webpackJsonp([0],{

/***/ "+B6R":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "+MX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inplace_vue__ = __webpack_require__("fhoe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2618bf06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inplace_vue__ = __webpack_require__("2ZSP");
function injectStyle (ssrContext) {
  __webpack_require__("j0E5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inplace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2618bf06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inplace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+STB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"terminal",staticClass:"ui-terminal ui-widget ui-widget-content ui-corner-all",class:_vm.terminalStyleClass,style:(_vm.terminalStyle),on:{"click":function($event){_vm.focus()}}},[(_vm.welcomeMessage)?_c('div',[_vm._v(_vm._s(_vm.welcomeMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui-terminal-content"},_vm._l((_vm.commands),function(command){return _c('div',[_c('span',[_vm._v(_vm._s(_vm.prompt))]),_vm._v(" "),_c('span',{staticClass:"ui-terminal-command"},[_vm._v(_vm._s(command.text))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(command.response))])])})),_vm._v(" "),_c('div',[_c('span',{staticClass:"ui-terminal-content-prompt"},[_vm._v(_vm._s(_vm.prompt))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.command),expression:"command"}],ref:"in",staticClass:"ui-terminal-input",attrs:{"type":"text","autocomplete":"off","autofocus":""},domProps:{"value":(_vm.command)},on:{"keydown":function($event){_vm.handleCommand($event)},"input":function($event){if($event.target.composing){ return; }_vm.command=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+bqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('div',{staticClass:"content-section introduction demo-component",attrs:{"id":"layout-topbar"}},[_c('a',{staticClass:"menu-button",attrs:{"href":"#","click":"onMenuButtonClick"}},[_c('i',{staticClass:"fa fa-bars"})]),_vm._v(" "),_c('a',{staticClass:"logo",attrs:{"href":"#"}},[_c('img',{attrs:{"alt":"logo","src":__webpack_require__("TMUp")}}),_c('span',{staticStyle:{"font-weight":"bold","font-size":"40px","color":"white"}},[_vm._v("VueFace")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+dhG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+hjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleria_vue__ = __webpack_require__("WH/I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301700eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleria_vue__ = __webpack_require__("iSi6");
function injectStyle (ssrContext) {
  __webpack_require__("niiN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301700eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+iml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobuttondemo_vue__ = __webpack_require__("rIO4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84bc23a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobuttondemo_vue__ = __webpack_require__("Rj17");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobuttondemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84bc23a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobuttondemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+w7j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/8aQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/E6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/EmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/heO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.severity)?_c('div',{staticClass:"ui-message ui-widget ui-corner-all",class:{'ui-messages-info': (_vm.severity === 'info'),
              'ui-messages-warn': (_vm.severity === 'warn'),
              'ui-messages-error': (_vm.severity === 'error'),
              'ui-messages-success': (_vm.severity === 'success')},attrs:{"aria-live":"polite"}},[_c('span',{staticClass:"ui-message-icon",class:_vm.getIcon()}),_vm._v(" "),_c('span',{staticClass:"ui-message-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "048l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-selectButton',
  props: {
    value: {},
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    optionStyleClass: String,
    tabindex: {
      type: [String, Number]
    },
    disabled: Boolean,
    multiple: Boolean
  },
  data: function data() {
    return {
      newValue: this.value,
      focusedItem: null
    };
  },

  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.$emit('input', value);
    }
  },
  methods: {
    onItemClick: function onItemClick(event, option, index) {
      if (this.disabled) {
        return;
      }
      this.$refs.cbox[index].focus();
      var checked = this.isChecked(option);
      if (this.multiple) {
        if (!checked) {
          this.newValue.push(option.value);
        } else {
          var i = this.newValue.indexOf(option.value);
          this.newValue.splice(i, 1);
        }
      } else {
        this.newValue = option.value;
      }
    },
    onFocus: function onFocus(event) {
      this.focusedItem = event.target;
      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      this.focusedItem = null;
      this.$emit('blur', event);
    },
    isChecked: function isChecked(option) {
      if (this.multiple) {
        return this.newValue.indexOf(option.value) >= 0;
      } else {
        return this.newValue === option.value;
      }
    }
  }
});

/***/ }),

/***/ "0TQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressspinner_vue__ = __webpack_require__("Nqm6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad87626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressspinner_vue__ = __webpack_require__("KmuM");
function injectStyle (ssrContext) {
  __webpack_require__("zAIs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressspinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad87626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressspinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0VG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progressspinnerdemo',
  data: function data() {
    return {
      value: 100
    };
  }
});

/***/ }),

/***/ "0wxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-spinner ui-widget ui-corner-all"},[_c('input',{ref:"inputfield",staticClass:"ui-spinner-input ui-inputtext ui-widget ui-state-default ui-corner-all",attrs:{"type":_vm.type,"id":_vm.inputId,"size":_vm.size,"maxlength":_vm.maxlength,"tabindex":_vm.tabindex,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required},domProps:{"value":_vm.valueAsString},on:{"keydown":function($event){_vm.onInputKeydown($event)},"keyup":function($event){_vm.onInputKeyup($event)},"keypress":function($event){_vm.onInputKeyPress($event)},"blur":function($event){_vm.onInputBlur($event)},"change":function($event){_vm.handleChange($event)},"focus":function($event){_vm.onInputFocus($event)}}}),_vm._v(" "),_c('button',{class:[
        'ui-spinner-button ui-spinner-up ui-corner-tr ui-button ui-widget ui-state-default',{
        'ui-state-disabled': _vm.disabled
      }],attrs:{"type":"button","disabled":_vm.disabled,"readonly":_vm.readonly},on:{"mouseleave":function($event){_vm.onUpButtonMouseleave($event)},"mousedown":function($event){_vm.onUpButtonMousedown($event)},"mouseup":function($event){_vm.onUpButtonMouseup($event)}}},[_c('span',{staticClass:"fa fa-caret-up ui-clickable"})]),_vm._v(" "),_c('button',{class:[
              'ui-spinner-button ui-spinner-down ui-corner-br ui-button ui-widget ui-state-default',{
              'ui-state-disabled': _vm.disabled
            }],attrs:{"type":"button","disabled":_vm.disabled,"readonly":_vm.readonly},on:{"mouseleave":function($event){_vm.onDownButtonMouseleave($event)},"mousedown":function($event){_vm.onDownButtonMousedown($event)},"mouseup":function($event){_vm.onDownButtonMouseup($event)}}},[_c('span',{staticClass:"fa fa-caret-down ui-clickable"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1QhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The ToggleButton is used to toggle between two states.")]),_vm._v(" "),_c('vf-toggleButton',{style:({'width':'150px'}),attrs:{"name":"basic"},model:{value:(_vm.checked1),callback:function ($$v) {_vm.checked1=$$v},expression:"checked1"}}),_vm._v(" "),_c('h3',[_vm._v("2. Customization")]),_vm._v(" "),_c('p',[_vm._v("The icons and labels of ToggleButton are customized using onLabel, offLabel, onIcon and offIcon attributes.")]),_vm._v(" "),_c('vf-toggleButton',{style:({'width':'150px'}),attrs:{"name":"custom","onLabel":"I confirm","offLabel":"I reject","onIcon":"fa-check-square","offIcon":"fa-square"},model:{value:(_vm.checked2),callback:function ($$v) {_vm.checked2=$$v},expression:"checked2"}}),_vm._v(" "),_c('h3',[_vm._v("3. Events")]),_vm._v(" "),_c('p',[_vm._v("The ToggleButton component supports change event")]),_vm._v(" "),_c('vf-toggleButton',{attrs:{"name":"events"},on:{"change":function($event){_vm.toggle($event)}},model:{value:(_vm.checked1),callback:function ($$v) {_vm.checked1=$$v},expression:"checked1"}}),_vm._v(" "),_c('h3',[_vm._v("4. Disabled")]),_vm._v(" "),_c('p',[_vm._v("The component disabled using disabled attribute")]),_vm._v(" "),_c('vf-toggleButton',{attrs:{"disabled":true,"name":"disabled","label":"Disabled"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("ToggleButton")]),_vm._v(" "),_c('span',[_vm._v("ToggleButton is used to select a boolean value using a button.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1pge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-footer"}},[_c('div',{staticClass:"content-section layout-footer"},[_c('span',[_vm._v("Released under the MIT License")]),_vm._v(" "),_c('div',{staticClass:"footer-links"},[_c('a',{attrs:{"href":"https://github.com/sudheerj/vueface"}},[_c('i',{staticClass:"fa fa-github"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://twitter.com/SudheerJonna"}},[_c('i',{staticClass:"fa fa-twitter"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "28x0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2F84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('vf-inplace',{attrs:{"closable":_vm.closable}},[_c('span',{attrs:{"slot":"display"},slot:"display"},[_vm._v("\n      Click to Edit\n  ")]),_vm._v(" "),_c('span',{attrs:{"slot":"content"},slot:"content"},[_c('vf-inputText',{attrs:{"type":"text"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)]),_vm._v(" "),_c('h3',[_vm._v("Image")]),_vm._v(" "),_c('vf-inplace',[_c('span',{attrs:{"slot":"display"},slot:"display"},[_c('span',{staticClass:"fa fa-picture-o"}),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v("View Picture")])]),_vm._v(" "),_c('span',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("VjVt"),"alt":"Nature"}})])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Inplace")]),_vm._v(" "),_c('span',[_vm._v("Inplace provides an easy to do editing and display at the same time where clicking the output displays the actual content.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2H7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var idx = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-accordionTab',
  data: function data() {
    return {
      animating: false,
      selected: false,
      id: 'ui-accordiontab-' + idx++
    };
  },
  props: {
    tabSelected: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    toggle: function toggle(event) {
      if (this.disabled || this.animating) {
        return false;
      }

      this.animating = true;
      var index = this.findTabIndex();

      if (this.selected) {
        this.selected = false;
        this.$parent.$emit('onClose', { originalEvent: event, index: index });
      } else {
        if (!this.$parent.multiple) {
          for (var i = 0; i < this.$parent.$children.length; i++) {
            this.$parent.$children[i].selected = false;
            this.$parent.$children[i].$emit('selectedChange', false);
          }
        }

        this.selected = true;
        this.$parent.$emit('onOpen', { originalEvent: event, index: index });
      }

      this.$emit('selectedChange', this.selected);

      event.preventDefault();
    },
    findTabIndex: function findTabIndex() {
      var index = -1;
      for (var i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i] === this) {
          index = i;
          break;
        }
      }
      return index;
    },
    getLazy: function getLazy() {
      return this.$parent.lazy;
    },
    hasHeaderFacet: function hasHeaderFacet() {
      return this.$slots.header;
    },
    onToggleDone: function onToggleDone(event) {
      this.animating = false;
    }
  },
  created: function created() {
    this.selected = this.tabSelected;
  },
  destroyed: function destroyed() {
    this.$parent.$children.splice(this.findTabIndex(), 1);
  }
});

/***/ }),

/***/ "2NlL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gmapdemo_vue__ = __webpack_require__("876m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f52fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gmapdemo_vue__ = __webpack_require__("oPQZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gmapdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f52fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gmapdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ZSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui-inplace', 'ui-widget', { inplaceStyleClass: true}],style:(_vm.inplaceStyle)},[(!_vm.isActive)?_c('div',{ref:"inplace",class:['ui-inplace-display', {'ui-state-disabled':_vm.disabled}],on:{"click":function($event){_vm.activate($event)}}},[_vm._t("display")],2):_vm._e(),_vm._v(" "),(_vm.isActive)?_c('div',{staticClass:"ui-inplace-content"},[_vm._t("content"),_vm._v(" "),(_vm.closable)?_c('p-button',{attrs:{"type":"button","icon":"fa-close"},on:{"click":function($event){_vm.deactivate($event)}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2d2C":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iMzVweCIgaGVpZ2h0PSIzNXB4IiB2aWV3Qm94PSIwIDAgMzUgMzUiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxyZWN0IHk9IjEwLjY5NSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjI0LjMwNSIgZmlsbD0iIzFCODJENyIvPgoJCTxyZWN0IHdpZHRoPSIzNSIgaGVpZ2h0PSI3Ljc3OCIgZmlsbD0iIzFCODJENyIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "2swz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rating_vue__ = __webpack_require__("a0Y4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55dcaf52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_vue__ = __webpack_require__("VDZt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rating_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55dcaf52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ujE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iTUVTU0FHRSI+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNMzYuNTA2LDU2Ljc0OGMwLDMuNjA3LDIuOTI0LDYuNTMzLDYuNTMyLDYuNTMzaDIzLjc2NEw3Ni45NDksNzUuNDlsMS4wMjUtMTIuMjA5CgkJYzMuNjA3LDAsNi41MzItMi45MjYsNi41MzItNi41MzNsMi43OTktMjMuMDJjMC0zLjYwNy0yLjkyNC02LjUzMi02LjUzMi02LjUzMkgzOS4zMDRjLTMuNjA3LDAtNi41MzIsMi45MjUtNi41MzIsNi41MzIKCQlMMzYuNTA2LDU2Ljc0OHoiLz4KCTxwYXRoIGZpbGw9IiMxQjgyRDciIGQ9Ik0zMy40OTIsNTcuMDEzbC0wLjY2LTQuMTFoLTUuMDExTDE3LjczOCw2NS4wMzRsLTEuMDE3LTEyLjEzMUgxNC41Yy0zLjMyNywwLTYuMDM3LTIuNzA4LTYuMDM3LTYuMDM3CgkJbC0zLjYyLTI5LjkxNWMwLjA3MS0zLjI2OCwyLjc1Mi01LjkwMiw2LjAzNC01LjkwMmg1My42NDhjMy4yNzEsMCw1Ljk0LDIuNjExLDYuMDM0LDUuODU4bC0xLjE3OSw3LjI3MWg0Ljg5M2wxLjA4OC02LjcwNwoJCWwwLjAzLTAuMzg3YzAtNS45OTEtNC44NzQtMTAuODY1LTEwLjg2Ni0xMC44NjVIMTAuODc4Yy01Ljk5MiwwLTEwLjg2Niw0Ljg3NC0xMC44NjYsMTAuODY1bDMuNjI1LDI5LjkzOAoJCWMwLjA3MSw1LjE1NCwzLjc1MSw5LjQ1Myw4LjYyMywxMC40NzhsMS42NTEsMTkuNjkybDE2LjE3Ni0xOS40NmgzLjQ1OUMzMy41MjMsNTcuNDk0LDMzLjQ5Nyw1Ny4yNTUsMzMuNDkyLDU3LjAxM3oiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "3F1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcodedemo_vue__ = __webpack_require__("D2tY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031788bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcodedemo_vue__ = __webpack_require__("MkLg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcodedemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031788bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcodedemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Hh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3e6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorpicker_vue__ = __webpack_require__("qrrn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19eba26c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorpicker_vue__ = __webpack_require__("uLqU");
function injectStyle (ssrContext) {
  __webpack_require__("eMof")
  __webpack_require__("tPdU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorpicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19eba26c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorpicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3xuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-tristatecheckbox',
  data: function data() {
    return {
      focus: false
    };
  },
  model: {
    prop: 'value',
    event: 'onChange'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    binary: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },
    checkboxStyle: {
      type: String,
      default: null
    },
    checkboxStyleClass: {
      type: String,
      default: null
    },
    value: {
      default: undefined
    },
    name: {
      type: String
    }

  },
  methods: {
    onClick: function onClick(event) {
      if (!this.disabled) {
        this.toggle(event);
        this.focus = true;
        this.$refs.input.focus();
      }
    },
    onKeydown: function onKeydown(event) {
      if (event.keyCode === 32) {
        event.preventDefault();
      }
    },
    onKeyup: function onKeyup(event) {
      if (event.keyCode === 32) {
        this.toggle(event);
        event.preventDefault();
      }
    },
    toggle: function toggle(event) {
      if (this.value === null || this.value === undefined) {
        this.value = true;
      } else if (this.value === true) {
        this.value = false;
      } else if (this.value === false) {
        this.value = null;
      }
      this.$emit('onChange', this.value);
    },
    onFocus: function onFocus() {
      this.focus = true;
    },
    onBlur: function onBlur() {
      this.focus = false;
    }
  }
});

/***/ }),

/***/ "4CxQ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iREFUQSI+Cgk8ZWxsaXBzZSBmaWxsPSIjODg5NTk3IiBjeD0iNDMuNjU5IiBjeT0iMjIuMTUiIHJ4PSI0My42MTYiIHJ5PSIxNi4zIi8+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMC4wNDMsMjkuMjVjMCwwLDYuNTQ4LDE0LjE5NSw0My42MTYsMTQuMTk1YzM3LjA2NywwLDQzLjYxNi0xNC4xOTUsNDMuNjE2LTE0LjE5NXY4LjIxOAoJCWMwLDAtNy45NjksMTQuMTk1LTQzLjYxNiwxNC4xOTVjLTM1LjY0NiwwLTQzLjYxNi0xMy45NDYtNDMuNjE2LTEzLjk0NlYyOS4yNXoiLz4KCTxwYXRoIGZpbGw9IiM4ODk1OTciIGQ9Ik0wLjA0Myw0Mi4xOTljMCwwLDYuNTQ4LDE0LjE5NSw0My42MTYsMTQuMTk1YzM3LjA2NywwLDQzLjYxNi0xNC4xOTUsNDMuNjE2LTE0LjE5NXY4LjIxOQoJCWMwLDAtNy45NjksMTQuMTkzLTQzLjYxNiwxNC4xOTNjLTM1LjY0NiwwLTQzLjYxNi0xMy45NDUtNDMuNjE2LTEzLjk0NVY0Mi4xOTl6Ii8+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMC4wNDMsNTUuMTQ5YzAsMCw2LjU0OCwxNC4xOTMsNDMuNjE2LDE0LjE5M2MzNy4wNjcsMCw0My42MTYtMTQuMTkzLDQzLjYxNi0xNC4xOTN2OC4yMTkKCQljMCwwLTcuOTY5LDE0LjE5My00My42MTYsMTQuMTkzYy0zNS42NDYsMC00My42MTYtMTMuOTQ1LTQzLjYxNi0xMy45NDVWNTUuMTQ5eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "4MN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'captchademo',
  data: function data() {
    return {
      verified: false,
      expired: false
    };
  },

  methods: {
    showResponse: function showResponse(event) {
      this.verification = true;
    },
    onExpire: function onExpire(event) {
      this.expired = true;
    }
  }
});

/***/ }),

/***/ "4cFB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/galleria3.79e3b59.jpg";

/***/ }),

/***/ "4cfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terminaldemo',
  data: function data() {
    return {
      response: null
    };
  },

  methods: {
    onCommand: function onCommand(event) {
      //event.command = entered command
      //in a real application connect to remote service to process the command and update the response field in return
      this.response = event.command === 'date' ? new Date().toDateString() : 'Unknown command: ' + event.command;
    }
  }
});

/***/ }),

/***/ "4pq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paneldemo_vue__ = __webpack_require__("p2b8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b0a942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paneldemo_vue__ = __webpack_require__("gGBX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paneldemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b0a942_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paneldemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4w4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var radarData = {
  labels: ['Requirement', 'Design', 'Implementation', 'Testing', 'Deployment', 'Maintainance'],
  datasets: [{
    label: 'VueJS',
    backgroundColor: 'rgba(162,141,158,0.4)',
    borderColor: 'rgba(145,171,188,1)',
    pointBackgroundColor: 'rgba(145,171,188,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(145,171,188,1)',
    data: [76, 55, 66, 78, 93, 74]
  }, {
    label: 'Angular',
    backgroundColor: 'rgba(255,99,132,0.2)',
    borderColor: 'rgba(255,99,132,1)',
    pointBackgroundColor: 'rgba(255,99,132,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(255,99,132,1)',
    data: [30, 43, 38, 17, 89, 33]
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radarchartdemo',
  data: function data() {
    return {
      radarData: radarData
    };
  }
});

/***/ }),

/***/ "5Aoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as bubble(type=\"bubble\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"bubble","data":_vm.bubbleData,"width":"100","height":"20"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("BubbleChart")]),_vm._v(" "),_c('span',[_vm._v("A bubble chart is used to display three dimensions of data at the same time. The location of the bubble is determined by the first two dimensions and the corresponding horizontal and vertical axes. The third dimension is represented by the size of the individual bubbles.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5d8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('vf-sidebar',{attrs:{"visible":_vm.visibleSidebar1,"baseZIndex":"10000"}},[_c('h1',{staticStyle:{"font-weight":"normal"}},[_vm._v("Left Sidebar")]),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Save"},on:{"click":function($event){_vm.visibleSidebar1 = false}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Cancel"},on:{"click":function($event){_vm.visibleSidebar1 = false}}})],1),_vm._v(" "),_c('vf-sidebar',{attrs:{"visible":_vm.visibleSidebar2,"position":"right","baseZIndex":"10000"}},[_c('h1',{staticStyle:{"font-weight":"normal"}},[_vm._v("Right Sidebar")]),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Save"},on:{"click":function($event){_vm.visibleSidebar2 = false}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Cancel"},on:{"click":function($event){_vm.visibleSidebar2 = false}}})],1),_vm._v(" "),_c('vf-sidebar',{attrs:{"visible":_vm.visibleSidebar3,"position":"top","baseZIndex":"10000"}},[_c('h1',{staticStyle:{"font-weight":"normal"}},[_vm._v("Top Sidebar")]),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Save"},on:{"click":function($event){_vm.visibleSidebar3 = false}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Cancel"},on:{"click":function($event){_vm.visibleSidebar3 = false}}})],1),_vm._v(" "),_c('vf-sidebar',{attrs:{"visible":_vm.visibleSidebar4,"position":"bottom","baseZIndex":"10000"}},[_c('h1',{staticStyle:{"font-weight":"normal"}},[_vm._v("Bottom Sidebar")]),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Save"},on:{"click":function($event){_vm.visibleSidebar4 = false}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Cancel"},on:{"click":function($event){_vm.visibleSidebar4 = false}}})],1),_vm._v(" "),_c('vf-sidebar',{attrs:{"visible":_vm.visibleSidebar5,"fullScreen":true,"baseZIndex":"10000"}},[_c('h1',{staticStyle:{"font-weight":"normal"}},[_vm._v("Full Screen Sidebar")]),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Save"},on:{"click":function($event){_vm.visibleSidebar5 = false}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Cancel"},on:{"click":function($event){_vm.visibleSidebar5 = false}}})],1),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-arrow-right"},on:{"click":function($event){_vm.visibleSidebar1 = true}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-arrow-left"},on:{"click":function($event){_vm.visibleSidebar2 = true}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-arrow-down"},on:{"click":function($event){_vm.visibleSidebar3 = true}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-arrow-up"},on:{"click":function($event){_vm.visibleSidebar4 = true}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-arrows-alt"},on:{"click":function($event){_vm.visibleSidebar5 = true}}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("SideBar")]),_vm._v(" "),_c('span',[_vm._v("Sidebar is a panel component displayed as an overlay..")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5zFn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var barData = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  datasets: [{
    label: 'VueJS downloads',
    backgroundColor: '#F2A5F5',
    borderColor: '#1988E5',
    data: [65, 88, 80, 81, 56, 95, 60, 65, 88, 80, 81, 56, 95, 60]
  }, {
    label: 'Angular downloads',
    backgroundColor: '#DCCC65',
    borderColor: '#799342',
    data: [77, 66, 50, 69, 86, 97, 90, 77, 66, 50, 69, 86, 97, 90]
  }]
};
var horizontalBarData = barData;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'horizontalbarchartdemo',
  data: function data() {
    return {
      horizontalBarData: horizontalBarData
    };
  }
});

/***/ }),

/***/ "64uC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__ = __webpack_require__("Jzan");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-blockUI',
  data: function data() {
    return {
      _blocked: false,
      targetElement: null
    };
  },
  props: {
    autoZIndex: {
      type: Boolean,
      default: true
    },
    target: {
      type: String,
      default: null
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    blocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    block: function block() {
      if (this.targetElement) {
        this.targetElement.appendChild(this.$refs.mask);
        this.targetElement.style.position = 'relative';
      } else {
        document.body.appendChild(this.$refs.mask);
      }

      if (this.autoZIndex) {
        this.$refs.mask.style.zIndex = String(this.baseZIndex + ++__WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].zindex);
      }
    },
    unblock: function unblock() {
      if (this.targetElement) {
        this.targetElement.removeChild(this.$refs.mask);
      } else {
        document.body.removeChild(this.$refs.mask);
      }
    }
  },
  destroyed: function destroyed() {
    this.unblock();
  },
  mounted: function mounted() {
    this.targetElement = document.getElementById(this.target);
  },
  watch: {
    blocked: function blocked(val) {
      this._blocked = val;

      if (this.$refs.mask) {
        if (this._blocked) {
          this.block();
        } else {
          this.unblock();
        }
      }
    }
  }
});

/***/ }),

/***/ "6JSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("JMCt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c9406c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("+bqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c9406c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6WBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'active': _vm.menuActive},attrs:{"id":"layout-sidebar"}},[_c('div',{staticClass:"layout-menu"},[_c('a',{ref:"inputmenutitle",class:{'active-menuitem':(_vm.element.inputmenutitle) == _vm.activeMenuId},attrs:{"id":"menu_input"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.inputmenutitle ? null : _vm.element.inputmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("GTbf")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("ilI2")}}),_vm._v(" "),_c('span',[_vm._v("Input")])]),_vm._v(" "),_c('div',{class:{submenushow: (_vm.element.inputmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.inputmenutitle != _vm.activeMenuId)}},[_c('span',{on:{"click":function($event){_vm.menuActive = false}}},[_c('router-link',{attrs:{"to":"/components/inputtext"}},[_vm._v("● InputText")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/inputtextarea"}},[_vm._v("● InputTextarea")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/password"}},[_vm._v("● Password")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/inputgroup"}},[_vm._v("● InputGroup")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/checkbox"}},[_vm._v("● Checkbox")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/tristatecheckbox"}},[_vm._v("● TriStateCheckbox")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/togglebutton"}},[_vm._v("● ToggleButton")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/radiobutton"}},[_vm._v("● RadioButton")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/editor"}},[_vm._v("● Editor")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/inplace"}},[_vm._v("● Inplace")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/selectbutton"}},[_vm._v("● SelectButton")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/rating"}},[_vm._v("● Rating")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/inputswitch"}},[_vm._v("● InputSwitch")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/spinner"}},[_vm._v("● Spinner")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/colorpicker"}},[_vm._v("● ColorPicker")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/minusplus"}},[_vm._v("● MinusPlus")])],1),_vm._v(" "),_c('a',{ref:"buttonmenutitle",class:{'active-menuitem': _vm.element.buttonmenutitle == _vm.activeMenuId},attrs:{"id":"button_menutitle"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.buttonmenutitle ? null : _vm.element.buttonmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("dNsU")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("7eJG")}}),_vm._v(" "),_c('span',[_vm._v("Button")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.buttonmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.buttonmenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/button"}},[_vm._v("● Button")])],1),_vm._v(" "),_c('a',{ref:"datamenutitle",class:{'active-menuitem': _vm.element.datamenutitle == _vm.activeMenuId},attrs:{"id":"data_menutitle"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.datamenutitle ? null : _vm.element.datamenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("iPUH")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("4CxQ")}}),_vm._v(" "),_c('span',[_vm._v("Data")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.datamenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.datamenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/gmap"}},[_vm._v("● Gmap")])],1),_vm._v(" "),_c('a',{ref:"panelmenutitle",class:{'active-menuitem': _vm.element.panelmenutitle == _vm.activeMenuId},attrs:{"id":"menu_panel"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.panelmenutitle ? null : _vm.element.panelmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("kFRB")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("UfxB")}}),_vm._v(" "),_c('span',[_vm._v("Panel")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.panelmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.panelmenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/panel"}},[_vm._v("● Panel")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/accordion"}},[_vm._v("● Accordion")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/fieldset"}},[_vm._v("● Fieldset")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/grid"}},[_vm._v("● Grid")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/toolbar"}},[_vm._v("● Toolbar")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/scrollpanel"}},[_vm._v("● ScrollPanel")])],1),_vm._v(" "),_c('a',{ref:"overlaymenutitle",class:{'active-menuitem': _vm.element.overlaymenutitle == _vm.activeMenuId},attrs:{"id":"menu_overlay"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.overlaymenutitle ? null : _vm.element.overlaymenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("PDYU")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("9RgO")}}),_vm._v(" "),_c('span',[_vm._v("Overlay")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.overlaymenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.overlaymenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/sidebar"}},[_vm._v("● Sidebar")])],1),_vm._v(" "),_c('a',{ref:"layoutmenutitle",class:{'active-menuitem': _vm.element.layoutmenutitle == _vm.activeMenuId},attrs:{"id":"menu_overlay"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.layoutmenutitle ? null : _vm.element.layoutmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("2d2C")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("P+Kh")}}),_vm._v(" "),_c('span',[_vm._v("Layout")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.layoutmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.layoutmenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/card"}},[_vm._v("● Card")])],1),_vm._v(" "),_c('a',{ref:"chartmenutitle",class:{'active-menuitem': _vm.element.chartmenutitle == _vm.activeMenuId},attrs:{"id":"menu_chart"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.chartmenutitle ? null : _vm.element.chartmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("ZbbW")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("LCrn")}}),_vm._v(" "),_c('span',[_vm._v("Charts")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.chartmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.chartmenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/charts/piechart"}},[_vm._v("● PieChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/barchart"}},[_vm._v("● BarChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/horizontalbarchart"}},[_vm._v("● HorizontalBar")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/linechart"}},[_vm._v("● LineChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/polarareachart"}},[_vm._v("● PolarareaChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/doughnutchart"}},[_vm._v("● DoughnutChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/radarchart"}},[_vm._v("● RadarChart")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/charts/bubblechart"}},[_vm._v("● BubbleChart")])],1),_vm._v(" "),_c('a',{ref:"messagesmenutitle",class:{'active-menuitem': _vm.element.messagesmenutitle == _vm.activeMenuId},attrs:{"id":"menu_messages"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.messagesmenutitle ? null : _vm.element.messagesmenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("2ujE")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("oUF0")}}),_vm._v(" "),_c('span',[_vm._v("Messages")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.messagesmenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.messagesmenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/message"}},[_vm._v("● Message")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/growl"}},[_vm._v("● Growl")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/badge"}},[_vm._v("● Badge")])],1),_vm._v(" "),_c('a',{ref:"multimediamenutitle",class:{'active-menuitem':_vm.element.multimediamenutitle == _vm.activeMenuId},attrs:{"id":"menu_multimedia"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.multimediamenutitle ? null : _vm.element.multimediamenutitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("Npf0")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("qZ9c")}}),_vm._v(" "),_c('span',[_vm._v("Multimedia")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.multimediamenutitle == _vm.activeMenuId), 'submenuhide': (_vm.element.multimediamenutitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/galleria"}},[_vm._v("● Galleria")])],1),_vm._v(" "),_c('a',{ref:"misctitle",class:{'active-menuitem':_vm.element.misctitle == _vm.activeMenuId},attrs:{"id":"menu_misc"},on:{"click":function($event){_vm.activeMenuId = (_vm.activeMenuId === _vm.element.misctitle ? null : _vm.element.misctitle)}}},[_c('img',{staticClass:"layout-menu-icon-active",attrs:{"src":__webpack_require__("+B6R")}}),_vm._v(" "),_c('img',{staticClass:"layout-menu-icon-inactive",attrs:{"src":__webpack_require__("JzTs")}}),_vm._v(" "),_c('span',[_vm._v("Misc")])]),_vm._v(" "),_c('div',{class:{'submenushow': (_vm.element.misctitle == _vm.activeMenuId), 'submenuhide': (_vm.element.misctitle != _vm.activeMenuId)}},[_c('router-link',{attrs:{"to":"/components/captcha"}},[_vm._v("● Captcha")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/progressspinner"}},[_vm._v("● ProgressSpinner")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/progressbar"}},[_vm._v("● ProgressBar")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/terminal"}},[_vm._v("● Terminal")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/blockui"}},[_vm._v("● BlockUI")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/backtotop"}},[_vm._v("● BackToTop")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/codehighlighter"}},[_vm._v("● CodeHighlighter")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/qrcode"}},[_vm._v("● QRCode")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/components/avatar"}},[_vm._v("● Avatar")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Jgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatardemo_vue__ = __webpack_require__("ITyC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cf196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatardemo_vue__ = __webpack_require__("kFam");
function injectStyle (ssrContext) {
  __webpack_require__("WP3Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatardemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cf196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatardemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7SDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputgroupdemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "7TSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as lineData(type=\"lineData\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"line","data":_vm.lineData,"width":"100","height":"20"}},[_vm._v(">")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("LineChart")]),_vm._v(" "),_c('span',[_vm._v("A line chart or line graph is a type of chart which displays information as a series of data points called 'markers' connected by straight line segments.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7eJG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "7hwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"panel",staticClass:"ui-panel ui-widget ui-widget-content ui-corner-all",class:_vm.panelStyleClass,style:(_vm.panelStyle),attrs:{"id":_vm.id}},[(_vm.showHeader)?_c('div',{staticClass:"ui-panel-titlebar ui-widget-header ui-helper-clearfix ui-corner-all"},[(_vm.header)?_c('span',{staticClass:"ui-panel-title"},[_vm._v(_vm._s(_vm.header))]):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),(_vm.toggleable)?_c('a',{staticClass:"ui-panel-titlebar-icon ui-panel-titlebar-toggler ui-corner-all ui-state-default",attrs:{"id":_vm.id + '-label',"href":"#","aria-controls":_vm.id + '-content',"role":"tab","aria-expanded":!_vm.collapsedStatus},on:{"click":function($event){_vm.toggle($event)}}},[_c('span',{class:_vm.collapsedStatus ? 'fa fa-fw ' + _vm.expandIcon : 'fa fa-fw ' + _vm.collapseIcon})]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"},on:{"enter":function($event){_vm.onToggleDone($event)},"leave":function($event){_vm.onToggleDone($event)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedStatus),expression:"!collapsedStatus"}],staticClass:"ui-panel-content-wrapper",class:{'ui-panel-content-wrapper-overflown': _vm.collapsedStatus||_vm.animating},attrs:{"id":_vm.id + '-content',"role":"region","aria-hidden":_vm.collapsedStatus,"aria-labelledby":_vm.id + '-label'}},[_c('div',{staticClass:"ui-panel-content ui-widget-content"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasFooter())?_c('div',{staticClass:"ui-panel-footer ui-widget-content"},[_vm._t("footer")],2):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7k/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],class:[
        'ui-inputtext', 'ui-corner-all', 'ui-state-default', 'ui-widget', {
        'ui-state-filled': _vm.filled
       }],domProps:{"value":(_vm.newValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8/e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:['ui-scrollpanel ui-widget ui-widget-content ui-corner-all', _vm.scrollpanelStyleClass],style:(_vm.scrollpanelStyle)},[_c('div',{staticClass:"ui-scrollpanel-wrapper"},[_c('div',{ref:"content",staticClass:"ui-scrollpanel-content"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{ref:"bar",staticClass:"ui-scrollpanel-bar"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "876m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var google = window.google;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gmapdemo',
  data: function data() {
    return {
      options: null,
      overlays: [],
      dialogVisible: false,
      markerTitle: null,
      selectedPosition: null,
      infoWindow: null,
      draggable: false,
      msgs: []
    };
  },

  methods: {
    handleMapClick: function handleMapClick(event) {
      this.dialogVisible = true;
      this.selectedPosition = event.latLng;
      alert(event.latLng);
    },
    handleOverlayClick: function handleOverlayClick(event) {
      // this.msgs = [];
      var isMarker = typeof event.overlay.getTitle !== 'undefined';
      if (isMarker) {
        var title = event.overlay.getTitle();
        this.infoWindow.setContent('' + title + '');
        this.infoWindow.open(event.map, event.overlay);
        event.map.setCenter(event.overlay.getPosition());
        // this.msgs.push({severity:'info', summary:'Marker Selected', detail: title});
      } else {
          // this.msgs.push({severity:'info', summary:'Shape Selected', detail: ''});
        }
    },
    addMarker: function addMarker() {
      this.overlays.push(new google.maps.Marker({
        position: {
          lat: this.selectedPosition.lat(),
          lng: this.selectedPosition.lng()
        },
        title: this.markerTitle,
        draggable: this.draggable
      }));
      this.markerTitle = null;
      this.dialogVisible = false;
    },
    handleDragEnd: function handleDragEnd(event) {
      var title = event.overlay.getTitle();
      alert('Dragged: ' + title);
      // this.msgs = [];
      // this.msgs.push({severity:'info', summary:'Marker Dragged', detail: event.overlay.getTitle()});
    },
    initOverlays: function initOverlays() {
      if (!this.overlays || !this.overlays.length) {
        this.overlays = [new google.maps.Marker({ position: { lat: 14.6188043, lng: 79.9630253 }, title: 'Talamanchi', draggable: true }), new google.maps.Marker({ position: { lat: 14.4290442, lng: 79.9456852 }, title: 'Nellore', draggable: true }), new google.maps.Polygon({ paths: [{ lat: 14.1413809, lng: 79.8254154 }, { lat: 11.1513809, lng: 78.8354154 }, { lat: 15.1313809, lng: 78.8254154 }, { lat: 15.1613809, lng: 79.8854154 }], strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
        }), new google.maps.Circle({ center: { lat: 14.1413809, lng: 79.9513809 },
          fillColor: '#197642', fillOpacity: 0.25, strokeWeight: 1, radius: 25000 }), new google.maps.Polyline({ path: [{ lat: 14.1413809, lng: 79.9254154 }, { lat: 14.6413809, lng: 79.9254154 }], geodesic: true, strokeColor: '#F0F000', strokeOpacity: 0.5, strokeWeight: 2 })];
      }
    },
    zoomIn: function zoomIn(map) {
      map.setZoom(map.getZoom() + 1);
    },
    zoomOut: function zoomOut(map) {
      map.setZoom(map.getZoom() - 1);
    },
    clear: function clear() {
      this.overlays = [];
    }
  },
  mounted: function mounted() {
    this.options = {
      center: {
        lat: 14.4426, lng: 79.9865
      },
      zoom: 8
    };
    this.initOverlays();
    this.infoWindow = new google.maps.InfoWindow();
  }
});

/***/ }),

/***/ "8AO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'indexdemo'
});

/***/ }),

/***/ "8aOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_growl_vue__ = __webpack_require__("a/PC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9c6c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_growl_vue__ = __webpack_require__("afjU");
function injectStyle (ssrContext) {
  __webpack_require__("/E6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_growl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9c6c90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_growl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8vfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkboxdemo',
  data: function data() {
    return {
      checked: true,
      selectedFrameworks: ['VueJS', 'React']
    };
  }
});

/***/ }),

/***/ "8wri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

var _instance = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-captcha',
  data: function data() {
    return {
      _instance: _instance
    };
  },
  props: {
    siteKey: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'light'
    },
    type: {
      type: String,
      default: 'image'
    },
    size: {
      type: String,
      default: 'normal'
    },
    tabindex: {
      type: Number,
      default: 0
    },
    language: {
      type: String,
      default: null
    },
    initCallback: {
      type: String,
      default: 'initRecaptcha'
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      this._instance = window.grecaptcha.render(this.$refs.captcha, {
        'sitekey': this.siteKey,
        'theme': this.theme,
        'type': this.type,
        'size': this.size,
        'tabindex': this.tabindex,
        'hl': this.language,
        'callback': function callback(response) {
          _this._zone.run(function () {
            return _this.recaptchaCallback(response);
          });
        },
        'expired-callback': function expiredCallback() {
          _this._zone.run(function () {
            return _this.recaptchaExpiredCallback();
          });
        }
      });
    },
    reset: function reset() {
      if (this._instance === null) {
        return;
      }

      window.grecaptcha.reset(this._instance);
    },
    getResponse: function getResponse() {
      if (this._instance === null) {
        return null;
      }

      return window.grecaptcha.getResponse(this._instance);
    },
    recaptchaCallback: function recaptchaCallback(response) {
      this.$emit('response', {
        response: response
      });
    },
    recaptchaExpiredCallback: function recaptchaExpiredCallback() {
      this.$emit('expire');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (window.grecaptcha) {
      this.init();
    } else {
      window[this.initCallback] = function () {
        _this2.init();
      };
    }
  },
  computed: {}
});

/***/ }),

/***/ "8yGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Single")]),_vm._v(" "),_c('vf-selectButton',{attrs:{"options":_vm.types},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}}),_vm._v(" "),_c('p',[_vm._v("Selected Type: "+_vm._s(_vm.selectedType))]),_vm._v(" "),_c('h3',[_vm._v("Multiple")]),_vm._v(" "),_c('vf-selectButton',{attrs:{"options":_vm.types,"multiple":true},model:{value:(_vm.selectedTypes),callback:function ($$v) {_vm.selectedTypes=$$v},expression:"selectedTypes"}}),_vm._v(" "),_c('p',[_vm._v("Selected Types: "),_c('span',[_vm._v(_vm._s(_vm.selectedTypes)+" ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-close","label":"Clear"},on:{"click":_vm.clear}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("SelectButton")]),_vm._v(" "),_c('span',[_vm._v("SelectButton is used to choose single or multiple items from a list using buttons.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8zkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_prismjs_prism_js__ = __webpack_require__("OEdS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_prismjs_prism_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_prismjs_prism_js__);



function inserted(el) {
  __WEBPACK_IMPORTED_MODULE_0__node_modules_prismjs_prism_js___default.a.highlightElement(el);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'code',
  inserted: inserted
});

/***/ }),

/***/ "9BOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fieldsetdemo_vue__ = __webpack_require__("eT9B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc40aaf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fieldsetdemo_vue__ = __webpack_require__("dHM0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fieldsetdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc40aaf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fieldsetdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9MA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-selectbutton ui-buttonset ui-widget ui-corner-all",class:'ui-buttonset-' + _vm.options.length},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"ui-button ui-widget ui-state-default ui-button-text-only",class:[_vm.optionStyleClass, {
        'ui-state-active': _vm.isChecked(option),
        'ui-state-disabled': _vm.disabled,
        'ui-state-focus': _vm.$refs.cbox && _vm.$refs.cbox[index] == _vm.focusedItem
       }],on:{"click":function($event){_vm.onItemClick($event, option, index)}}},[_c('span',{staticClass:"ui-button-text ui-clickable"},[_vm._v(_vm._s(option.label))]),_vm._v(" "),_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',{ref:"cbox",refInFor:true,attrs:{"type":"checkbox","tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":option.value},on:{"focus":function($event){_vm.onFocus($event)},"blur":function($event){_vm.onBlur($event)}}})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9RgO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iT1ZFUkxBWSI+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNODIuOTg5LDEwLjA4M0g0LjMyOGMtMi4zMzgsMC00LjIzNSwxLjg5Ny00LjIzNSw0LjIzNXYxMi4yNDhoODcuMTMyVjE0LjMxOQoJCUM4Ny4yMjUsMTEuOTgxLDg1LjMyOSwxMC4wODMsODIuOTg5LDEwLjA4M3ogTTgxLjY4OCwyMS4wOTVjMC41MTYsMC41MTYsMC41MTYsMS4zNDksMCwxLjg2MmMtMC41MTIsMC41MTUtMS4zNDgsMC41MTYtMS44NjEsMAoJCWwtMi43Ny0yLjc2OWwtMi43NywyLjc2OWMtMC41MTYsMC41MTYtMS4zNSwwLjUxNS0xLjg2MywwYy0wLjUxNC0wLjUxNC0wLjUxNC0xLjM0NywwLTEuODYybDIuNzctMi43NjlsLTIuNzcxLTIuNzcxCgkJYy0wLjUxMi0wLjUxNi0wLjUxMi0xLjM0OSwwLTEuODYyYzAuNTE2LTAuNTE1LDEuMzUtMC41MTYsMS44NjMsMGwyLjc3MSwyLjc3MWwyLjc3LTIuNzcxYzAuNTE0LTAuNTE2LDEuMzUtMC41MTUsMS44NjEsMAoJCWMwLjUxNiwwLjUxNCwwLjUxNiwxLjM0NywwLDEuODYybC0yLjc3LDIuNzcxTDgxLjY4OCwyMS4wOTV6Ii8+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMC4wOTMsMzAuMDUydjM5LjA0YzAsMi4zMzgsMS44OTcsNC4yMzUsNC4yMzUsNC4yMzVoNzguNjYxYzIuMzQsMCw0LjIzNi0xLjg5Nyw0LjIzNi00LjIzNXYtMzkuMDRIMC4wOTN6CgkJIE04MC4yOSw2NS43NTdINy4wM1YzNy42Mmg3My4yNlY2NS43NTd6Ii8+Cgk8cmVjdCB4PSIxMS4wNTIiIHk9IjQxLjg4MiIgZmlsbD0iIzg4OTU5NyIgd2lkdGg9IjY1LjY1MiIgaGVpZ2h0PSI1LjM5NSIvPgoJPHJlY3QgeD0iMTEuMDUyIiB5PSI1MC44OTgiIGZpbGw9IiM4ODk1OTciIHdpZHRoPSI0Ni4yMTEiIGhlaWdodD0iNS4zOTYiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "APAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubblechartdemo_vue__ = __webpack_require__("kdJE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb6e830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubblechartdemo_vue__ = __webpack_require__("5Aoz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubblechartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb6e830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubblechartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AR/5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var barData = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  datasets: [{
    label: 'VueJS downloads',
    backgroundColor: '#F2A5F5',
    borderColor: '#1988E5',
    data: [65, 88, 80, 81, 56, 95, 60, 65, 88, 80, 81, 56, 95, 60]
  }, {
    label: 'Angular downloads',
    backgroundColor: '#DCCC65',
    borderColor: '#799342',
    data: [77, 66, 50, 69, 86, 97, 90, 77, 66, 50, 69, 86, 97, 90]
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'barchartdemo',
  data: function data() {
    return {
      barData: barData
    };
  }
});

/***/ }),

/***/ "AZ2a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B1eA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badge_vue__ = __webpack_require__("nEZQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88f8b5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badge_vue__ = __webpack_require__("OCJF");
function injectStyle (ssrContext) {
  __webpack_require__("7SDM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88f8b5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BezM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The accordion displays stacked group of information in the form of tabs.")]),_vm._v(" "),_c('vf-accordion',[_c('vf-accordionTab',{attrs:{"header":"Godfather I","selected":true}},[_vm._v("\n          The story begins as Don Vito Corleone, the head of a New York Mafia family, overseeshis daughter's wedding. His beloved son ichael has just come home from the war, but does not intend to become part of his father's business. T hrough Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather II"}},[_vm._v("\n          Francis Ford Coppola's legendary continuation and sequel to his landmark 1972 film, The_Godfather parallels the young Vito Corleone's rise with his son Michael's spiritual fall, deepening The_Godfather's depiction of the dark side of the American dream. In the early 1900s, the child Vito flees his Sicilian village for America after the local Mafia kills his family. Vito struggles to make a living, legally or illegally, for his wife and growing brood in Little Italy, killing the local Black Hand Fanucci after he demands his customary cut of the tyro's business. With Fanucci gone, Vito's communal stature grows.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather III"}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")])],1),_vm._v(" "),_c('h3',[_vm._v("2. Multiple")]),_vm._v(" "),_c('p',[_vm._v("Enabled multiple tabs selected at the same time using multiple attribute.")]),_vm._v(" "),_c('vf-accordion',{attrs:{"multiple":true}},[_c('vf-accordionTab',{attrs:{"header":"Godfather I"}},[_vm._v("\n          The story begins  as Don Vito Corleone, the head of a New York Mafia family, overseeshis daughter's wedding. His beloved son ichael has just come home from the war, but does not intend to become part of his father's business. T hrough Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather II"}},[_vm._v("\n          Francis Ford Coppola's legendary continuation and sequel to his landmark 1972 film, The_Godfather parallels the young Vito Corleone's rise with his son Michael's spiritual fall, deepening The_Godfather's depiction of the dark side of the American dream. In the early 1900s, the child Vito flees his Sicilian village for America after the local Mafia kills his family. Vito struggles to make a living, legally or illegally, for his wife and growing brood in Little Italy, killing the local Black Hand Fanucci after he demands his customary cut of the tyro's business. With Fanucci gone, Vito's communal stature grows.\n     ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather III"}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")])],1),_vm._v(" "),_c('h3',[_vm._v("3. Events")]),_vm._v(" "),_c('p',[_vm._v("The events such as onClose and onOpen invoked on tab change")]),_vm._v(" "),_c('vf-accordion',{on:{"onClose":function($event){_vm.onTabClose($event)},"onOpen":function($event){_vm.onTabOpen($event)}}},[_c('vf-accordionTab',{attrs:{"header":"Godfather I"}},[_vm._v("\n          The story begins as Don Vito Corleone, the head of a New York Mafia family, overseeshis daughter's wedding. His beloved son ichael has just come home from the war, but does not intend to become part of his father's business. T hrough Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather II"}},[_vm._v("\n          Francis Ford Coppola's legendary continuation and sequel to his landmark 1972 film, The_Godfather parallels the young Vito Corleone's rise with his son Michael's spiritual fall, deepening The_Godfather's depiction of the dark side of the American dream. In the early 1900s, the child Vito flees his Sicilian village for America after the local Mafia kills his family. Vito struggles to make a living, legally or illegally, for his wife and growing brood in Little Italy, killing the local Black Hand Fanucci after he demands his customary cut of the tyro's business. With Fanucci gone, Vito's communal stature grows.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather III"}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather IV","disabled":true}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")])],1),_vm._v(" "),_c('h3',[_vm._v("4. Programmatic")]),_vm._v(" "),_c('p',[_vm._v("The tabs interacted in a programmatic way using methods available")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"1em"}},[_c('vf-button',{attrs:{"type":"button","icon":"fa fa-chevron-up"},on:{"click":function($event){_vm.openPrev()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa fa-chevron-down"},on:{"click":function($event){_vm.openNext()}}})],1),_vm._v(" "),_c('vf-accordion',{attrs:{"activeIndex":_vm.index}},[_c('vf-accordionTab',{attrs:{"header":"Godfather I"}},[_vm._v("\n          The story begins as Don Vito Corleone, the head of a New York Mafia family, overseeshis daughter's wedding. His beloved son ichael has just come home from the war, but does not intend to become part of his father's business. T hrough Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather II"}},[_vm._v("\n          Francis Ford Coppola's legendary continuation and sequel to his landmark 1972 film, The_Godfather parallels the young Vito Corleone's rise with his son Michael's spiritual fall, deepening The_Godfather's depiction of the dark side of the American dream. In the early 1900s, the child Vito flees his Sicilian village for America after the local Mafia kills his family. Vito struggles to make a living, legally or illegally, for his wife and growing brood in Little Italy, killing the local Black Hand Fanucci after he demands his customary cut of the tyro's business. With Fanucci gone, Vito's communal stature grows.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather III"}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")]),_vm._v(" "),_c('vf-accordionTab',{attrs:{"header":"Godfather IV"}},[_vm._v("\n          After a break of more than  15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would one day be completely legitimate.\n      ")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Accordion")]),_vm._v(" "),_c('span',[_vm._v("Accordion groups a collection of contents in tabs.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BjHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as bar(type=\"bar\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"bar","data":_vm.barData,"width":"100","height":"20"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("BarChart")]),_vm._v(" "),_c('span',[_vm._v("A bar chart or bar graph is a chart that presents Grouped data with rectangular bars with lengths proportional to the values that they represent.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CH+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{class:{'fieldsetStyleClass:true, ui-fieldset ui-widget ui-widget-content ui-corner-all': true, 'ui-fieldset-toggleable': _vm.toggleable},style:(_vm.fieldsetStyle),attrs:{"id":_vm.id}},[_c('legend',{staticClass:"ui-fieldset-legend ui-corner-all ui-state-default ui-unselectable-text"},[(_vm.toggleable)?_c('a',{attrs:{"href":"#","aria-controls":_vm.id + '-content',"aria-expanded":!_vm.collapsedStatus,"tabindex":_vm.toggleable ? null : -1},on:{"click":function($event){_vm.toggle($event)}}},[_c('span',{staticClass:"ui-fieldset-toggler fa fa-w",class:{'fa-minus': !_vm.collapsedStatus,'fa-plus':_vm.collapsedStatus}}),_vm._v(" "),_c('span',{staticClass:"ui-fieldset-legend-text"},[_vm._v(_vm._s(_vm.legend))]),_vm._v(" "),_vm._t("header")],2):_c('span',[_c('span',{staticClass:"ui-fieldset-legend-text"},[_vm._v(_vm._s(_vm.legend))]),_vm._v(" "),_vm._t("header")],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"},on:{"enter":function($event){_vm.onToggleDone($event)},"leave":function($event){_vm.onToggleDone($event)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedStatus),expression:"!collapsedStatus"}],staticClass:"ui-fieldset-content-wrapper",class:{'ui-fieldset-content-wrapper-overflown': _vm.collapsedStatus||_vm.animating},attrs:{"id":_vm.id + '-content',"aria-hidden":_vm.collapsedStatus,"role":"region"}},[_c('div',{staticClass:"ui-fieldset-content"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cno/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carddemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Cpt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mask",staticClass:"ui-blockui ui-widget-overlay",class:{'ui-blockui-document':!_vm.target},style:({'display': (_vm.blocked ? 'block' : 'none')})},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CwOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-password',
  props: {
    value: String,
    promptLabel: {
      type: String,
      default: 'Please enter a password'
    },
    weakLabel: {
      type: String,
      default: 'Weak'
    },
    mediumLabel: {
      type: String,
      default: 'Medium'
    },
    strongLabel: {
      type: String,
      default: 'Strong'
    },
    feedback: {
      type: Boolean,
      default: true
    }

  },
  data: function data() {
    return {
      newValue: this.value,
      filled: false,
      panel: null,
      meter: null,
      info: null
    };
  },

  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.updateFilled(value);
      this.$emit('input', value);
    }
  },
  methods: {
    updateFilled: function updateFilled(value) {
      this.filled = value && value.length;
    },
    testStrength: function testStrength(str) {
      var grade = 0;
      var val = void 0;

      val = str.match('[0-9]');
      grade += this.normalize(val ? val.length : 1 / 4, 1) * 25;

      val = str.match('[a-zA-Z]');
      grade += this.normalize(val ? val.length : 1 / 2, 3) * 10;

      val = str.match('[!@#$%^&*?_~.,;=]');
      grade += this.normalize(val ? val.length : 1 / 6, 1) * 35;

      val = str.match('[A-Z]');
      grade += this.normalize(val ? val.length : 1 / 6, 1) * 30;

      grade *= str.length / 8;

      return grade > 100 ? 100 : grade;
    },
    normalize: function normalize(x, y) {
      var diff = x - y;

      if (diff <= 0) {
        return x / y;
      } else {
        return 1 + 0.5 * (x / (x + y / 4));
      }
    },
    disabled: function disabled() {
      return this.$refs.password.disabled;
    },
    handleKeyup: function handleKeyup(e) {
      var value = e.target.value;
      var label = null;
      var meterPos = null;

      if (value.length === 0) {
        label = this.promptLabel;
        meterPos = '0px 0px';
      } else {
        var score = this.testStrength(value);
        if (score < 30) {
          label = this.weakLabel;
          meterPos = '0px -10px';
        } else if (score >= 30 && score < 80) {
          label = this.mediumLabel;
          meterPos = '0px -20px';
        } else if (score >= 80) {
          label = this.strongLabel;
          meterPos = '0px -30px';
        }
      }

      this.meter.style.backgroundPosition = meterPos;
      this.info.textContent = label;
    },
    handleFocus: function handleFocus(e) {
      this.panel.style.zIndex = String(++__WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].zindex);
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].removeClass(this.panel, 'ui-helper-hidden');
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].absolutePosition(this.panel, this.$refs.password);
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].fadeIn(this.panel, 250);
    },
    handleBlur: function handleBlur(e) {
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].addClass(this.panel, 'ui-helper-hidden');
    },
    handleInput: function handleInput(e) {
      this.updateFilled();
    }
  },
  mounted: function mounted() {
    this.panel = document.createElement('div');
    this.panel.className = 'ui-password-panel ui-widget ui-state-highlight ui-corner-all ui-helper-hidden ui-password-panel-overlay';
    this.meter = document.createElement('div');
    this.meter.className = 'ui-password-meter';
    this.info = document.createElement('div');
    this.info.className = 'ui-password-info';
    this.info.textContent = this.promptLabel;
    if (this.feedback) {
      this.panel.appendChild(this.meter);
      this.panel.appendChild(this.info);
      document.body.appendChild(this.panel);
    }
    this.updateFilled(this.value);
  },
  destroyed: function destroyed() {
    if (!this.feedback) {
      return;
    }

    this.panel.removeChild(this.meter);
    this.panel.removeChild(this.info);
    document.body.removeChild(this.panel);
    this.panel = null;
    this.meter = null;
    this.info = null;
  }
});

/***/ }),

/***/ "D2tY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'qrcodedemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "D47R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"myButton",class:_vm.styleClass,attrs:{"disabled":_vm.disabled,"name":"button"},on:{"click":_vm.handleClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D971":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-radioButton',
  inheritAttrs: false,
  model: {
    prop: 'model',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    model: {},
    value: {},
    name: {
      type: String
    },
    inputId: {
      type: String
    },
    tabindex: {
      type: [Number, String]
    },
    radioStyle: {},
    radioStyleClass: {
      type: String
    }
  },
  data: function data() {
    return {
      checked: false,
      focused: false,
      newModel: this.model
    };
  },

  watch: {
    model: function model(value) {
      this.newModel = value;
    },
    newModel: function newModel(value) {
      var _this = this;

      this.$emit('input', value);
      this.$nextTick(function () {
        _this.checked = _this.$refs.rb.checked;
      });
    }
  },
  methods: {
    select: function select(event) {
      if (this.disabled) {
        return;
      }
      this.$refs.rb.click();
      this.$emit('click');
      this.checked = this.$refs.rb.checked;
    },
    onFocus: function onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    }
  },
  mounted: function mounted() {
    this.checked = this.$refs.rb.checked;
  }
});

/***/ }),

/***/ "DBIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbuttondemo_vue__ = __webpack_require__("MQoD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665e3766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbuttondemo_vue__ = __webpack_require__("8yGQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbuttondemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665e3766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbuttondemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DDQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DL0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Interactive Terminal")]),_vm._v(" "),_c('vf-terminal',{attrs:{"response":_vm.response,"welcomeMessage":"Welcome to VueFace","prompt":"VueFace $"},on:{"handler":function($event){_vm.onCommand($event)}}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Terminal")]),_vm._v(" "),_c('span',[_vm._v("Terminal is a text based user interface. Enter \"date\" to display the current date.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DMfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('vf-password')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Password")]),_vm._v(" "),_c('span',[_vm._v("Password displays strength indicator for password fields.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dgv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_growldemo_vue__ = __webpack_require__("IBKf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf0c440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_growldemo_vue__ = __webpack_require__("Z4Ww");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_growldemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf0c440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_growldemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DqVS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_griddemo_vue__ = __webpack_require__("t9Xv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6f72c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_griddemo_vue__ = __webpack_require__("udM/");
function injectStyle (ssrContext) {
  __webpack_require__("bPOf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_griddemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6f72c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_griddemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E/Rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E6pZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],ref:"password",class:[
          'ui-inputtext', 'ui-corner-all', 'ui-state-default', 'ui-widget', {
          'ui-state-filled': _vm.filled
         }],attrs:{"type":"password"},domProps:{"value":(_vm.newValue)},on:{"keyup":function($event){_vm.handleKeyup($event)},"focus":function($event){_vm.handleFocus($event)},"blur":function($event){_vm.handleBlur($event)},"input":[function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value},function($event){_vm.handleInput($event)}]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F5au":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],ref:"textarea",class:[
        'ui-inputtext', 'ui-corner-all', 'ui-state-default', 'ui-widget', {
        'ui-state-filled': _vm.filled
       }],attrs:{"rows":_vm.rows,"cols":_vm.cols},domProps:{"value":(_vm.newValue)},on:{"focus":function($event){_vm.handleAutoresize($event)},"blur":function($event){_vm.handleAutoresize($event)},"keyup":function($event){_vm.handleAutoresize($event)},"input":[function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value},function($event){_vm.handleFilledState($event)}]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FHVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"backtotop-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top",on:{"click":_vm.backToTop}},[(!_vm.textOnly)?_c('div',[_c('i',{class:['fa', _vm.icon],staticStyle:{"align":"middle"}})]):_vm._e(),_vm._v(" "),(!_vm.iconOnly)?_c('span',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fiol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ft+r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G5qQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minusplusdemo_vue__ = __webpack_require__("TG+F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f3c5ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minusplusdemo_vue__ = __webpack_require__("KpGb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minusplusdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f3c5ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minusplusdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9X4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputswitch_vue__ = __webpack_require__("Ot71");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2b5dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputswitch_vue__ = __webpack_require__("uOqY");
function injectStyle (ssrContext) {
  __webpack_require__("Fiol")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputswitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2b5dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputswitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GNQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linechartdemo_vue__ = __webpack_require__("k0RA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bb4ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linechartdemo_vue__ = __webpack_require__("7TSA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linechartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bb4ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linechartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GTbf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "GZPu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Goma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_captcha_vue__ = __webpack_require__("8wri");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0371e4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__ = __webpack_require__("RW21");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_captcha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0371e4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HF2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as polarData(type=\"polarData\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"polarArea","data":_vm.polarData,"width":"100","height":"20"}},[_vm._v(">")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("PolarAreaChart")]),_vm._v(" "),_c('span',[_vm._v("Polar area charts are similar to pie charts, but each segment has the same angle - the radius of the segment differs depending on the value.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HIeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Binary")]),_vm._v(" "),_c('h3',[_vm._v("Boolean - "+_vm._s(_vm.checked))]),_vm._v(" "),_c('p',[_vm._v("A single boolean value can be bound using the ngModel property as well by enabling the binary option.")]),_vm._v(" "),_c('vf-checkbox',{attrs:{"binary":"true"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_vm._v(" "),_c('h3',[_vm._v("2. Checkbox Group")]),_vm._v(" "),_c('p',[_vm._v("Collection of checkboxes categorized as a one group known as Checkbox Group")]),_vm._v(" "),_c('vf-checkbox',{attrs:{"name":"group1","value":"VueJS","label":"VueJS","inputId":"ny"},model:{value:(_vm.selectedFrameworks),callback:function ($$v) {_vm.selectedFrameworks=$$v},expression:"selectedFrameworks"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('vf-checkbox',{attrs:{"name":"group1","value":"Angular","label":"Angular","inputId":"sf"},model:{value:(_vm.selectedFrameworks),callback:function ($$v) {_vm.selectedFrameworks=$$v},expression:"selectedFrameworks"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('vf-checkbox',{attrs:{"name":"group1","value":"React","label":"React","inputId":"la"},model:{value:(_vm.selectedFrameworks),callback:function ($$v) {_vm.selectedFrameworks=$$v},expression:"selectedFrameworks"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Checkbox")]),_vm._v(" "),_c('span',[_vm._v("Checkbox is an extension to standard checkbox element with skinning capabilities.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hfmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputswitchdemo_vue__ = __webpack_require__("J1Zj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e72aff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputswitchdemo_vue__ = __webpack_require__("SJdk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputswitchdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e72aff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputswitchdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HwG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolbardemo_vue__ = __webpack_require__("vviW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71184866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolbardemo_vue__ = __webpack_require__("k1wk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolbardemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71184866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolbardemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/h8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('header-layout')],1),_vm._v(" "),_c('div',{attrs:{"slot":"sider"},slot:"sider"},[_c('sidebar-layout')],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('router-view')],1),_vm._v(" "),_c('div',[_c('footer-layout')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IBKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'growldemo',
  data: function data() {
    return {
      msgs: [],
      msgs1: []
    };
  },

  methods: {
    showSuccess: function showSuccess() {
      this.msgs = [];
      this.msgs.push({ severity: 'success', summary: 'Success Message', detail: 'Order submitted' });
    },
    showInfo: function showInfo() {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'VueFace rocks' });
    },
    showWarn: function showWarn() {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'There are unsaved changes' });
    },
    showError: function showError() {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Validation failed' });
    },
    showMultiple: function showMultiple() {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Message 1', detail: 'VueJS rocks' });
      this.msgs.push({ severity: 'info', summary: 'Message 2', detail: 'Angular rocks' });
      this.msgs.push({ severity: 'info', summary: 'Message 3', detail: 'React rocks' });
    },
    showSticky: function showSticky() {
      this.msgs1 = [];
      this.msgs1.push({ severity: 'success', summary: 'Error Message', detail: 'Sticky message' });
      this.msgs1.push({ severity: 'info', summary: 'Message 1', detail: 'VueJS rocks' });
      this.msgs1.push({ severity: 'warn', summary: 'Message 2', detail: 'Angular rocks' });
      this.msgs1.push({ severity: 'error', summary: 'Message 3', detail: 'React rocks' });
    },
    clear: function clear() {
      this.msgs = [];
      this.msgs1 = [];
    }
  }
});

/***/ }),

/***/ "ITyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'avatardemo',
  data: function data() {
    return {
      urlName: ''
    };
  }
});

/***/ }),

/***/ "IV5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var polarData = {
  datasets: [{
    data: [45, 35, 10, 15, 5],
    backgroundColor: ['#6544a9', '#51cc00', '#5d4361', '#E7E9ED', '#36A2EB'],
    label: 'Single page application frameworks'
  }],
  labels: ['VueJS', 'Angular', 'React', 'Ember', 'Meteor.js']
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chartsdemo',
  data: function data() {
    return {
      polarData: polarData
    };
  }
});

/***/ }),

/***/ "J1Zj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputswitchdemo',
  data: function data() {
    return {
      checked1: false,
      checked2: true
    };
  }
});

/***/ }),

/***/ "JMCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-layout',
  data: function data() {
    return {
      menuActive: false,
      activeMenuId: ''
    };
  },

  methods: {
    onMenuButtonClick: function onMenuButtonClick(event) {
      this.menuActive = !this.menuActive;
      event.preventDefault();
    },
    changeTheme: function changeTheme(event, theme) {
      var themeLink = document.getElementById('current-theme');
      themeLink.href = '../../../src/assets/themes/' + theme + '/theme.css';
      event.preventDefault();
    }
  }
});

/***/ }),

/***/ "JUgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'indicatorStyleClass': true,'ui-progressbar ui-widget ui-widget-content ui-corner-all': true, 'ui-progressbar-determinate': (_vm.mode === 'determinate'), 'ui-progressbar-indeterminate': (_vm.mode === 'indeterminate')},style:(_vm.indicatorStyle),attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuenow":_vm.value,"aria-valuemax":"100"}},[_c('div',{staticClass:"ui-progressbar-value ui-progressbar-value-animate ui-widget-header ui-corner-all",style:({width: _vm.value + '%', display :'block'})}),_vm._v(" "),(_vm.showValue)?_c('div',{staticClass:"ui-progressbar-label",style:(_vm.value ? 'display: block' : 'display: none')},[_vm._v(_vm._s(_vm.value)+_vm._s(_vm.unit))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JVo+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'togglebuttondemo',
  data: function data() {
    return {
      checked1: false,
      checked2: true
    };
  },

  methods: {
    toggle: function toggle(value) {
      console.log(value);
    }
  }
});

/***/ }),

/***/ "Jeto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("8AO8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ce9dee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ovUD");
function injectStyle (ssrContext) {
  __webpack_require__("dIqr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3ce9dee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jss5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_carddemo_vue__ = __webpack_require__("Cno/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44433862_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_carddemo_vue__ = __webpack_require__("zve5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_carddemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44433862_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_carddemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JuO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("Basic")]),_vm._v(" "),_c('p',[_vm._v("Galleria requires a set of images to display. Images attribute defines the path of the image whereas title and alt attributes are used in the caption section to display summary and description about an image.")]),_vm._v(" "),_c('vf-galleria',{attrs:{"images":_vm.images,"panelWidth":350,"panelHeight":313,"showCaption":true}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Galleria")]),_vm._v(" "),_c('span',[_vm._v("Galleria is a content gallery component.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JzTs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Jzan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  zindex: 100,

  calculatedScrollbarWidth: null,

  addClass: function addClass(element, className) {
    if (element.classList) {
      element.classList.add(className);
    } else {
      element.className += ' ' + className;
    }
  },
  addMultipleClasses: function addMultipleClasses(element, className) {
    if (element.classList) {
      var styles = className.split(' ');
      for (var i = 0; i < styles.length; i++) {
        element.classList.add(styles[i]);
      }
    } else {
      var _styles = className.split(' ');
      for (var _i = 0; _i < _styles.length; _i++) {
        element.className += ' ' + _styles[_i];
      }
    }
  },
  removeClass: function removeClass(element, className) {
    if (element.classList) {
      element.classList.remove(className);
    } else {
      element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  },
  hasClass: function hasClass(element, className) {
    if (element.classList) {
      return element.classList.contains(className);
    } else {
      return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
    }
  },
  siblings: function siblings(element) {
    return Array.prototype.filter.call(element.parentNode.children, function (child) {
      return child !== element;
    });
  },
  find: function find(element, selector) {
    return element.querySelectorAll(selector);
  },
  findSingle: function findSingle(element, selector) {
    return element.querySelector(selector);
  },
  index: function index(element) {
    var children = element.parentNode.childNodes;
    var num = 0;
    for (var i = 0; i < children.length; i++) {
      if (children[i] === element) return num;
      if (children[i].nodeType === 1) num++;
    }
    return -1;
  },
  relativePosition: function relativePosition(element, target) {
    var elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
    var targetHeight = target.offsetHeight;
    var targetWidth = target.offsetWidth;
    var targetOffset = target.getBoundingClientRect();
    var viewport = this.getViewport();
    var top = void 0;
    var left = void 0;

    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
      top = -1 * elementDimensions.height;
      if (targetOffset.top + top < 0) {
        top = 0;
      }
    } else {
      top = targetHeight;
    }

    if (targetOffset.left + elementDimensions.width > viewport.width) {
      left = targetWidth - elementDimensions.width;
    } else {
      left = 0;
    }

    element.style.top = top + 'px';
    element.style.left = left + 'px';
  },
  absolutePosition: function absolutePosition(element, target) {
    var elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
    var elementOuterHeight = elementDimensions.height;
    var elementOuterWidth = elementDimensions.width;
    var targetOuterHeight = target.offsetHeight;
    var targetOuterWidth = target.offsetWidth;
    var targetOffset = target.getBoundingClientRect();
    var windowScrollTop = this.getWindowScrollTop();
    var windowScrollLeft = this.getWindowScrollLeft();
    var viewport = this.getViewport();
    var top = void 0;
    var left = void 0;

    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
      top = targetOffset.top + windowScrollTop - elementOuterHeight;
      if (top < 0) {
        top = 0 + windowScrollTop;
      }
    } else {
      top = targetOuterHeight + targetOffset.top + windowScrollTop;
    }

    if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) {
      left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
    } else {
      left = targetOffset.left + windowScrollLeft;
    }

    element.style.top = top + 'px';
    element.style.left = left + 'px';
  },
  getHiddenElementOuterHeight: function getHiddenElementOuterHeight(element) {
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    var elementHeight = element.offsetHeight;
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return elementHeight;
  },
  getHiddenElementOuterWidth: function getHiddenElementOuterWidth(element) {
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    var elementWidth = element.offsetWidth;
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return elementWidth;
  },
  getHiddenElementDimensions: function getHiddenElementDimensions(element) {
    var dimensions = {};
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    dimensions.width = element.offsetWidth;
    dimensions.height = element.offsetHeight;
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return dimensions;
  },
  scrollInView: function scrollInView(container, item) {
    var borderTopValue = getComputedStyle(container).getPropertyValue('borderTopWidth');
    var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
    var paddingTopValue = getComputedStyle(container).getPropertyValue('paddingTop');
    var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
    var containerRect = container.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
    var scroll = container.scrollTop;
    var elementHeight = container.clientHeight;
    var itemHeight = this.getOuterHeight(item);

    if (offset < 0) {
      container.scrollTop = scroll + offset;
    } else if (offset + itemHeight > elementHeight) {
      container.scrollTop = scroll + offset - elementHeight + itemHeight;
    }
  },
  fadeIn: function fadeIn(element, duration) {
    element.style.opacity = 0;

    var last = +new Date();
    var opacity = 0;
    var tick = function tick() {
      opacity = +element.style.opacity.replace(',', '.') + (new Date().getTime() - last) / duration;
      element.style.opacity = opacity;
      last = +new Date();

      if (+opacity < 1) {
        window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
      }
    };

    tick();
  },
  fadeOut: function fadeOut(element, ms) {
    var opacity = 1;
    var interval = 50;
    var duration = ms;
    var gap = interval / duration;

    var fading = setInterval(function () {
      opacity = opacity - gap;

      if (opacity <= 0) {
        opacity = 0;
        clearInterval(fading);
      }

      element.style.opacity = opacity;
    }, interval);
  },
  getWindowScrollTop: function getWindowScrollTop() {
    var doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  },
  getWindowScrollLeft: function getWindowScrollLeft() {
    var doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  },
  matches: function matches(element, selector) {
    var p = Element.prototype;
    var f = p['matches'] || p.webkitMatchesSelector || p['mozMatchesSelector'] || p.msMatchesSelector || function (s) {
      return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    };
    return f.call(element, selector);
  },
  getOuterWidth: function getOuterWidth(el, margin) {
    var width = el.offsetWidth;

    if (margin) {
      var style = getComputedStyle(el);
      width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }

    return width;
  },
  getHorizontalPadding: function getHorizontalPadding(el) {
    var style = getComputedStyle(el);
    return parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
  },
  getHorizontalMargin: function getHorizontalMargin(el) {
    var style = getComputedStyle(el);
    return parseFloat(style.marginLeft) + parseFloat(style.marginRight);
  },
  innerWidth: function innerWidth(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);

    width += parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return width;
  },
  width: function width(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);

    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return width;
  },
  getInnerHeight: function getInnerHeight(el) {
    var height = el.offsetHeight;
    var style = getComputedStyle(el);

    height += parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    return height;
  },
  getOuterHeight: function getOuterHeight(el, margin) {
    var height = el.offsetHeight;

    if (margin) {
      var style = getComputedStyle(el);
      height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }

    return height;
  },
  getHeight: function getHeight(el) {
    var height = el.offsetHeight;
    var style = getComputedStyle(el);

    height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

    return height;
  },
  getWidth: function getWidth(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);

    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width;
  },
  getViewport: function getViewport() {
    var win = window;
    var d = document;
    var e = d.documentElement;
    var g = d.getElementsByTagName('body')[0];
    var w = win.innerWidth || e.clientWidth || g.clientWidth;
    var h = win.innerHeight || e.clientHeight || g.clientHeight;

    return { width: w, height: h };
  },
  getOffset: function getOffset(el) {
    var rect = el.getBoundingClientRect();

    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  },
  getUserAgent: function getUserAgent() {
    return navigator.userAgent;
  },
  isIE: function isIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return true;
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      return true;
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return true;
    }

    // other browser
    return false;
  },
  appendChild: function appendChild(element, target) {
    if (this.isElement(target)) {
      target.appendChild(element);
    } else if (target.el && target.el.nativeElement) {
      target.el.nativeElement.appendChild(element);
    } else {
      throw new Error('Cannot append ' + target + ' to ' + element);
    };
  },
  removeChild: function removeChild(element, target) {
    if (this.isElement(target)) {
      target.removeChild(element);
    } else if (target.el && target.el.nativeElement) {
      target.el.nativeElement.removeChild(element);
    } else {
      throw new Error('Cannot remove ' + element + ' from ' + target);
    };
  },
  isElement: function isElement(obj) {
    return (typeof HTMLElement === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string';
  },
  calculateScrollbarWidth: function calculateScrollbarWidth() {
    if (this.calculatedScrollbarWidth !== null) {
      return this.calculatedScrollbarWidth;
    }

    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'ui-scrollbar-measure';
    document.body.appendChild(scrollDiv);

    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    this.calculatedScrollbarWidth = scrollbarWidth;

    return scrollbarWidth;
  },
  invokeElementMethod: function invokeElementMethod(element, methodName, args) {
    methodName.apply(element, args);
  },
  clearSelection: function clearSelection() {
    if (window.getSelection) {
      if (window.getSelection().empty) {
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) {
        window.getSelection().removeAllRanges();
      }
    } else if (document['selection'] && document['selection'].empty) {
      try {
        document['selection'].empty();
      } catch (error) {
        // ignore IE bug
      }
    }
  }
});

/***/ }),

/***/ "K5Bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-accordion ui-widget ui-helper-reset",class:_vm.accordionStyleClass,style:(_vm.accordionStyle),attrs:{"role":"presentation"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KmuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-progress-spinner",class:_vm.indicatorStyleClass,style:(_vm.indicatorStyle),attrs:{"name":"progressSpinner"}},[_c('svg',{staticClass:"ui-progress-spinner-svg",attrs:{"viewBox":"25 25 50 50","animation-duration":_vm.animationDuration}},[_c('circle',{staticClass:"ui-progress-spinner-circle",attrs:{"cx":"50","cy":"50","r":"20","fill":_vm.fill,"stroke-width":_vm.strokeWidth,"stroke-miterlimit":"10"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KpGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('vf-minusplus',{attrs:{"min":0,"max":20,"step":1,"value":_vm.value1}}),_vm._v(" "),_c('h3',[_vm._v("Vertical")]),_vm._v(" "),_c('vf-minusplus',{staticClass:"demo-vertical",attrs:{"min":0,"max":9,"vertical":true,"value":_vm.value2}}),_vm._v(" "),_c('h3',[_vm._v("Custom")]),_vm._v(" "),_c('vf-minusplus',{attrs:{"min":0,"max":30,"step":2,"decrementLabel":_vm.decrement_desc,"incrementLabel":_vm.increment_desc},model:{value:(_vm.value3),callback:function ($$v) {_vm.value3=$$v},expression:"value3"}},[_vm._v("\n        "+_vm._s(_vm.input_header)+" "+_vm._s(_vm.value3)+"\n      ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("MinusPlusInput")]),_vm._v(" "),_c('span',[_vm._v("MinusPlusInput is an input element with increment and decrement controls.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L14D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("Three states of element can be displayed in an icon format.")]),_vm._v(" "),_c('h3',[_vm._v("Boolean - "+_vm._s(_vm.checked))]),_vm._v(" "),_c('vf-tristatecheckbox',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_vm._v(" "),_c('h3',[_vm._v("2. Disabled")]),_vm._v(" "),_c('p',[_vm._v("The checkbox selection is prevented using disabled attribute.")]),_vm._v(" "),_c('h3',[_vm._v("Boolean - "+_vm._s(_vm.checked))]),_vm._v(" "),_c('vf-tristatecheckbox',{attrs:{"disabled":true},model:{value:(_vm.disabledCheck),callback:function ($$v) {_vm.disabledCheck=$$v},expression:"disabledCheck"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("TriStateCheckbox")]),_vm._v(" "),_c('span',[_vm._v("TriStateCheckbox is used to select either \"true\", \"false\" or \"null\" as the value.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LCrn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iQ0hBUlRTIj4KCTxwYXRoIGZpbGw9IiM4ODk1OTciIGQ9Ik02OC44NTEsMjAuNTE0djIzLjM0aDAuMTI0bDE4LjMyMywxNC4yNjdjLTQuMjY5LDUuNTExLTEwLjkzNSw5LjA3NC0xOC40NDcsOS4wNzQKCQljLTEyLjg5MiwwLTIzLjM0LTEwLjQ0OS0yMy4zNC0yMy4zNDFDNDUuNTExLDMwLjk2Myw1NS45NiwyMC41MTQsNjguODUxLDIwLjUxNHoiLz4KCTxyZWN0IHg9IjAuMDE5IiB5PSIzNi45NDkiIGZpbGw9IiM4ODk1OTciIHdpZHRoPSIxMS4wNDUiIGhlaWdodD0iMzAuMjA3Ii8+Cgk8cmVjdCB4PSIxNC43ODgiIHk9IjE2LjIxNiIgZmlsbD0iIzg4OTU5NyIgd2lkdGg9IjExLjA0NSIgaGVpZ2h0PSI1MC45MzkiLz4KCTxyZWN0IHg9IjI5LjU1NiIgeT0iMjcuMDA4IiBmaWxsPSIjODg5NTk3IiB3aWR0aD0iMTEuMDQ1IiBoZWlnaHQ9IjQwLjE0NyIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "LFj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtext_vue__ = __webpack_require__("M1Ar");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37130d41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtext_vue__ = __webpack_require__("7k/h");
function injectStyle (ssrContext) {
  __webpack_require__("XSfJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtext_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37130d41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtext_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LVT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_captchademo_vue__ = __webpack_require__("4MN/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cff92952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captchademo_vue__ = __webpack_require__("qCHU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_captchademo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cff92952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captchademo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Laca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebardemo_vue__ = __webpack_require__("rYCn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09554680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebardemo_vue__ = __webpack_require__("5d8C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebardemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09554680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebardemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LkQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-backToTop',
  props: {
    text: {
      type: String,
      default: null
    },
    offset: {
      type: [String, Number],
      default: 500
    },
    icon: {
      type: String,
      default: 'fa-arrow-up'
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    textOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  created: function created() {
    var _this = this;

    window.createscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.createscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    };
    window.onscroll = function () {
      _this.visible = window.pageYOffset > parseInt(_this.offset);
    };
  },

  methods: {
    backToTop: function backToTop() {
      window.createscroll();
    }
  }
});

/***/ }),

/***/ "M1Ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-inputText',
  props: {
    value: String
  },
  data: function data() {
    return {
      newValue: this.value,
      filled: false
    };
  },

  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.updateFilled(value);
      this.$emit('input', value);
    }
  },
  methods: {
    updateFilled: function updateFilled(value) {
      this.filled = value && value.length;
    }
  },
  created: function created() {
    this.updateFilled(this.value);
  }
});

/***/ }),

/***/ "MQoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var types = [];
types.push({ label: 'Apartment', value: 'Apartment' });
types.push({ label: 'House', value: 'House' });
types.push({ label: 'Studio', value: 'Studio' });

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ratingdemo',
  data: function data() {
    return {
      types: types,
      selectedType: null,
      selectedTypes: ['Apartment', 'Studio']
    };
  },

  methods: {
    clear: function clear() {
      this.selectedType = null;
      this.selectedTypes = [];
    }
  }
});

/***/ }),

/***/ "MkLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Customized QRCode")]),_vm._v(" "),_c('vf-qrcode',{attrs:{"value":"https://github.com/sudheerj/vueface","size":300,"background":"lightblue","backgroundAlpha":"0.7","foreground":"black","foregroundAlpha":"0.7"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("QRCode")]),_vm._v(" "),_c('span',[_vm._v("A QRCode is a machine-readable optical label that contains information about the item to which it is attached.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Msuo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NCmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'editordemo',
    data: function data() {
        return {
            text1: '<div>Hello World!</div><div>VueFace <b>Editor</b> Rocks</div><div><br></div>',
            text2: null
        };
    },

    methods: {
        clear: function clear() {
            this.text1 = '';
        }
    }
});

/***/ }),

/***/ "NM4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//

var google = window.google;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-gmap',
  data: function data() {
    return {
      map: null
    };
  },

  props: {
    options: {
      type: Object,
      default: null
    },
    overlays: {
      type: Array,
      default: null
    }
  },
  watch: {
    overlays: function overlays(newValue, oldValue) {
      if (this.map !== null) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(oldValue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var overlay = _step.value;

            overlay.setMap(null);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.overlays), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _overlay = _step2.value;

            _overlay.setMap(this.map);
            this.bindOverlayEvents(_overlay);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  },
  methods: {
    initialize: function initialize() {
      var _this = this;

      this.map = new google.maps.Map(this.$refs.gmap, this.options);

      this.$emit('ready', {
        map: this.map
      });

      if (this.overlays) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.overlays), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var overlay = _step3.value;

            overlay.setMap(this.map);
            this.bindOverlayEvents(overlay);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      this.map.addListener('click', function (event) {
        _this.$emit('click', event);
      });

      this.map.addListener('dragend', function (event) {
        _this.$emit('dragend', event);
      });

      this.map.addListener('zoom_changed', function (event) {
        _this.$emit('zoomchanged', event);
      });
    },
    bindOverlayEvents: function bindOverlayEvents(overlay) {
      var _this2 = this;

      overlay.addListener('click', function (event) {
        _this2.$emit('overlayclick', {
          originalEvent: event,
          overlay: overlay,
          map: _this2.map
        });
      });

      if (overlay.getDraggable()) {
        this.bindDragEvents(overlay);
      }
    },
    bindDragEvents: function bindDragEvents(overlay) {
      var _this3 = this;

      overlay.addListener('dragstart', function (event) {
        _this3.$emit('overlaydragstart', {
          originalEvent: event,
          overlay: overlay,
          map: _this3.map
        });
      });

      overlay.addListener('drag', function (event) {
        _this3.$emit('overlaydrag', {
          originalEvent: event,
          overlay: overlay,
          map: _this3.map
        });
      });

      overlay.addListener('dragend', function (event) {
        _this3.$emit('overlaydragend', {
          originalEvent: event,
          overlay: overlay,
          map: _this3.map
        });
      });
    },
    getMap: function getMap() {
      return this.map;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    if (!this.map && this.$refs.gmap.offsetParent) {
      this.$nextTick(function () {
        _this4.initialize();
      });
    }
  }
});

/***/ }),

/***/ "NXPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratingdemo_vue__ = __webpack_require__("kyEY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076d79c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ratingdemo_vue__ = __webpack_require__("On9F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratingdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076d79c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ratingdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NfLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__("WaYt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0d63e84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__("Z3VC");
function injectStyle (ssrContext) {
  __webpack_require__("kY+Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0d63e84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "No9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinnerdemo_vue__ = __webpack_require__("n7LC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f07fbd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinnerdemo_vue__ = __webpack_require__("qyQT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinnerdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f07fbd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinnerdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Npf0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Nqm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-progressSpinner',
  data: function data() {
    return {
      cornerStyleClass: 'ui-corner-all'
    };
  },
  props: {
    fill: {
      type: String,
      default: 'none'
    },
    strokeWidth: {
      type: String,
      default: '2'
    },
    animationDuration: {
      type: String,
      default: '2s'
    },
    indicatorStyle: {
      type: String,
      default: null
    },
    indicatorStyleClass: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ "NqxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Inline")]),_vm._v(" "),_c('vf-colorPicker',{attrs:{"inline":true},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5em"}},[_vm._v("Selected Color: "),_c('span',{style:({display:'inline-block',width:'32px',height:'32px','vertical-align':'middle', backgroundColor: _vm.color1})}),_vm._v(" "+_vm._s(_vm.color1)+" ")]),_vm._v(" "),_c('h3',[_vm._v("Overlay")]),_vm._v(" "),_c('vf-colorPicker',{model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":".5em"}},[_vm._v("Selected Color: "),_c('span',{style:({'color':_vm.color2})},[_vm._v(_vm._s(_vm.color2))])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("ColorPicker")]),_vm._v(" "),_c('span',[_vm._v("ColorPicker is an input component to select a color..")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OCJF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-badge ui-position"},[_vm._t("default"),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],staticClass:"ui-badge-content",class:['ui-widget ui-widget-content ui-corner-all', _vm.badgeClass, {'fixed': true, 'dot': _vm.dot }],style:({'background-color': _vm.backgroundColor}),domProps:{"textContent":_vm._s(_vm.data)}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OK5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_codehighlighter_codehighlighter__ = __webpack_require__("SakC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'codehighlighterdemo',
  data: function data() {
    return {};
  },

  directives: {
    code: __WEBPACK_IMPORTED_MODULE_0__src_components_codehighlighter_codehighlighter__["a" /* default */]
  }
});

/***/ }),

/***/ "OiG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockui_vue__ = __webpack_require__("64uC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1694b428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockui_vue__ = __webpack_require__("Cpt3");
function injectStyle (ssrContext) {
  __webpack_require__("vdW/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockui_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1694b428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockui_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "On9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The rating is measured with number of stars.")]),_vm._v(" "),_c('vf-rating',{model:{value:(_vm.val1),callback:function ($$v) {_vm.val1=$$v},expression:"val1"}}),_vm._v("\n      "+_vm._s(_vm.val1)+"\n\n      "),_c('h3',[_vm._v("2. Abort cancel")]),_vm._v(" "),_c('p',[_vm._v("The rating component doesn't allow cancelling the rating.")]),_vm._v(" "),_c('vf-rating',{attrs:{"cancel":false},model:{value:(_vm.val2),callback:function ($$v) {_vm.val2=$$v},expression:"val2"}}),_vm._v(" "),_c('h3',[_vm._v("3. ReadOnly")]),_vm._v(" "),_c('p',[_vm._v("The component appears in read mode using readOnly attribute")]),_vm._v(" "),_c('vf-rating',{attrs:{"readonly":true,"stars":10,"cancel":false},model:{value:(_vm.val3),callback:function ($$v) {_vm.val3=$$v},expression:"val3"}}),_vm._v(" "),_c('h3',[_vm._v("4. Disabled")]),_vm._v(" "),_c('p',[_vm._v("The component disabled using disabled attribute")]),_vm._v(" "),_c('vf-rating',{attrs:{"disabled":true,"stars":10},model:{value:(_vm.val4),callback:function ($$v) {_vm.val4=$$v},expression:"val4"}}),_vm._v(" "),_c('h3',[_vm._v("5. Custom Icons")]),_vm._v(" "),_c('p',[_vm._v("The component is customized(apart from star icon) using icon classes")]),_vm._v(" "),_c('vf-rating',{attrs:{"iconOnClass":"fa-plus-circle","iconOffClass":"fa-minus-circle","iconCancelClass":"fa-close"},model:{value:(_vm.val5),callback:function ($$v) {_vm.val5=$$v},expression:"val5"}}),_vm._v(" "),_c('h3',[_vm._v("6. Events")]),_vm._v(" "),_c('p',[_vm._v("The rating component supports rating and caceling events")]),_vm._v(" "),_c('vf-rating',{on:{"rating":function($event){_vm.rating($event)},"canceling":_vm.canceling},model:{value:(_vm.val6),callback:function ($$v) {_vm.val6=$$v},expression:"val6"}}),_vm._v(" "),(_vm.msg)?_c('span',[_vm._v(_vm._s(_vm.msg))]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Rating")]),_vm._v(" "),_c('span',[_vm._v("Rating components is a star based selection input for the evaluation or assessment of something.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OqFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollPaneldemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Ot71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-inputSwitch',
  data: function data() {
    return {
      checked: false,
      focused: false,
      container: null,
      handle: null,
      onContainer: null,
      offContainer: null,
      onLabelChild: null,
      offLabelChild: null,
      offset: null,
      ariaLabel: null,
      ariaLabelledBy: null,
      initialized: false,
      newValue: this.value
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onLabel: {
      type: String,
      default: 'On'
    },
    offLabel: {
      type: String,
      default: 'Off'
    },
    tabindex: {
      type: Number,
      default: 0
    },
    inputId: {
      type: String,
      default: null
    },
    inputswitchStyle: {
      type: String,
      default: null
    },
    inputswitchStyleClass: {
      type: String,
      default: null
    },
    ariaLabelTemplate: {
      type: String,
      default: 'InputSwitch {0}'
    }
  },
  methods: {
    render: function render() {
      var onContainerWidth = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.onContainer);
      var offContainerWidth = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.offContainer);
      var spanPadding = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].innerWidth(this.offLabelChild) - __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.offLabelChild);
      var handleMargins = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].getOuterWidth(this.handle) - __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].innerWidth(this.handle);

      var containerWidth = onContainerWidth > offContainerWidth ? onContainerWidth : offContainerWidth;
      var handleWidth = containerWidth;

      this.handle.style.width = handleWidth + 'px';
      handleWidth = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.handle);
      containerWidth = containerWidth + handleWidth + 6;

      var labelWidth = containerWidth - handleWidth - spanPadding - handleMargins;

      this.container.style.width = containerWidth + 'px';
      this.onLabelChild.style.width = labelWidth + 'px';
      this.offLabelChild.style.width = labelWidth + 'px';

      // position
      this.offContainer.style.width = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.container) - 5 + 'px';
      this.offset = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].width(this.container) - __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].getOuterWidth(this.handle);

      // default value
      if (this.checked) {
        this.handle.style.left = this.offset + 'px';
        this.onContainer.style.width = this.offset + 'px';
        this.offLabelChild.style.marginRight = -this.offset + 'px';
      } else {
        this.onContainer.style.width = 0 + 'px';
        this.onLabelChild.style.marginLeft = -this.offset + 'px';
      }

      this.initialized = true;
    },
    toggle: function toggle(event) {
      if (!this.disabled) {
        if (this.checked) {
          this.checked = false;
          this.uncheckUI();
        } else {
          this.checked = true;
          this.checkUI();
        }

        this.$emit('input', this.checked);
        this.$refs.in.focus();
      }
    },
    checkUI: function checkUI() {
      this.onContainer.style.width = this.offset + 'px';
      this.onLabelChild.style.marginLeft = 0 + 'px';
      this.offLabelChild.style.marginRight = -this.offset + 'px';
      this.handle.style.left = this.offset + 'px';
      this.updateAriaLabel();
    },
    uncheckUI: function uncheckUI() {
      this.onContainer.style.width = 0 + 'px';
      this.onLabelChild.style.marginLeft = -this.offset + 'px';
      this.offLabelChild.style.marginRight = 0 + 'px';
      this.handle.style.left = 0 + 'px';
      this.updateAriaLabel();
    },
    onFocus: function onFocus(event) {
      this.focused = true;
    },
    onBlur: function onBlur(event) {
      this.focused = false;
    },
    setDisabledState: function setDisabledState(val) {
      this.disabled = val;
    },
    updateAriaLabel: function updateAriaLabel() {
      var pattern = /{(.*?)}/;
      var value = this.checked ? this.onLabel : this.offLabel;

      this.ariaLabel = this.ariaLabelTemplate.replace(this.ariaLabelTemplate.match(pattern)[0], value);
    }
  },
  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {
    this.container = this.$refs.inputswitch;
    this.checked = this.$refs.in.checked;
    this.handle = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].findSingle(this.container, 'div.ui-inputswitch-handle');
    this.onContainer = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].findSingle(this.container, 'div.ui-inputswitch-on');
    this.offContainer = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].findSingle(this.container, 'div.ui-inputswitch-off');
    this.onLabelChild = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].findSingle(this.onContainer, 'span.ui-inputswitch-onlabel');
    this.offLabelChild = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].findSingle(this.offContainer, 'span.ui-inputswitch-offlabel');
    if (this.container && this.container.offsetParent && !this.initialized) {
      this.render();
    }
  }
});

/***/ }),

/***/ "OvOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OwaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-message',
  data: function data() {
    return {};
  },
  props: {
    severity: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  },
  methods: {
    getIcon: function getIcon() {
      var icon = null;

      if (this.severity) {
        switch (this.severity) {
          case 'success':
            icon = 'fa fa-check';
            break;

          case 'info':
            icon = 'fa fa-info-circle';
            break;

          case 'error':
            icon = 'fa fa-close';
            break;

          case 'warn':
            icon = 'fa fa-warning';
            break;

          default:
            icon = 'fa fa-info-circle';
            break;
        }
      }

      return icon;
    }
  }
});

/***/ }),

/***/ "P+Kh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iMzVweCIgaGVpZ2h0PSIzNXB4IiB2aWV3Qm94PSIwIDAgMzUgMzUiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxyZWN0IHk9IjEwLjY5NSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjI0LjMwNSIgZmlsbD0iIzg4OTU5NyIvPgoJCTxyZWN0IHdpZHRoPSIzNSIgaGVpZ2h0PSI3Ljc3OCIgZmlsbD0iIzg4OTU5NyIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "P/uI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Default")]),_vm._v(" "),_c('vf-inputTextarea',{attrs:{"rows":"5","cols":"30"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_vm._v(" "),_c('h3',[_vm._v("AutoResize")]),_vm._v(" "),_c('vf-inputTextarea',{attrs:{"rows":"5","cols":"30","autoResize":_vm.autoResize}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("InputTextarea")]),_vm._v(" "),_c('span',[_vm._v("Inputtextarea add styling and autoResize functionality to standard textare element.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P6kH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'messagedemo',
  data: function data() {
    return {
      msgs: []
    };
  },

  methods: {
    showSuccess: function showSuccess() {
      this.msgs = [];
      this.msgs.push({ severity: 'success', summary: 'Success Message', detail: 'Order submitted' });
    },
    showInfo: function showInfo() {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'VueFace rocks' });
    },
    showWarn: function showWarn() {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'There are unsaved changes' });
    },
    showError: function showError() {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Validation failed' });
    },
    showMultiple: function showMultiple() {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Message 1', detail: 'Vue rocks' });
      this.msgs.push({ severity: 'info', summary: 'Message 2', detail: 'Angular rocks' });
      this.msgs.push({ severity: 'info', summary: 'Message 3', detail: 'React rocks' });
    },
    clear: function clear() {
      this.msgs = [];
    }
  }
});

/***/ }),

/***/ "PDYU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iT1ZFUkxBWSI+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNODIuOTg5LDEwLjA4M0g0LjMyOGMtMi4zMzgsMC00LjIzNSwxLjg5Ny00LjIzNSw0LjIzNXYxMi4yNDhoODcuMTMyVjE0LjMxOQoJCUM4Ny4yMjUsMTEuOTgxLDg1LjMyOSwxMC4wODMsODIuOTg5LDEwLjA4M3ogTTgxLjY4OCwyMS4wOTVjMC41MTYsMC41MTYsMC41MTYsMS4zNDksMCwxLjg2MmMtMC41MTIsMC41MTUtMS4zNDgsMC41MTYtMS44NjEsMAoJCWwtMi43Ny0yLjc2OWwtMi43NywyLjc2OWMtMC41MTYsMC41MTYtMS4zNSwwLjUxNS0xLjg2MywwYy0wLjUxNC0wLjUxNC0wLjUxNC0xLjM0NywwLTEuODYybDIuNzctMi43NjlsLTIuNzcxLTIuNzcxCgkJYy0wLjUxMi0wLjUxNi0wLjUxMi0xLjM0OSwwLTEuODYyYzAuNTE2LTAuNTE1LDEuMzUtMC41MTYsMS44NjMsMGwyLjc3MSwyLjc3MWwyLjc3LTIuNzcxYzAuNTE0LTAuNTE2LDEuMzUtMC41MTUsMS44NjEsMAoJCWMwLjUxNiwwLjUxNCwwLjUxNiwxLjM0NywwLDEuODYybC0yLjc3LDIuNzcxTDgxLjY4OCwyMS4wOTV6Ii8+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNMC4wOTMsMzAuMDUydjM5LjA0YzAsMi4zMzgsMS44OTcsNC4yMzUsNC4yMzUsNC4yMzVoNzguNjYxYzIuMzQsMCw0LjIzNi0xLjg5Nyw0LjIzNi00LjIzNXYtMzkuMDRIMC4wOTN6CgkJIE04MC4yOSw2NS43NTdINy4wM1YzNy42Mmg3My4yNlY2NS43NTd6Ii8+Cgk8cmVjdCB4PSIxMS4wNTIiIHk9IjQxLjg4MiIgZmlsbD0iIzFCODJENyIgd2lkdGg9IjY1LjY1MiIgaGVpZ2h0PSI1LjM5NSIvPgoJPHJlY3QgeD0iMTEuMDUyIiB5PSI1MC44OTgiIGZpbGw9IiMxQjgyRDciIHdpZHRoPSI0Ni4yMTEiIGhlaWdodD0iNS4zOTYiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "PKs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleriademo_vue__ = __webpack_require__("tesd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0c16cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleriademo_vue__ = __webpack_require__("JuO/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleriademo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0c16cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleriademo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "POpO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/galleria4.179c768.jpg";

/***/ }),

/***/ "Q96i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__ = __webpack_require__("OwaC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e5fab3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__ = __webpack_require__("/heO");
function injectStyle (ssrContext) {
  __webpack_require__("GZPu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e5fab3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QJip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doughnutchartdemo_vue__ = __webpack_require__("z63Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32886368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doughnutchartdemo_vue__ = __webpack_require__("eRTM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doughnutchartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32886368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doughnutchartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QXw8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_vue__ = __webpack_require__("6JSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_vue__ = __webpack_require__("Z3Qg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar_vue__ = __webpack_require__("vUa0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeaderLayout: __WEBPACK_IMPORTED_MODULE_0__header_vue__["a" /* default */],
    SidebarLayout: __WEBPACK_IMPORTED_MODULE_2__sidebar_vue__["a" /* default */],
    FooterLayout: __WEBPACK_IMPORTED_MODULE_1__footer_vue__["a" /* default */]
  },
  name: 'Layout',
  methods: {
    changeTheme: function changeTheme(event, theme) {
      var themeLink = document.getElementById('current-theme');
      themeLink.href = '../../../src/assets/themes/' + theme + '/theme.css';
      event.preventDefault();
    }
  }
});

/***/ }),

/***/ "Qacz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_vue__ = __webpack_require__("CwOi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ebd5b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_vue__ = __webpack_require__("E6pZ");
function injectStyle (ssrContext) {
  __webpack_require__("tYc9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ebd5b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmOc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-chkbox ui-widget",class:_vm.checkboxStyleClass,style:(_vm.checkboxStyle)},[_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.newModel),expression:"newModel"}],ref:"cb",class:{'ui-state-focus': _vm.focused},attrs:{"type":"checkbox","id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled,"tabindex":_vm.tabindex},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.newModel)?_vm._i(_vm.newModel,_vm.value)>-1:(_vm.newModel)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"change":function($event){var $$a=_vm.newModel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newModel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newModel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newModel=$$c}}}},'input',_vm.$attrs,false))]),_vm._v(" "),_c('div',{staticClass:"ui-chkbox-box ui-widget ui-corner-all ui-state-default",class:{
           'ui-state-active': _vm.checked,
           'ui-state-disabled': _vm.disabled,
           'ui-state-focus': _vm.focused
         },on:{"click":function($event){$event.preventDefault();_vm.onClick($event, true)}}},[_c('span',{staticClass:"ui-chkbox-icon ui-clickable",class:{'fa fa-check': _vm.checked}})])]),_vm._v(" "),(_vm.label)?_c('label',{staticClass:"ui-chkbox-label",class:{
           'ui-label-active': _vm.checked,
           'ui-label-disabled':_vm.disabled,
           'ui-label-focus':_vm.focused
         },attrs:{"for":_vm.inputId},on:{"click":function($event){$event.preventDefault();_vm.onClick($event, true)}}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R1Rv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextdemo_vue__ = __webpack_require__("yZ23");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f924f6c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextdemo_vue__ = __webpack_require__("eML1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f924f6c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-accordion',
  data: function data() {
    return {
      _activeIndex: 0,
      tabs: []
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    accordionStyle: {
      type: String,
      default: null
    },
    accordionStyleClass: {
      type: String,
      default: null
    },
    lazy: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    addTab: function addTab(tab) {
      this.tabs.push(tab);
    },
    getTabs: function getTabs() {
      return this.tabs;
    }
  },
  updated: function updated() {
    if (this.tabs && this.tabs.length && this._activeIndex != null) {
      for (var i = 0; i < this.tabs.length; i++) {
        var selected = this.multiple ? this._activeIndex.includes(i) : i === this._activeIndex;
        var changed = selected !== this.tabs[i].selected;

        if (changed) {
          this.tabs[i].animating = true;
        }

        this.tabs[i].selected = selected;
        this.tabs[i].$emit('selectedChange', selected);
      }
    }
  },
  computed: {}
});

/***/ }),

/***/ "RW21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captcha"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rj17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("Used to select an option from multiple choices.")]),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group1","value":"VueJS","label":"VueJS","inputId":"g1opt1"},model:{value:(_vm.val1),callback:function ($$v) {_vm.val1=$$v},expression:"val1"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group1","value":"Angular","label":"Angular","inputId":"g1opt2"},model:{value:(_vm.val1),callback:function ($$v) {_vm.val1=$$v},expression:"val1"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group1","value":"React","label":"React","inputId":"g1opt3"},model:{value:(_vm.val1),callback:function ($$v) {_vm.val1=$$v},expression:"val1"}}),_c('br'),_vm._v("\n      Selected Value = "+_vm._s(_vm.val1||'none')+"\n\n      "),_c('h3',[_vm._v("2. Preselection")]),_vm._v(" "),_c('p',[_vm._v("The preselection feature allows default selection of any option.")]),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group2","value":"VueJS","label":"VueJS","inputId":"g2opt1"},model:{value:(_vm.val2),callback:function ($$v) {_vm.val2=$$v},expression:"val2"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group2","value":"Angular","label":"Angular","inputId":"g2opt2"},model:{value:(_vm.val2),callback:function ($$v) {_vm.val2=$$v},expression:"val2"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group2","value":"React","label":"React","inputId":"g2opt3"},model:{value:(_vm.val2),callback:function ($$v) {_vm.val2=$$v},expression:"val2"}}),_c('br'),_vm._v("\n\n      Selected Value = "+_vm._s(_vm.val2||'none')+"\n\n      "),_c('h3',[_vm._v("3. Events")]),_vm._v(" "),_c('p',[_vm._v("The radio button component supports click event")]),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group3","value":"VueJS","label":"VueJS","inputId":"g3opt1"},on:{"click":_vm.clickMe},model:{value:(_vm.val3),callback:function ($$v) {_vm.val3=$$v},expression:"val3"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group3","value":"Angular","label":"Angular","inputId":"g3opt2"},on:{"click":_vm.clickMe},model:{value:(_vm.val3),callback:function ($$v) {_vm.val3=$$v},expression:"val3"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group3","value":"React","label":"React","inputId":"g3opt3"},on:{"click":_vm.clickMe},model:{value:(_vm.val3),callback:function ($$v) {_vm.val3=$$v},expression:"val3"}}),_c('br'),_vm._v("\n      Selected Value = "+_vm._s(_vm.val3||'none')+"\n\n      "),_c('h3',[_vm._v("4. Disabled")]),_vm._v(" "),_c('p',[_vm._v("The component disabled using disabled attribute")]),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group4","value":"VueJS","label":"VueJS","inputId":"g4opt1","disabled":true},model:{value:(_vm.val4),callback:function ($$v) {_vm.val4=$$v},expression:"val4"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group4","value":"Angular","label":"Angular","inputId":"g4opt2","disabled":true},model:{value:(_vm.val4),callback:function ($$v) {_vm.val4=$$v},expression:"val4"}}),_c('br'),_vm._v(" "),_c('vf-radioButton',{attrs:{"name":"group4","value":"React","label":"React","inputId":"g4opt3","disabled":true},model:{value:(_vm.val4),callback:function ($$v) {_vm.val4=$$v},expression:"val4"}}),_c('br'),_vm._v("\n      Selected Value = "+_vm._s(_vm.val4||'none')+"\n\n    ")],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("RadioButton")]),_vm._v(" "),_c('span',[_vm._v("RadioButton is an extension to standard radio button element with skinning capabilities.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rjl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputgroupdemo_vue__ = __webpack_require__("7SQ7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6672d337_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputgroupdemo_vue__ = __webpack_require__("oP77");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputgroupdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6672d337_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputgroupdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RnuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("QXw8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c73f466_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("I/h8");
function injectStyle (ssrContext) {
  __webpack_require__("E/Rd")
  __webpack_require__("daQr")
  __webpack_require__("+dhG")
  __webpack_require__("SrdQ")
  __webpack_require__("OvOt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c73f466_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S34Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SCRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('vf-messages',{attrs:{"value":_vm.msgs}}),_vm._v(" "),_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',{staticClass:"first"},[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The list of messages displayed in one place using p-messages component.")]),_vm._v(" "),_c('div',[_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Success"},on:{"click":function($event){_vm.showSuccess()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-info",attrs:{"type":"button","label":"Info"},on:{"click":function($event){_vm.showInfo()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-warning",attrs:{"type":"button","label":"Warn"},on:{"click":function($event){_vm.showWarn()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-danger",attrs:{"type":"button","label":"Error"},on:{"click":function($event){_vm.showError()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Multiple"},on:{"click":function($event){_vm.showMultiple()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-close","label":"Clear"},on:{"click":function($event){_vm.clear()}}})],1),_vm._v(" "),_c('h3',[_vm._v("2. Inline Message CSS")]),_vm._v(" "),_c('p',[_vm._v("CSS helpers to display inline messages mostly within forms.")]),_vm._v(" "),_c('vf-message',{attrs:{"severity":"info","text":"VueFace Rocks"}}),_vm._v(" "),_c('vf-message',{attrs:{"severity":"success","text":"Record Saved"}}),_vm._v(" "),_c('vf-message',{attrs:{"severity":"warn","text":"Are you sure?"}}),_vm._v(" "),_c('vf-message',{attrs:{"severity":"error","text":"Field is required"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Message")]),_vm._v(" "),_c('span',[_vm._v("Messages is used to display messages inline.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SHej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-minusplus',
  props: {
    value: {
      default: 0,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 10,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    },
    vertical: {
      default: false,
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    decrementLabel: {
      type: String,
      default: '-'
    },
    incrementLabel: {
      type: String,
      default: '+'
    },
    minusplusStyleClass: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      inputValue: 0
    };
  },

  computed: {
    isIncrement: function isIncrement() {
      return this.inputValue + this.step <= this.max;
    },
    isDecrement: function isDecrement() {
      return this.inputValue - this.step >= this.min;
    }
  },
  methods: {
    getButtonClass: function getButtonClass(decrement) {
      var buttonClass = '';
      if (decrement) {
        if (!this.isDecrement) buttonClass += ' ui-state-disabled';
      } else {
        if (!this.isIncrement) buttonClass += ' ui-state-disabled';
      }
      return buttonClass;
    },
    increment: function increment() {
      if (this.isIncrement) {
        this.inputValue = this.inputValue + this.step;
        this.$emit('onIncrement', this.inputValue);
        this.$emit('input', this.inputValue);
      }
    },
    decrement: function decrement() {
      if (this.isDecrement) {
        this.inputValue = this.inputValue - this.step;
        this.$emit('onDecrement', this.inputValue);
        this.$emit('input', this.inputValue);
      }
    }
  },
  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.inputValue = parseInt(newVal);
      }
    }
  },
  created: function created() {
    this.inputValue = this.value;
    if (this.step < 1) this.step = 1;
  }
});

/***/ }),

/***/ "SJdk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The inputswitch component displays on and off toggleable state.")]),_vm._v(" "),_c('vf-inputSwitch',{model:{value:(_vm.checked1),callback:function ($$v) {_vm.checked1=$$v},expression:"checked1"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.checked1))]),_vm._v(" "),_c('h3',[_vm._v("2. Labels")]),_vm._v(" "),_c('p',[_vm._v("The inputswitch component displays customized labels for on and off toggleable state.")]),_vm._v(" "),_c('vf-inputSwitch',{attrs:{"onLabel":"Yes","offLabel":"No"},model:{value:(_vm.checked2),callback:function ($$v) {_vm.checked2=$$v},expression:"checked2"}}),_vm._v(" "),_c('h3',[_vm._v("Labels - "),_c('span',[_vm._v(" "+_vm._s(_vm.checked2)+" ")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("InputSwitch")]),_vm._v(" "),_c('span',[_vm._v("InputSwitch is used to select a boolean value.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SakC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_codehighlighter_vue__ = __webpack_require__("8zkq");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_codehighlighter_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SeAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buttondemo_vue__ = __webpack_require__("fHj6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d20155_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttondemo_vue__ = __webpack_require__("W4xU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buttondemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d20155_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttondemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SrdQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SsdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollpanel_vue__ = __webpack_require__("pRjg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4accf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollpanel_vue__ = __webpack_require__("8/e0");
function injectStyle (ssrContext) {
  __webpack_require__("fMPF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollpanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4accf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollpanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T4AK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tristatecheckboxdemo',
  data: function data() {
    return {
      checked: false,
      disabledCheck: true
    };
  }
});

/***/ }),

/***/ "TG+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'minusplusinputdemo',
  data: function data() {
    return {
      value1: 10,
      value2: 5,
      value3: 10,
      decrement_desc: 'Loss',
      increment_desc: 'Win',
      input_header: 'Total points:'
    };
  }
});

/***/ }),

/***/ "TMUp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.c086536.png";

/***/ }),

/***/ "TsEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-radiobutton ui-widget",class:_vm.radioStyleClass,style:(_vm.radioStyle)},[_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.newModel),expression:"newModel"}],ref:"rb",attrs:{"type":"radio","id":_vm.inputId,"name":_vm.name,"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm._q(_vm.newModel,_vm.value)},on:{"focus":function($event){_vm.onFocus($event)},"blur":function($event){_vm.onBlur($event)},"change":function($event){_vm.newModel=_vm.value}}},'input',_vm.$attrs,false))]),_vm._v(" "),_c('div',{class:[
          'ui-radiobutton-box ui-widget ui-state-default',{
          'ui-state-active': _vm.checked,
          'ui-state-disabled': _vm.disabled,
          'ui-state-focus': _vm.focused
        }],on:{"click":function($event){!_vm.disabled && _vm.select()}}},[_c('span',{staticClass:"ui-radiobutton-icon ui-clickable",class:{'fa fa-circle': _vm.checked}})])]),_vm._v(" "),(_vm.label)?_c('label',{staticClass:"ui-radiobutton-label",class:{
          'ui-label-active': _vm.checked,
          'ui-label-disabled': _vm.disabled,
          'ui-label-focus': _vm.focused
         },attrs:{"for":_vm.inputId},on:{"click":_vm.select}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U4Te":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6fo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inplacedemo_vue__ = __webpack_require__("hMVA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0c28d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inplacedemo_vue__ = __webpack_require__("2F84");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inplacedemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0c28d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inplacedemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UK7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UPTn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UQcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      menuActive: false,
      activeMenuId: '',
      element: {}
    };
  },
  mounted: function mounted() {
    this.element.inputmenutitle = this.$refs.inputmenutitle.id;
    this.element.buttonmenutitle = this.$refs.buttonmenutitle.id;
    this.element.datamenutitle = this.$refs.datamenutitle.id;
    this.element.panelmenutitle = this.$refs.panelmenutitle.id;
    this.element.overlaymenutitle = this.$refs.overlaymenutitle.id;
    this.element.chartmenutitle = this.$refs.chartmenutitle.id;
    this.element.messagesmenutitle = this.$refs.messagesmenutitle.id;
    this.element.multimediamenutitle = this.$refs.multimediamenutitle.id;
    this.element.misctitle = this.$refs.misctitle.id;
  }
});

/***/ }),

/***/ "UfxB":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iUEFORUwiPgoJPHBhdGggZmlsbD0iIzg4OTU5NyIgZD0iTTc3LjU5MSw3MC44ODNjMCwyLjA4Mi0xLjY4OCwzLjc3MS0zLjc3LDMuNzcxSDMuODAyYy0yLjA4MywwLTMuNzctMS42ODktMy43Ny0zLjc3MVYyMi4yMjEKCQljMC0yLjA4MSwxLjY4Ny0zLjc3LDMuNzctMy43N2g3MC4wMjFjMi4wODIsMCwzLjc3LDEuNjg5LDMuNzcsMy43N0w3Ny41OTEsNzAuODgzTDc3LjU5MSw3MC44ODN6Ii8+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNODMuNTE3LDguNzU2aC03MC4wMmMtMi4wODMsMC0zLjc3MSwxLjY4OC0zLjc3MSwzLjc3djEuNjE2SDc4LjEzYzIuMDgyLDAsMy43NzEsMS42ODksMy43NzEsMy43N3Y0Ny4wNDcKCQloMS42MTdjMi4wOCwwLDMuNzctMS42ODgsMy43Ny0zLjc3VjEyLjUyNkM4Ny4yODYsMTAuNDQ0LDg1LjU5Nyw4Ljc1Niw4My41MTcsOC43NTZ6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Urqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gmap_vue__ = __webpack_require__("NM4i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cddf2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gmap_vue__ = __webpack_require__("v602");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gmap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cddf2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gmap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VCtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_passworddemo_vue__ = __webpack_require__("Zwp2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94f4964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_passworddemo_vue__ = __webpack_require__("DMfs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_passworddemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94f4964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_passworddemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VDZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-rating",class:{'ui-state-disabled': _vm.disabled}},[(_vm.cancel)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.clear}},[_c('span',{staticClass:"fa",class:_vm.iconCancelClass,style:(_vm.iconCancelStyle)})]):_vm._e(),_vm._v(" "),_vm._l((_vm.starsArray),function(star,index){return _c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.rate(index)}}},[_c('span',{staticClass:"fa",class:(!_vm.value || index >= _vm.value) ? _vm.iconOffClass : _vm.iconOnClass,style:((!_vm.value || index >= _vm.value) ? _vm.iconOffStyle : _vm.iconOnStyle)})])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VQhR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/galleria1.725c2db.jpg";

/***/ }),

/***/ "VTww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbutton_vue__ = __webpack_require__("048l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1a6646_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbutton_vue__ = __webpack_require__("9MA0");
function injectStyle (ssrContext) {
  __webpack_require__("DDQL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectbutton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1a6646_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectbutton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VUKx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vcda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_highlightjs__ = __webpack_require__("5CJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_index_js__ = __webpack_require__("lVK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_vue__ = __webpack_require__("RnuE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_inputtext_inputtextdemo_vue__ = __webpack_require__("R1Rv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_inputtextarea_inputtextareademo_vue__ = __webpack_require__("nkpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_button_buttondemo_vue__ = __webpack_require__("SeAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_progressbar_progressbardemo_vue__ = __webpack_require__("q04z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_progressspinner_progressspinnerdemo_vue__ = __webpack_require__("gky/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_checkbox_checkboxdemo_vue__ = __webpack_require__("wRVP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_tristatecheckbox_tristatecheckboxdemo_vue__ = __webpack_require__("vJy2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_charts_barchart_barchartdemo_vue__ = __webpack_require__("kDDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_components_charts_bubblechart_bubblechartdemo_vue__ = __webpack_require__("APAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_components_charts_doughnutchart_doughnutchartdemo_vue__ = __webpack_require__("QJip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_components_charts_horizontalbarchart_horizontalbarchartdemo_vue__ = __webpack_require__("cI7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_components_charts_linechart_linechartdemo_vue__ = __webpack_require__("GNQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_components_charts_piechart_piechartdemo_vue__ = __webpack_require__("f4fb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_components_charts_polarareachart_polarareachartdemo_vue__ = __webpack_require__("Xnr+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_components_charts_radarchart_radarchartdemo_vue__ = __webpack_require__("roGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_components_rating_ratingdemo_vue__ = __webpack_require__("NXPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_components_togglebutton_togglebuttondemo_vue__ = __webpack_require__("o3S/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_components_radiobutton_radiobuttondemo_vue__ = __webpack_require__("+iml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_components_captcha_captchademo_vue__ = __webpack_require__("LVT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_components_panel_paneldemo_vue__ = __webpack_require__("4pq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_components_fieldset_fieldsetdemo_vue__ = __webpack_require__("9BOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_components_grid_griddemo_vue__ = __webpack_require__("DqVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_components_toolbar_toolbardemo_vue__ = __webpack_require__("HwG1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_components_galleria_galleriademo_vue__ = __webpack_require__("PKs+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_components_message_messagedemo_vue__ = __webpack_require__("p7ze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_components_editor_editordemo_vue__ = __webpack_require__("WLN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_components_accordion_accordiondemo_vue__ = __webpack_require__("zkdQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_components_terminal_terminaldemo_vue__ = __webpack_require__("iaRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_components_growl_growldemo_vue__ = __webpack_require__("Dgv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_components_gmap_gmapdemo_vue__ = __webpack_require__("2NlL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_components_inputswitch_inputswitchdemo_vue__ = __webpack_require__("Hfmo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_components_inputgroup_inputgroupdemo_vue__ = __webpack_require__("Rjl8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_components_password_passworddemo_vue__ = __webpack_require__("VCtn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_components_spinner_spinnerdemo_vue__ = __webpack_require__("No9W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_components_inplace_inplacedemo_vue__ = __webpack_require__("U6fo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_components_blockui_blockuidemo_vue__ = __webpack_require__("rfYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_components_sidebar_sidebardemo_vue__ = __webpack_require__("Laca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__src_components_backtotop_backtotopdemo_vue__ = __webpack_require__("j4oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__src_components_codehighlighter_codehighlighterdemo_vue__ = __webpack_require__("q86k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__src_components_selectbutton_selectbuttondemo_vue__ = __webpack_require__("DBIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__src_components_colorpicker_colorpickerdemo_vue__ = __webpack_require__("VqTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__src_components_badge_badgedemo_vue__ = __webpack_require__("vZp5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__src_components_card_carddemo_vue__ = __webpack_require__("Jss5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__src_components_qrcode_qrcodedemo_vue__ = __webpack_require__("3F1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__src_components_scrollpanel_scrollpaneldemo_vue__ = __webpack_require__("getA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__src_components_avatar_avatardemo_vue__ = __webpack_require__("7Jgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__src_components_minusplus_minusplusdemo_vue__ = __webpack_require__("G5qQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__src_components_index_vue__ = __webpack_require__("Jeto");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//import App from './App.vue';




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__src_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_highlightjs___default.a)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */])




















































const routes = [
  { path: '/', component: __WEBPACK_IMPORTED_MODULE_52__src_components_index_vue__["a" /* default */] },
  { path: '/components/inputtext', component: __WEBPACK_IMPORTED_MODULE_5__src_components_inputtext_inputtextdemo_vue__["a" /* default */] },
  { path: '/components/button', component: __WEBPACK_IMPORTED_MODULE_7__src_components_button_buttondemo_vue__["a" /* default */] },
  { path: '/components/inputgroup', component: __WEBPACK_IMPORTED_MODULE_36__src_components_inputgroup_inputgroupdemo_vue__["a" /* default */] },
  { path: '/components/progressspinner', component: __WEBPACK_IMPORTED_MODULE_9__src_components_progressspinner_progressspinnerdemo_vue__["a" /* default */] },
  { path: '/components/progressbar', component: __WEBPACK_IMPORTED_MODULE_8__src_components_progressbar_progressbardemo_vue__["a" /* default */] },
  { path: '/components/checkbox', component: __WEBPACK_IMPORTED_MODULE_10__src_components_checkbox_checkboxdemo_vue__["a" /* default */] },
  { path: '/components/tristatecheckbox', component: __WEBPACK_IMPORTED_MODULE_11__src_components_tristatecheckbox_tristatecheckboxdemo_vue__["a" /* default */] },
  { path: '/components/charts/barchart', component: __WEBPACK_IMPORTED_MODULE_12__src_components_charts_barchart_barchartdemo_vue__["a" /* default */] },
  { path: '/components/charts/bubblechart', component: __WEBPACK_IMPORTED_MODULE_13__src_components_charts_bubblechart_bubblechartdemo_vue__["a" /* default */] },
  { path: '/components/charts/doughnutchart', component: __WEBPACK_IMPORTED_MODULE_14__src_components_charts_doughnutchart_doughnutchartdemo_vue__["a" /* default */] },
  { path: '/components/charts/horizontalbarchart', component: __WEBPACK_IMPORTED_MODULE_15__src_components_charts_horizontalbarchart_horizontalbarchartdemo_vue__["a" /* default */] },
  { path: '/components/charts/linechart', component: __WEBPACK_IMPORTED_MODULE_16__src_components_charts_linechart_linechartdemo_vue__["a" /* default */] },
  { path: '/components/charts/piechart', component: __WEBPACK_IMPORTED_MODULE_17__src_components_charts_piechart_piechartdemo_vue__["a" /* default */] },
  { path: '/components/charts/linechart', component: __WEBPACK_IMPORTED_MODULE_16__src_components_charts_linechart_linechartdemo_vue__["a" /* default */] },
  { path: '/components/charts/polarareachart', component: __WEBPACK_IMPORTED_MODULE_18__src_components_charts_polarareachart_polarareachartdemo_vue__["a" /* default */] },
  { path: '/components/charts/radarchart', component: __WEBPACK_IMPORTED_MODULE_19__src_components_charts_radarchart_radarchartdemo_vue__["a" /* default */] },
  { path: '/components/rating', component: __WEBPACK_IMPORTED_MODULE_20__src_components_rating_ratingdemo_vue__["a" /* default */] },
  { path: '/components/togglebutton', component: __WEBPACK_IMPORTED_MODULE_21__src_components_togglebutton_togglebuttondemo_vue__["a" /* default */] },
  { path: '/components/radiobutton', component: __WEBPACK_IMPORTED_MODULE_22__src_components_radiobutton_radiobuttondemo_vue__["a" /* default */] },
  { path: '/components/captcha', component: __WEBPACK_IMPORTED_MODULE_23__src_components_captcha_captchademo_vue__["a" /* default */] },
  { path: '/components/panel', component: __WEBPACK_IMPORTED_MODULE_24__src_components_panel_paneldemo_vue__["a" /* default */] },
  { path: '/components/fieldset', component: __WEBPACK_IMPORTED_MODULE_25__src_components_fieldset_fieldsetdemo_vue__["a" /* default */] },
  { path: '/components/grid', component: __WEBPACK_IMPORTED_MODULE_26__src_components_grid_griddemo_vue__["a" /* default */] },
  { path: '/components/toolbar', component: __WEBPACK_IMPORTED_MODULE_27__src_components_toolbar_toolbardemo_vue__["a" /* default */] },
  { path: '/components/galleria', component: __WEBPACK_IMPORTED_MODULE_28__src_components_galleria_galleriademo_vue__["a" /* default */] },
  { path: '/components/message', component: __WEBPACK_IMPORTED_MODULE_29__src_components_message_messagedemo_vue__["a" /* default */] },
  { path: '/components/editor', component: __WEBPACK_IMPORTED_MODULE_30__src_components_editor_editordemo_vue__["a" /* default */] },
  { path: '/components/accordion', component: __WEBPACK_IMPORTED_MODULE_31__src_components_accordion_accordiondemo_vue__["a" /* default */] },
  { path: '/components/terminal', component: __WEBPACK_IMPORTED_MODULE_32__src_components_terminal_terminaldemo_vue__["a" /* default */] },
  { path: '/components/growl', component: __WEBPACK_IMPORTED_MODULE_33__src_components_growl_growldemo_vue__["a" /* default */] },
  { path: '/components/gmap', component: __WEBPACK_IMPORTED_MODULE_34__src_components_gmap_gmapdemo_vue__["a" /* default */] },
  { path: '/components/inputswitch', component: __WEBPACK_IMPORTED_MODULE_35__src_components_inputswitch_inputswitchdemo_vue__["a" /* default */] },
  { path: '/components/inputtextarea', component: __WEBPACK_IMPORTED_MODULE_6__src_components_inputtextarea_inputtextareademo_vue__["a" /* default */] },
  { path: '/components/password', component: __WEBPACK_IMPORTED_MODULE_37__src_components_password_passworddemo_vue__["a" /* default */] },
  { path: '/components/spinner', component: __WEBPACK_IMPORTED_MODULE_38__src_components_spinner_spinnerdemo_vue__["a" /* default */] },
  { path: '/components/inplace', component: __WEBPACK_IMPORTED_MODULE_39__src_components_inplace_inplacedemo_vue__["a" /* default */] },
  { path: '/components/blockui', component: __WEBPACK_IMPORTED_MODULE_40__src_components_blockui_blockuidemo_vue__["a" /* default */] },
  { path: '/components/sidebar', component: __WEBPACK_IMPORTED_MODULE_41__src_components_sidebar_sidebardemo_vue__["a" /* default */] },
  { path: '/components/backtotop', component: __WEBPACK_IMPORTED_MODULE_42__src_components_backtotop_backtotopdemo_vue__["a" /* default */] },
  { path: '/components/codehighlighter', component: __WEBPACK_IMPORTED_MODULE_43__src_components_codehighlighter_codehighlighterdemo_vue__["a" /* default */] },
  { path: '/components/selectbutton', component: __WEBPACK_IMPORTED_MODULE_44__src_components_selectbutton_selectbuttondemo_vue__["a" /* default */] },
  { path: '/components/colorpicker', component: __WEBPACK_IMPORTED_MODULE_45__src_components_colorpicker_colorpickerdemo_vue__["a" /* default */] },
  { path: '/components/badge', component: __WEBPACK_IMPORTED_MODULE_46__src_components_badge_badgedemo_vue__["a" /* default */] },
  { path: '/components/card', component: __WEBPACK_IMPORTED_MODULE_47__src_components_card_carddemo_vue__["a" /* default */] },
  { path: '/components/qrcode', component: __WEBPACK_IMPORTED_MODULE_48__src_components_qrcode_qrcodedemo_vue__["a" /* default */] },
  { path: '/components/scrollpanel', component: __WEBPACK_IMPORTED_MODULE_49__src_components_scrollpanel_scrollpaneldemo_vue__["a" /* default */] },
  { path: '/components/avatar', component: __WEBPACK_IMPORTED_MODULE_50__src_components_avatar_avatardemo_vue__["a" /* default */] },
  { path: '/components/minusplus', component: __WEBPACK_IMPORTED_MODULE_51__src_components_minusplus_minusplusdemo_vue__["a" /* default */] }
]
const router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
})

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: router,
  template: '<home/>',
  components: { Home: __WEBPACK_IMPORTED_MODULE_4__src_components_home_vue__["a" /* default */] }
}).$mount('#app')


/***/ }),

/***/ "VjVt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/galleria5.df4cc30.jpg";

/***/ }),

/***/ "VqTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorpickerdemo_vue__ = __webpack_require__("roYW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510b0f84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorpickerdemo_vue__ = __webpack_require__("NqxN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorpickerdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510b0f84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorpickerdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W3u5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var idx = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-panel',
  data: function data() {
    return {
      animating: false,
      id: 'ui-panel-' + idx++,
      collapsedStatus: false
    };
  },
  props: {
    toggleable: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: null
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    panelStyle: {
      type: String,
      default: null
    },
    panelStyleClass: {
      type: String,
      default: null
    },
    expandIcon: {
      type: String,
      default: 'fa-plus'
    },
    collapseIcon: {
      type: String,
      default: 'fa-minus'
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    hasFooter: function hasFooter() {
      return this.$slots.footer;
    },
    toggle: function toggle(event) {
      if (this.animating) {
        return false;
      }

      this.animating = true;
      this.$emit('onBeforeToggle', { originalEvent: event, collapsed: this.collapsedStatus });

      if (this.toggleable) {
        if (this.collapsedStatus) {
          this.expand(event);
        } else {
          this.collapse(event);
        }
      }

      event.preventDefault();
    },
    expand: function expand(event) {
      this.collapsedStatus = false;
      this.$emit('collapsedChange', this.collapsedStatus);
    },
    collapse: function collapse(event) {
      this.collapsedStatus = true;
      this.$emit('collapsedChange', this.collapsedStatus);
    },
    onToggleDone: function onToggleDone(event) {
      this.animating = false;
      this.$emit('onAfterToggle', { originalEvent: event, collapsed: this.collapsedStatus });
    }
  },
  mounted: function mounted() {
    this.collapsedStatus = this.collapsed;
  },
  computed: {}
});

/***/ }),

/***/ "W4xU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Icon positions")]),_vm._v(" "),_c('p',[_vm._v("The icon of a button is specified using icon attribute and position is customized using iconPos attribute. The default icon position is left. To display only an icon, leave label as undefined.")]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-check","label":"VueJS"}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-check","iconPos":"right","label":"VueJS"}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-close"}}),_vm._v(" "),_c('h3',[_vm._v("2. Severity Buttons")]),_vm._v(" "),_c('p',[_vm._v("Different color options are available to define severity levels.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Primary"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","label":"Secondary"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Success"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-info",attrs:{"type":"button","label":"Info"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-warning",attrs:{"type":"button","label":"Warning"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-danger",attrs:{"type":"button","label":"Danger"}}),_vm._v(" "),_c('h3',[_vm._v("3. Events")]),_vm._v(" "),_c('p',[_vm._v("The button component supports click event")]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Click"},on:{"click":_vm.clickMe}}),_vm._v(" "),_c('h3',[_vm._v("4. Disabled")]),_vm._v(" "),_c('p',[_vm._v("The component disabled using disabled attribute")]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-check","disabled":true,"label":"Disabled"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Button")]),_vm._v(" "),_c('span',[_vm._v("Button is an extension to standard input element with icons and theming.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v(".ui-button-secondary")]),_vm._v(" "),_c('li',[_vm._v(".ui-button-success")]),_vm._v(" "),_c('li',[_vm._v(".ui-button-info")]),_vm._v(" "),_c('li',[_vm._v(".ui-button-warning")]),_vm._v(" "),_c('li',[_vm._v(".ui-button-danger")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WBXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-progressBar',
  data: function data() {
    return {};
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    showValue: {
      type: Boolean,
      default: true
    },
    indicatorStyle: {
      type: String,
      default: null
    },
    indicatorStyleClass: {
      type: String,
      default: null
    },
    unit: {
      type: String,
      default: '%'
    },
    mode: {
      type: String,
      default: 'determinate'
    }
  }
});

/***/ }),

/***/ "WH/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-galleria',
  data: function data() {
    return {
      _images: null,

      slideshowActive: false,

      container: null,

      panelWrapper: null,

      panels: null,

      caption: null,

      stripWrapper: null,

      strip: null,

      frames: null,

      interval: null,

      stripLeft: 0,

      imagesChanged: false,

      initialized: false,

      domHandler: __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */],

      activeIndex: 0
    };
  },
  props: {
    images: {
      type: Array,
      default: null
    },
    galleriaStyle: {
      type: String,
      default: null
    },
    galleriaStyleClass: {
      type: String,
      default: null
    },
    panelWidth: {
      type: Number,
      default: 600
    },
    panelHeight: {
      type: Number,
      default: 400
    },
    frameWidth: {
      type: Number,
      default: 60
    },
    frameHeight: {
      type: Number,
      default: 40
    },
    activeImageIndex: {
      type: Number,
      default: 0
    },
    transitionInterval: {
      type: Number,
      default: 4000
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    showFilmstrip: {
      type: Boolean,
      default: true
    },
    showCaption: {
      type: Boolean,
      default: true
    }

  },
  methods: {
    render: function render() {
      this.panels = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].find(this.panelWrapper, 'li.ui-galleria-panel');

      if (this.showFilmstrip) {
        this.frames = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].find(this.strip, 'li.ui-galleria-frame');
        this.stripWrapper.style.width = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].width(this.panelWrapper) - 50 + 'px';
        this.stripWrapper.style.height = this.frameHeight + 'px';
      }

      if (this.showCaption) {
        this.caption = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].findSingle(this.container, 'div.ui-galleria-caption');
        this.caption.style.bottom = this.showFilmstrip ? __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].getOuterHeight(this.stripWrapper, true) + 'px' : 0 + 'px';
        this.caption.style.width = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].width(this.panelWrapper) + 'px';
      }

      if (this.autoPlay) {
        this.startSlideshow();
      }

      this.container.style.visibility = 'visible';
    },
    startSlideshow: function startSlideshow() {
      var _this = this;

      this.interval = setInterval(function () {
        _this.next();
      }, this.transitionInterval);

      this.slideshowActive = true;
    },
    stopSlideshow: function stopSlideshow() {
      if (this.interval) {
        clearInterval(this.interval);
      }

      this.slideshowActive = false;
    },
    clickNavRight: function clickNavRight() {
      if (this.slideshowActive) {
        this.stopSlideshow();
      }
      this.next();
    },
    clickNavLeft: function clickNavLeft() {
      if (this.slideshowActive) {
        this.stopSlideshow();
      }
      this.prev();
    },
    frameClick: function frameClick(frame) {
      if (this.slideshowActive) {
        this.stopSlideshow();
      }

      this.select(__WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].index(frame), false);
    },
    prev: function prev() {
      if (this.activeIndex !== 0) {
        this.select(this.activeIndex - 1, true);
      }
    },
    next: function next() {
      if (this.activeIndex !== this.panels.length - 1) {
        this.select(this.activeIndex + 1, true);
      } else {
        this.select(0, false);
        this.stripLeft = 0;
      }
    },
    select: function select(index, reposition) {
      if (index !== this.activeIndex) {
        var newPanel = this.panels[index];
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].fadeIn(newPanel, 500);

        if (this.showFilmstrip) {
          var newFrame = this.frames[index];

          if (reposition === undefined || reposition === true) {
            var frameLeft = newFrame.offsetLeft;
            var stepFactor = this.frameWidth + parseInt(getComputedStyle(newFrame)['margin-right'], 10);
            var stripLeft = this.strip.offsetLeft;
            var frameViewportLeft = frameLeft + stripLeft;
            var frameViewportRight = frameViewportLeft + this.frameWidth;

            if (frameViewportRight > __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].width(this.stripWrapper)) {
              this.stripLeft -= stepFactor;
            } else if (frameViewportLeft < 0) {
              this.stripLeft += stepFactor;
            }
          }
        }

        this.activeIndex = index;
      }
    },
    clickImage: function clickImage(event, image, i) {
      this.$emit('onImageClicked', { originalEvent: event, image: image, index: i });
    }
  },
  mounted: function mounted() {
    this.activeIndex = this.activeImageIndex;
    this.imagesChanged = true;
    this.container = this.$refs.galleria;
    this.panelWrapper = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].findSingle(this.container, 'ul.ui-galleria-panel-wrapper');
    this.initialized = true;

    if (this.showFilmstrip) {
      this.stripWrapper = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].findSingle(this.container, 'div.ui-galleria-filmstrip-wrapper');
      this.strip = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].findSingle(this.stripWrapper, 'ul.ui-galleria-filmstrip');
    }

    this._images = this.images;
    this.$refs.galleria.style.width = this.panelWidth + 'px';
    this.$refs.galleria.style.visibility = 'visible';

    if (this.images && this.images.length) {
      this.render();
    }
  },
  watch: {
    images: function images(value) {
      this._images = value;
      this.activeIndex = 0;
      this.imagesChanged = true;
    }
  },
  updated: function updated() {
    if (this.imagesChanged) {
      this.stopSlideshow();
      this.render();
      this.imagesChanged = false;
    }
  },
  destroyed: function destroyed() {
    this.stopSlideshow();
  },
  computed: {}
});

/***/ }),

/***/ "WHX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'backtotopdemo',
  data: function data() {
    return {
      offset: '200',
      text: 'Top'
    };
  },

  watch: {
    offset: function offset(newVal) {
      document.body.style.height = parseInt(newVal) + 600;
    }
  }
});

/***/ }),

/***/ "WLN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editordemo_vue__ = __webpack_require__("NCmf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53318f2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editordemo_vue__ = __webpack_require__("nRi/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editordemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53318f2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editordemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WP3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WaYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_quill_dist_quill_js__ = __webpack_require__("yPE/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_quill_dist_quill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_quill_dist_quill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_domhandler_js__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-editor',
  data: function data() {
    return {
      value: null,
      _readonly: false,
      quill: null
    };
  },
  model: {
    prop: 'model',
    event: 'onChange'
  },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    formats: {
      type: Array,
      default: null
    },
    editorStyle: {
      type: String,
      default: null
    },
    editorStyleClass: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    model: {
      type: undefined
    }
  },
  methods: {
    getQuill: function getQuill() {
      return this.quill;
    },
    hasToolbar: function hasToolbar() {
      return this.$slots.toolbar;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var editorElement = __WEBPACK_IMPORTED_MODULE_1__dom_domhandler_js__["a" /* default */].findSingle(this.$refs.editor, 'div.ui-editor-content');
    var toolbarElement = __WEBPACK_IMPORTED_MODULE_1__dom_domhandler_js__["a" /* default */].findSingle(this.$refs.editor, 'div.ui-editor-toolbar');

    this.quill = new __WEBPACK_IMPORTED_MODULE_0__node_modules_quill_dist_quill_js___default.a(editorElement, {
      modules: {
        toolbar: toolbarElement
      },
      placeholder: this.placeholder,
      readOnly: this.readonly,
      theme: 'snow',
      formats: this.formats
    });

    this.value = this.model;

    if (this.quill) {
      if (this.value) {
        this.quill.pasteHTML(this.value);
      } else {
        this.quill.setText('');
      }
    }

    this._readonly = this.readonly;

    if (this.quill) {
      if (this._readonly) {
        this.quill.disable();
      } else {
        this.quill.enable();
      }
    }

    if (this.value) {
      this.quill.pasteHTML(this.value);
    }

    this.quill.on('text-change', function (delta, oldContents, source) {
      var html = editorElement.children[0].innerHTML;
      var text = _this.quill.getText();
      if (html === '<p><br></p>') {
        html = null;
      }

      _this.$emit('onTextChange', {
        htmlValue: html,
        textValue: text,
        delta: delta,
        source: source
      });

      _this.$emit('onChange', html);
    });

    this.quill.on('selection-change', function (range, oldRange, source) {
      _this.$emit('onSelectionChange', {
        range: range,
        oldRange: oldRange,
        source: source
      });
    });

    this.$emit('onInit', {
      editor: this.quill
    });
  },
  computed: {}
});

/***/ }),

/***/ "WwAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordion_vue__ = __webpack_require__("R1ui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbc8bc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordion_vue__ = __webpack_require__("K5Bc");
function injectStyle (ssrContext) {
  __webpack_require__("mQC1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbc8bc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X42f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('vf-scrollPanel',{attrs:{"scrollpanelStyle":{'width': '100%', 'height': '200px'}}},[_c('div',{staticStyle:{"{padding":"'1em',line-height:'1.5'}"}},[_vm._v("\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through\n              Michael's life the nature of the family business becomes clear. The business of the family is just like the head\n              of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands\n              against the good of the family.\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through Michael's\n              life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind\n              and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the\n              family.\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('vf-scrollPanel',{attrs:{"scrollpanelStyle":{'width': '100%', 'height': '200px'},"scrollpanelStyleClass":"custombar1"}},[_c('div',{staticStyle:{"{padding":"'1em',line-height:'1.5'}"}},[_vm._v("\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through\n              Michael's life the nature of the family business becomes clear. The business of the family is just like the head\n              of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands\n              against the good of the family.\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through Michael's\n              life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind\n              and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the\n              family.\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('vf-scrollPanel',{attrs:{"scrollpanelStyle":{'width': '100%', 'height': '200px'},"scrollpanelStyleClass":"custombar2"}},[_c('div',{staticStyle:{"{padding":"'1em',line-height:'1.5'}"}},[_vm._v("\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through\n              Michael's life the nature of the family business becomes clear. The business of the family is just like the head\n              of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands\n              against the good of the family.\n              The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. His beloved\n              son Michael has just come home from the war, but does not intend to become part of his father's business. Through Michael's\n              life the nature of the family business becomes clear. The business of the family is just like the head of the family, kind\n              and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the\n              family.\n          ")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("ScrollPanel")]),_vm._v(" "),_c('span',[_vm._v("ScrollPanel is a cross browser, lightweight and skinnable alternative to native browser scrollbar.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XHuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-avatar',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconClass: {
      type: [String, Object, Array]
    },
    src: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: Number
    },
    iconSize: {
      type: Number
    },
    avatarStyle: {
      type: String,
      default: null
    },
    avatarStyleClass: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
});

/***/ }),

/***/ "XJZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-toolbar',
  data: function data() {
    return {};
  },
  props: {
    toolbarStyle: {
      type: String,
      default: null
    },
    toolbarStyleClass: {
      type: String,
      default: null
    }
  }

});

/***/ }),

/***/ "XMfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSfJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xl0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XlOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'accordiondemo',
  data: function data() {
    return {
      msgs: [],
      index: -1
    };
  },

  methods: {
    onTabClose: function onTabClose(event) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Tab Closed', detail: 'Index: ' + event.index });
    },
    onTabOpen: function onTabOpen(event) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Tab Expanded', detail: 'Index: ' + event.index });
    },
    openNext: function openNext() {
      this.index = this.index === 3 ? 0 : this.index + 1;
    },
    openPrev: function openPrev() {
      this.index = this.index <= 0 ? 3 : this.index - 1;
    }
  }
});

/***/ }),

/***/ "Xnr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polarareachartdemo_vue__ = __webpack_require__("IV5t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775e9a14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polarareachartdemo_vue__ = __webpack_require__("HF2f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polarareachartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775e9a14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polarareachartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y8DQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[_c('div',{ref:"container",class:['ui-sidebar ui-widget ui-widget-content ui-shadow', _vm.sidebarStyleClass,  {'ui-sidebar-active': _vm.visible,
          'ui-sidebar-left': (_vm.position === 'left'), 'ui-sidebar-right': (_vm.position === 'right'),
          'ui-sidebar-top': (_vm.position === 'top'), 'ui-sidebar-bottom': (_vm.position === 'bottom'),
          'ui-sidebar-full': _vm.fullScreen}],style:(_vm.sidebarStyle)},[_c('a',{class:['ui-sidebar-close', 'ui-corner-all'],attrs:{"href":"#","role":"button"},on:{"click":function($event){_vm.close($event)}}},[_c('span',{staticClass:"fa fa-fw fa-close"})]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YNGN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z3Co":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z3Qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("h1RH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c910bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("1pge");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c910bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z3VC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",staticClass:"ui-widget ui-editor-container ui-corner-all",class:_vm.editorStyleClass},[(_vm.hasToolbar())?_c('div',{staticClass:"ui-editor-toolbar ui-widget-header ui-corner-top"},[_vm._t("toolbar")],2):_vm._e(),_vm._v(" "),(!_vm.hasToolbar())?_c('div',{staticClass:"ui-editor-toolbar ui-widget-header ui-corner-top"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui-editor-content",style:(_vm.editorStyle)})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('select',{staticClass:"ql-header"},[_c('option',{attrs:{"value":"1"}},[_vm._v("Heading")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Subheading")]),_vm._v(" "),_c('option',{attrs:{"selected":""}},[_vm._v("Normal")])]),_vm._v(" "),_c('select',{staticClass:"ql-font"},[_c('option',{attrs:{"selected":""}},[_vm._v("Sans Serif")]),_vm._v(" "),_c('option',{attrs:{"value":"serif"}},[_vm._v("Serif")]),_vm._v(" "),_c('option',{attrs:{"value":"monospace"}},[_vm._v("Monospace")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('button',{staticClass:"ql-bold",attrs:{"aria-label":"Bold"}}),_vm._v(" "),_c('button',{staticClass:"ql-italic",attrs:{"aria-label":"Italic"}}),_vm._v(" "),_c('button',{staticClass:"ql-underline",attrs:{"aria-label":"Underline"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('select',{staticClass:"ql-color"}),_vm._v(" "),_c('select',{staticClass:"ql-background"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('button',{staticClass:"ql-list",attrs:{"value":"ordered","aria-label":"Ordered List"}}),_vm._v(" "),_c('button',{staticClass:"ql-list",attrs:{"value":"bullet","aria-label":"Unordered List"}}),_vm._v(" "),_c('select',{staticClass:"ql-align"},[_c('option',{attrs:{"selected":""}}),_vm._v(" "),_c('option',{attrs:{"value":"center"}}),_vm._v(" "),_c('option',{attrs:{"value":"right"}}),_vm._v(" "),_c('option',{attrs:{"value":"justify"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('button',{staticClass:"ql-link",attrs:{"aria-label":"Insert Link"}}),_vm._v(" "),_c('button',{staticClass:"ql-image",attrs:{"aria-label":"Insert Image"}}),_vm._v(" "),_c('button',{staticClass:"ql-code-block",attrs:{"aria-label":"Insert Code Block"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ql-formats"},[_c('button',{staticClass:"ql-clean",attrs:{"aria-label":"Remove Styles"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z4Ww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('vf-growl',{attrs:{"value":_vm.msgs,"growlStyle":{top:'100px'}}}),_vm._v(" "),_c('vf-growl',{attrs:{"value":_vm.msgs1,"growlStyle":{top:'100px'},"sticky":true}}),_vm._v(" "),_c('h3',{staticClass:"first"}),_vm._v(" "),_c('p',[_vm._v("The notifications displayed in one place using p-growl component.")]),_vm._v(" "),_c('div',[_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Success"},on:{"click":function($event){_vm.showSuccess()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-info",attrs:{"type":"button","label":"Info"},on:{"click":function($event){_vm.showInfo()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-warning",attrs:{"type":"button","label":"Warn"},on:{"click":function($event){_vm.showWarn()}}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-danger",attrs:{"type":"button","label":"Error"},on:{"click":function($event){_vm.showError()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Multiple"},on:{"click":function($event){_vm.showMultiple()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Sticky"},on:{"click":function($event){_vm.showSticky()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","icon":"fa-close","label":"Clear"},on:{"click":function($event){_vm.clear()}}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Growl")]),_vm._v(" "),_c('span',[_vm._v("Growl is used to display messages in an overlay.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZWGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"content-section implementation"},[_c('h3',{staticClass:"first"},[_vm._v("CSS")]),_vm._v(" "),_c('pre',[_c('code',{directives:[{name:"code",rawName:"v-code"}],staticClass:"language-css"},[_vm._v("\n.ui-datatable table {\n    border-collapse:collapse;\n    width: 100%;\n    table-layout: fixed;\n}\n")]),_vm._v("\n")]),_vm._v(" "),_c('h3',[_vm._v("HTML")]),_vm._v(" "),_c('pre',[_c('code',{directives:[{name:"code",rawName:"v-code"}],staticClass:"language-markup"},[_vm._v("\n<div id=\"pm\" style=\"width:300px\">\n<div>\n<div><a data-icon=\"fa-file-o\">File</a></div>\n<div>\n    <ul>\n        <li><a data-icon=\"fa-plus\">New</a>\n            <ul>\n                <li><a>Project</a></li>\n                <li><a>Other</a></li>\n            </ul>\n        </li>\n        <li><a>Open</a></li>\n        <li><a>Quit</a></li>\n    </ul>\n</div>\n</div>\n</div>\n")]),_vm._v("\n ")]),_vm._v(" "),_c('h3',[_vm._v("Javascript")]),_vm._v(" "),_c('pre',[_c('code',{directives:[{name:"code",rawName:"v-code"}],staticClass:"language-javascript"},[_vm._v("\nvar map;\n    function initMap() {\n        map = new google.maps.Map(document.getElementById('map'), {\n        center: {lat: -34.397, lng: 150.644},\n        zoom: 8\n    });\n}\n")]),_vm._v("\n")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("CodeHighlighter")]),_vm._v(" "),_c('span',[_vm._v("CodeHighlighter CodeHighlighter is an attribute directive to highlight code blocks using PrismJS.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZXpy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZbbW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iQ0hBUlRTIj4KCTxwYXRoIGZpbGw9IiMxQjgyRDciIGQ9Ik02OC44NTEsMjAuNTE0djIzLjM0aDAuMTI0bDE4LjMyMywxNC4yNjdjLTQuMjY5LDUuNTExLTEwLjkzNSw5LjA3NC0xOC40NDcsOS4wNzQKCQljLTEyLjg5MiwwLTIzLjM0LTEwLjQ0OS0yMy4zNC0yMy4zNDFDNDUuNTExLDMwLjk2Myw1NS45NiwyMC41MTQsNjguODUxLDIwLjUxNHoiLz4KCTxyZWN0IHg9IjAuMDE5IiB5PSIzNi45NDkiIGZpbGw9IiMxQjgyRDciIHdpZHRoPSIxMS4wNDUiIGhlaWdodD0iMzAuMjA3Ii8+Cgk8cmVjdCB4PSIxNC43ODgiIHk9IjE2LjIxNiIgZmlsbD0iIzFCODJENyIgd2lkdGg9IjExLjA0NSIgaGVpZ2h0PSI1MC45MzkiLz4KCTxyZWN0IHg9IjI5LjU1NiIgeT0iMjcuMDA4IiBmaWxsPSIjMUI4MkQ3IiB3aWR0aD0iMTEuMDQ1IiBoZWlnaHQ9IjQwLjE0NyIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "ZusN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scrollPage"}},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"form-control"},[_c('span',[_vm._v("Scroll down the window scroll to 200px")]),_c('br'),_vm._v(" "),_vm._m(1),_c('br'),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","onkeypress":"return event.charCode >= 48 && event.charCode <= 57"},model:{value:(_vm.offset),callback:function ($$v) {_vm.offset=$$v},expression:"offset"}})],1),_vm._v(" "),_c('div',{staticClass:"form-control"},[_vm._m(2),_c('br'),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('vf-backToTop',{attrs:{"offset":_vm.offset,"text":_vm.text}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("BackToTop")]),_vm._v(" "),_c('span',[_vm._v("This Back to top link allows users to smoothly scroll back to the top of the page.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_c('strong',[_vm._v("Offset")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_c('strong',[_vm._v("Text")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zwp2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'passworddemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "a/PC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-growl',
  data: function data() {
    return {
      zIndex: 0,

      container: null,

      timeout: null,

      preventRerender: false,

      _value: null,

      _growlStyle: null
    };
  },
  props: {
    sticky: {
      type: Boolean,
      default: false
    },
    life: {
      type: [String, Number],
      default: 3000
    },
    growlStyle: {
      type: Object,
      default: null
    },
    growlStyleClass: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: []
    }
  },
  methods: {
    handleValueChange: function handleValueChange() {
      if (this.preventRerender) {
        this.preventRerender = false;
        return;
      }

      this.zIndex = ++__WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].zindex;
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].fadeIn(this.container, 250);

      if (!this.sticky) {
        this.initTimeout();
      }
    },
    initTimeout: function initTimeout() {
      var _this = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(function () {
        _this.removeAll();
      }, this.life);
    },
    remove: function remove(index) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].fadeOut(this.$refs.msgel, 250);

      setTimeout(function () {
        _this2.preventRerender = true;
        _this2.$emit('onClose', { message: _this2.value[index] });

        _this2._value = _this2.value.filter(function (val, i) {
          return i !== index;
        });
        _this2.$emit('valueChange', _this2._value);
      }, 250);
    },
    removeAll: function removeAll() {
      var _this3 = this;

      if (this.value && this.value.length) {
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].fadeOut(this.container, 250);

        setTimeout(function () {
          _this3.value.forEach(function (msg, index) {
            return _this3.$emit('onClose', { message: _this3.value[index] });
          });
          _this3._value = [];
          _this3.$emit('valueChange', _this3._value);
        }, 250);
      }
    },
    onMessageClick: function onMessageClick(i) {
      this.$emit('onClick', { message: this.value[i] });
    }
  },
  mounted: function mounted() {
    this.container = this.$refs.container;

    if (!this.sticky) {
      this.initTimeout();
    }
  },
  destroyed: function destroyed() {
    if (!this.sticky) {
      clearTimeout(this.timeout);
    }
  },
  updated: function updated() {
    if (this.container) {
      this.handleValueChange();
    }
  },
  watch: {
    value: function value(val) {
      this._value = val;
      if (this.container) {
        this.handleValueChange();
      }
    }
  }
});

/***/ }),

/***/ "a/uE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__("cETb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c66ae780_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__("D47R");
function injectStyle (ssrContext) {
  __webpack_require__("3Hh3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c66ae780_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a0Y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var starsArray = [];
var value = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-rating',
  data: function data() {
    return {
      starsArray: starsArray, value: value
    };
  },
  model: {
    prop: 'model',
    event: 'rating'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    stars: {
      type: Number,
      default: 5
    },
    cancel: {
      type: Boolean,
      default: false
    },
    iconOnClass: {
      type: String,
      default: 'fa-star'
    },
    iconOnStyle: {
      type: String,
      default: null
    },
    iconOffClass: {
      type: String,
      default: 'fa-star-o'
    },
    iconOffStyle: {
      type: String,
      default: null
    },
    iconCancelClass: {
      type: String,
      default: 'fa-ban'
    },
    iconCancelStyle: {
      type: String,
      default: null
    },
    model: {
      type: Number,
      default: 0
    }
  },
  methods: {
    rate: function rate(i) {
      if (!this.readonly && !this.disabled) {
        this.value = i + 1;
        this.$emit('rating', this.value);
      }
      // event.preventDefault();
    },
    clear: function clear(event) {
      if (!this.readonly && !this.disabled) {
        this.value = null;
        this.emit('canceling', event);
      }
      event.preventDefault();
    }
  },
  mounted: function mounted() {
    this.value = this.model;
    this.starsArray = [];
    for (var i = 0; i < this.stars; i++) {
      this.starsArray[i] = i;
    }
  }
});

/***/ }),

/***/ "afjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:['ui-growl ui-widget', _vm.growlStyleClass],style:([_vm.growlStyle, {'zIndex': _vm.zIndex}])},_vm._l((_vm.value),function(msg,index){return _c('div',{ref:"msgel",refInFor:true,class:['ui-growl-item-container ui-state-highlight ui-corner-all ui-shadow', {'ui-growl-message-info':msg.severity == 'info','ui-growl-message-warn':msg.severity == 'warn',
                  'ui-growl-message-error':msg.severity == 'error','ui-growl-message-success':msg.severity == 'success'}],attrs:{"aria-live":"polite"},on:{"click":function($event){_vm.onMessageClick(index)}}},[_c('div',{staticClass:"ui-growl-item"},[_c('div',{staticClass:"ui-growl-icon-close fa fa-close",on:{"click":function($event){_vm.remove(index)}}}),_vm._v(" "),_c('span',{class:['ui-growl-image fa fa-2x', {'fa-info-circle':msg.severity == 'info','fa-exclamation-circle':msg.severity == 'warn',
                              'fa-close':msg.severity == 'error','fa-check':msg.severity == 'success'}]}),_vm._v(" "),_c('div',{staticClass:"ui-growl-message"},[_c('span',{staticClass:"ui-growl-title"},[_vm._v(_vm._s(msg.summary))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(msg.detail)}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aj/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-sidebar',
  props: {
    position: {
      type: String,
      default: 'left'
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    appendTo: {
      type: String,
      default: null
    },
    blockScroll: {
      type: Boolean,
      default: false
    },
    sidebarStyle: {
      type: String,
      default: null
    },
    sidebarStyleClass: {
      type: String,
      default: null
    },
    autoZIndex: {
      type: Boolean,
      default: true
    },
    baseZIndex: {
      type: [Number, String],
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      initialized: false,

      _visible: false,

      preventVisibleChangePropagation: false,

      mask: null,

      executePostDisplayActions: false

    };
  },

  watch: {
    visible: function visible(val) {
      this._visible = val;
      if (this.initialized && this.$refs.container) {
        if (this._visible) {
          this.show();
        } else {
          if (this.preventVisibleChangePropagation) {
            this.preventVisibleChangePropagation = false;
          } else {
            this.hide();
          }
        }
      }
    }
  },
  methods: {
    show: function show() {
      this.executePostDisplayActions = true;
      if (this.autoZIndex) {
        this.$refs.container.style.zIndex = String(this.baseZIndex + ++__WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].zindex);
      }
      this.enableModality();
    },
    hide: function hide() {
      this.$emit('hide', {});
      this.disableModality();
    },
    close: function close(event) {
      this.preventVisibleChangePropagation = true;
      this.hide();
      this.$emit('visibleChange', false);
      this.$refs.container.style.opacity = 0;
      this._visible = false;
      event.preventDefault();
    },
    enableModality: function enableModality() {
      var _this = this;

      if (!this.mask) {
        this.mask = document.createElement('div');
        this.mask.style.zIndex = String(parseInt(this.$refs.container.style.zIndex) - 1);
        this.mask.setAttribute('id', 'maskElement');
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].addMultipleClasses(this.mask, 'ui-widget-overlay ui-sidebar-mask');
        this.mask.addEventListener('click', function (event) {
          _this.close(event);
        });
        document.body.appendChild(this.mask);
        if (this.blockScroll) {
          __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].addClass(document.body, 'ui-overflow-hidden');
        }
      }
    },
    disableModality: function disableModality() {
      if (this.mask) {
        this.unbindMaskClickListener();
        document.body.removeChild(this.mask);
        if (this.blockScroll) {
          __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].removeClass(document.body, 'ui-overflow-hidden');
        }
        this.mask = null;
      }
    },
    unbindMaskClickListener: function unbindMaskClickListener() {
      if (this.mask) {
        this.mask.removeEventListener('click', null);
      }
    }
  },
  mounted: function mounted() {
    this.initialized = true;

    if (this.appendTo) {
      if (this.appendTo === 'body') {
        document.body.appendChild(this.$refs.container);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].appendChild(this.$refs.container, this.appendTo);
      }
    }

    if (this.visible) {
      this.show();
    }
  },
  updated: function updated() {
    if (this.executePostDisplayActions) {
      this.$emit('show', {});
      this.executePostDisplayActions = false;
    }
  },
  destroyed: function destroyed() {
    this.initialized = false;

    if (this.visible) {
      this.hide();
    }

    if (this.appendTo) {
      document.body.removeChild(this.$refs.container);
    }

    this.unbindMaskClickListener();
  }
});

/***/ }),

/***/ "avq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Numbers")]),_vm._v(" "),_c('vf-badge',{attrs:{"value":100}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-up","label":"Likes"}})],1),_vm._v(" "),_c('vf-badge',{attrs:{"value":50}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-down","label":"Dislikes"}})],1),_vm._v(" "),_c('h3',{staticClass:"first"},[_vm._v("Color")]),_vm._v(" "),_c('vf-badge',{attrs:{"value":100,"backgroundColor":"red"}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-up","label":"Likes"}})],1),_vm._v(" "),_c('vf-badge',{attrs:{"value":50,"backgroundColor":"blue"}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-down","label":"Dislikes"}})],1),_vm._v(" "),_c('h3',[_vm._v("Max")]),_vm._v(" "),_c('vf-badge',{attrs:{"value":200,"max":100}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-up","label":"Likes"}})],1),_vm._v(" "),_c('vf-badge',{attrs:{"value":100,"max":50}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-thumbs-down","label":"Dislikes"}})],1),_vm._v(" "),_c('h3',[_vm._v("Text")]),_vm._v(" "),_c('vf-badge',{attrs:{"value":"new"}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-comments","label":"Comments"}})],1),_vm._v(" "),_c('vf-badge',{attrs:{"value":"old"}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-comments","label":"Comments"}})],1),_vm._v(" "),_c('h3',[_vm._v("Notify")]),_vm._v(" "),_c('vf-badge',{attrs:{"dot":true}},[_c('vf-button',{attrs:{"type":"button","label":"Alert"}})],1),_vm._v(" "),_c('vf-badge',{attrs:{"dot":true}},[_c('vf-button',{attrs:{"type":"button","icon":"fa-exclamation-circle"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Badge")]),_vm._v(" "),_c('span',[_vm._v("A number or status mark on form components.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b/PY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as horizontalBar(type=\"horizontalBar\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"horizontalBar","data":_vm.horizontalBarData,"width":"100","height":"20"}},[_vm._v(">")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("HorizontalBarChart")]),_vm._v(" "),_c('span',[_vm._v("A horizontal bar chart is a variation on a vertical bar chart. It is sometimes used to show trend data, and the comparison of multiple data sets side by side.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bCLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

var Chart = __webpack_require__("ikxi");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-charts',
  data: function data() {
    return {};
  },
  props: {
    width: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    options: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  methods: {
    onCanvasClick: function onCanvasClick(event) {
      if (this.chart) {
        var element = this.chart.getElementAtEvent(event);
        var dataset = this.chart.getDatasetAtEvent(event);
        if (element && element[0] && dataset) {
          this.$emit('onDataSelect', { originalEvent: event, element: element[0], dataset: dataset });
        }
      }
    },
    initChart: function initChart() {
      this.chart = new Chart(this.getCanvas(), {
        type: this.type,
        data: this.data,
        options: this.options
      });
    },
    getCanvas: function getCanvas() {
      return this.$refs.chart.children[0];
    },
    getBase64Image: function getBase64Image() {
      return this.chart.toBase64Image();
    },
    generateLegend: function generateLegend() {
      if (this.chart) {
        this.chart.generateLegend();
      }
    },
    refresh: function refresh() {
      if (this.chart) {
        this.chart.update();
      }
    },
    reinit: function reinit() {
      if (this.chart) {
        this.chart.destroy();
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    this.initChart();
  }
});

/***/ }),

/***/ "bPOf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c7s5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tristatecheckbox_vue__ = __webpack_require__("3xuk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c194fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tristatecheckbox_vue__ = __webpack_require__("hsQg");
function injectStyle (ssrContext) {
  __webpack_require__("ksO3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tristatecheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c194fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tristatecheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cETb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-button',
  data: function data() {
    return {
      cornerStyleClass: 'ui-corner-all'
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    }
  },
  mounted: function mounted() {
    if (this.icon) {
      var iconElement = document.createElement('span');
      var iconPosClass = this.iconPos === 'right' ? 'ui-button-icon-right' : 'ui-button-icon-left';
      iconElement.className = iconPosClass + ' ui-clickable fa fa-fw ' + this.icon;
      this.$el.appendChild(iconElement);
    }

    var labelElement = document.createElement('span');
    labelElement.className = 'ui-button-text ui-clickable';
    labelElement.appendChild(document.createTextNode(this.label || 'ui-btn'));
    this.$el.appendChild(labelElement);
    // this.initialized = true;
  },
  computed: {
    styleClass: function styleClass() {
      var styleClass = 'ui-button ui-widget ui-state-default ' + this.cornerStyleClass;
      if (this.icon) {
        if (this.label != null && this.label !== undefined) {
          if (this.iconPos === 'left') {
            styleClass = styleClass + ' ui-button-text-icon-left';
          } else {
            styleClass = styleClass + ' ui-button-text-icon-right';
          }
        } else {
          styleClass = styleClass + ' ui-button-icon-only';
        }
      } else {
        styleClass = styleClass + ' ui-button-text-only';
      }

      return styleClass;
    }
  }
});

/***/ }),

/***/ "cI7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horizontalbarchartdemo_vue__ = __webpack_require__("5zFn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db3aefe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_horizontalbarchartdemo_vue__ = __webpack_require__("b/PY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horizontalbarchartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db3aefe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_horizontalbarchartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cczm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Dynamic")]),_vm._v("\n      The progress bar is displayed with dynamic value\n      "),_c('vf-progressBar',{attrs:{"value":_vm.value}}),_vm._v(" "),_c('h3',[_vm._v("2. Static")]),_vm._v("\n      The progress bar is displayed with static value\n     "),_c('vf-progressBar',{attrs:{"value":50}}),_vm._v(" "),_c('h3',[_vm._v("3. Indeterminate")]),_vm._v("\n      The progress bar displayed without any bound using mode attribute instead of showing the value between 0 and 100\n      "),_c('vf-progressBar',{style:({'height': '6px'}),attrs:{"mode":"indeterminate"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("ProgressBar")]),_vm._v(" "),_c('span',[_vm._v("ProgressBar is a process status indicator.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "creL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as pieData(type=\"pieData\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"pie","data":_vm.pieData,"width":"100","height":"20"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("PieChart")]),_vm._v(" "),_c('span',[_vm._v("A pie chart is a circular statistical graphic, which is divided into slices to illustrate numerical proportion.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cthI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotop_vue__ = __webpack_require__("LkQg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42675979_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotop_vue__ = __webpack_require__("FHVX");
function injectStyle (ssrContext) {
  __webpack_require__("fcKA")
  __webpack_require__("fmvX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42675979_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d0EF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_vue__ = __webpack_require__("vIIL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589168c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_vue__ = __webpack_require__("+STB");
function injectStyle (ssrContext) {
  __webpack_require__("Ft+r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589168c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dHM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The basic fieldset component displays the content with a legend.")]),_vm._v(" "),_c('vf-fieldset',{style:({'margin-bottom':'20px'}),attrs:{"legend":"Godfather I"}},[_vm._v("\n        The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding.\n His beloved son Michael has just come home from the war, but does not intend to become part of his father's business.\n Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family,\n kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n\n      ")]),_vm._v(" "),_c('h3',[_vm._v("2. Toggleable")]),_vm._v(" "),_c('p',[_vm._v("The fieldset component displays the content with a toggleable legend.")]),_vm._v(" "),_c('vf-fieldset',{style:({'margin-bottom':'20px'}),attrs:{"legend":"Godfather II","toggleable":true}},[_vm._v("\n        The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding.\n His beloved son Michael has just come home from the war, but does not intend to become part of his father's business.\n Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family,\n kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n      ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Fieldset")]),_vm._v(" "),_c('span',[_vm._v("Fieldset is a grouping component with a content toggle feature.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dIqr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dNsU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "daQr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dmfF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dy4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minusplus_vue__ = __webpack_require__("SHej");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e974b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minusplus_vue__ = __webpack_require__("n/XO");
function injectStyle (ssrContext) {
  __webpack_require__("UPTn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_minusplus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e974b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_minusplus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eML1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('vf-inputText',{attrs:{"id":"input","type":"text","size":"30"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_vm._v(" "),_c('span',{attrs:{"id":"text"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('h3',[_vm._v("Float Label")]),_vm._v(" "),_c('span',{staticClass:"ui-float-label"},[_c('vf-inputText',{attrs:{"id":"float-input","type":"text","size":"30"}}),_vm._v(" "),_c('label',{attrs:{"for":"float-input"}},[_vm._v("Username")])],1),_vm._v(" "),_c('h3',[_vm._v("Disabled")]),_vm._v(" "),_c('vf-inputText',{attrs:{"id":"disabled-input","type":"text","size":"30","disabled":_vm.disabled}}),_vm._v(" "),_c('vf-button',{attrs:{"id":"disabled-btn","type":"button","label":"Toggle"},on:{"click":_vm.toggleDisabled}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("InputText")]),_vm._v(" "),_c('span',[_vm._v("InputText is an extension to standard input element with theming.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eMof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eRTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as doughnut(type=\"doughnut\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"doughnut","data":_vm.doughnutData,"width":"100","height":"20"}},[_vm._v(">")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("DoughnutChart")]),_vm._v(" "),_c('span',[_vm._v("A doughnut chart is a variant of the pie chart, with a blank center allowing for additional information about the data as a whole to be included.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eT9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fieldsetdemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "eTvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglebutton_vue__ = __webpack_require__("sGQm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b74cf2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglebutton_vue__ = __webpack_require__("hx58");
function injectStyle (ssrContext) {
  __webpack_require__("S34Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglebutton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b74cf2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglebutton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "erfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var pieData = {
  labels: ['VueJS', 'Angular', 'ReactJS'],
  datasets: [{
    data: [35, 35, 30],
    backgroundColor: ["#886384", "#12A2EB", "#FFCE56"],
    hoverBackgroundColor: ["#126384", "#CDA2EB", "#FFCE56"]
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'piechartdemo',
  data: function data() {
    return {
      pieData: pieData
    };
  }
});

/***/ }),

/***/ "f/vl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui-avatar', _vm.avatarStyleClass],style:([_vm.avatarStyle, {'color': _vm.color, 'background-color': _vm.backgroundColor}]),on:{"click":_vm.handleClick}},[_c('div',{staticClass:"ui-avatar-content"},[(_vm.icon)?_c('i',{class:['fa', _vm.icon, _vm.iconClass]}):_vm._e(),_vm._v(" "),(_vm.src)?_c('img',{class:['ui-image',_vm.imageClass],attrs:{"src":_vm.src}}):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f4fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_piechartdemo_vue__ = __webpack_require__("erfn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27fb46e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_piechartdemo_vue__ = __webpack_require__("creL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_piechartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c27fb46e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_piechartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fHj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'buttondemo',
  data: function data() {
    return {};
  },

  methods: {
    clickMe: function clickMe(event) {
      if (event) {
        alert(event.target.innerText);
      }
    }
  }
});

/***/ }),

/***/ "fMPF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fVev":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__ = __webpack_require__("gSuX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fbba0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__ = __webpack_require__("0wxG");
function injectStyle (ssrContext) {
  __webpack_require__("AZ2a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fbba0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcKA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-inplace',
  props: {
    active: Boolean,
    closable: Boolean,
    disabled: Boolean,
    inplaceStyle: String,
    inplaceStyleClass: String
  },
  data: function data() {
    return {
      hover: false,
      isActive: this.active
    };
  },

  methods: {
    activate: function activate(event) {
      if (!this.disabled) {
        this.isActive = true;
        this.$emit('activate', event);
      }
    },
    deactivate: function deactivate(event) {
      if (!this.disabled) {
        this.isActive = false;
        this.hover = false;
        this.$emit('deactivate', event);
      }
    }
  }
});

/***/ }),

/***/ "fmvX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g8lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordiontab_vue__ = __webpack_require__("2H7Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_581864e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordiontab_vue__ = __webpack_require__("yg1F");
function injectStyle (ssrContext) {
  __webpack_require__("28x0")
  __webpack_require__("Xl0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordiontab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_581864e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordiontab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gGBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The basic panel component displays the content with a header.")]),_vm._v(" "),_c('vf-panel',{style:({'margin-bottom':'20px'}),attrs:{"header":"Godfather I","toggleable":true}},[_vm._v("\n        The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding.\n His beloved son Michael has just come home from the war, but does not intend to become part of his father's business.\n Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family,\n kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n\n      ")]),_vm._v(" "),_c('h3',[_vm._v("2. Customization")]),_vm._v(" "),_c('p',[_vm._v("The panel component customized with header and footer slots.")]),_vm._v(" "),_c('vf-panel',{style:({'margin-bottom':'20px'})},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"ui-helper-clearfix"},[_c('span',{staticClass:"ui-panel-title",staticStyle:{"font-size":"16px","display":"inline-block","margin-top":"2px"}},[_vm._v("Custom Header")]),_vm._v(" "),_c('vf-button',{style:({'float':'right'}),attrs:{"label":"Save","icon":"fa-check"}})],1)]),_vm._v("\n        The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding.\n His beloved son Michael has just come home from the war, but does not intend to become part of his father's business.\n Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family,\n kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n\n        "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"ui-helper-clearfix"},[_c('vf-button',{style:({'float':'left'}),attrs:{"label":"New","icon":"fa-plus"}}),_vm._v(" "),_c('vf-button',{style:({'float':'right'}),attrs:{"label":"Delete","icon":"fa-close"}})],1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Panel")]),_vm._v(" "),_c('span',[_vm._v("Panel is a grouping component providing with content toggle feature.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gSuX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-spinner',
  props: {
    value: {
      type: [Number, String]
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    maxlength: {
      type: Number
    },
    size: {
      type: Number
    },
    placeholder: {
      type: String
    },
    inputId: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    },
    decimalSeparator: {
      type: String,
      default: '.'
    },
    thousandSeparator: {
      type: String,
      default: ','
    },
    tabindex: {
      type: Number
    },
    formatInput: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      filled: false,
      newValue: this.value,
      valueAsString: null,
      keyPattern: new RegExp('/[0-9\+\-]/'),
      precision: null,
      timer: null,
      focus: false
    };
  },

  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.formatValue();
      this.updateFilled(value);
      this.$emit('input', value);
    }
  },
  methods: {
    updateFilled: function updateFilled(value) {
      this.filled = value && value.length;
    },
    repeat: function repeat(event, interval, dir) {
      var _this = this;

      var i = interval || 500;

      this.clearTimer();
      this.timer = setTimeout(function () {
        _this.repeat(event, 40, dir);
      }, i);

      this.spin(event, dir);
    },
    spin: function spin(event, dir) {
      var step = this.step * dir;
      var currentValue = this.newValue || 0;

      if (this.precision) {
        this.newValue = parseFloat(this.toFixed(currentValue + step, this.precision));
      } else {
        this.newValue = currentValue + step;
      }

      if (this.maxlength !== undefined && this.newValue.toString().length > this.maxlength) {
        this.newValue = currentValue;
      }

      if (this.min !== undefined && this.newValue < this.min) {
        this.newValue = this.min;
      }

      if (this.max !== undefined && this.newValue > this.max) {
        this.newValue = this.max;
      }

      this.formatValue();
      this.$emit('change', event);
    },
    toFixed: function toFixed(value, precision) {
      var power = Math.pow(10, precision || 0);
      return String(Math.round(value * power) / power);
    },
    onUpButtonMousedown: function onUpButtonMousedown(event) {
      if (!this.disabled) {
        this.$refs.inputfield.focus();
        this.repeat(event, null, 1);
        this.updateFilled();
      }
    },
    onUpButtonMouseup: function onUpButtonMouseup(event) {
      if (!this.disabled) {
        this.clearTimer();
      }
    },
    onUpButtonMouseleave: function onUpButtonMouseleave(event) {
      if (!this.disabled) {
        this.clearTimer();
      }
    },
    onDownButtonMousedown: function onDownButtonMousedown(event) {
      if (!this.disabled) {
        this.$refs.inputfield.focus();
        this.repeat(event, null, -1);
        this.updateFilled();
      }
    },
    onDownButtonMouseup: function onDownButtonMouseup(event) {
      if (!this.disabled) {
        this.clearTimer();
      }
    },
    onDownButtonMouseleave: function onDownButtonMouseleave(event) {
      if (!this.disabled) {
        this.clearTimer();
      }
    },
    onInputKeydown: function onInputKeydown(event) {
      if (event.which === 38) {
        this.spin(event, 1);
        event.preventDefault();
      } else if (event.which === 40) {
        this.spin(event, -1);
        event.preventDefault();
      }
    },
    onInputKeyPress: function onInputKeyPress(event) {
      var inputChar = String.fromCharCode(event.charCode);
      if (!this.keyPattern.test(inputChar) && inputChar !== this.decimalSeparator && event.keyCode !== 9 && event.keyCode !== 8 && event.keyCode !== 37 && event.keyCode !== 39 && event.keyCode !== 46) {
        event.preventDefault();
      }
    },
    onInputKeyup: function onInputKeyup(event) {
      this.newValue = this.parseValue(event.target.value);
      this.formatValue();
      this.updateFilled();
    },
    onInputBlur: function onInputBlur(event) {
      this.focus = false;
      this.$emit('blur', event);
    },
    onInputFocus: function onInputFocus(event) {
      this.focus = true;
      this.$emit('focus', event);
    },
    parseValue: function parseValue(val) {
      var value = void 0;

      if (this.formatInput) {
        val = val.split(this.thousandSeparator).join('');
      }

      if (val.trim() === '') {
        value = null;
      } else {
        if (this.precision) {
          value = parseFloat(val.replace(',', '.'));
        } else {
          value = parseInt(val);
        }

        if (!isNaN(value)) {
          if (this.max !== undefined && value > this.max) {
            value = this.max;
          }

          if (this.min !== undefined && value < this.min) {
            value = this.min;
          }
        } else {
          value = null;
        }
      }

      return value;
    },
    formatValue: function formatValue() {
      if (this.newValue !== null && this.newValue !== undefined) {
        var textValue = String(this.newValue).replace('.', this.decimalSeparator);

        if (this.formatInput) {
          textValue = textValue.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandSeparator);
        }

        this.valueAsString = textValue;
      } else {
        this.valueAsString = '';
      }

      this.$refs.inputfield.value = this.valueAsString;
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event);
    },
    clearTimer: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  },
  mounted: function mounted() {
    this.updateFilled(this.newValue);
    this.formatValue();
    if (Math.floor(this.step) === 0) {
      this.precision = this.step.toString().split(/[,]|[.]/)[1].length;
    }
  }
});

/***/ }),

/***/ "getA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollpaneldemo_vue__ = __webpack_require__("OqFQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4da230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollpaneldemo_vue__ = __webpack_require__("X42f");
function injectStyle (ssrContext) {
  __webpack_require__("+w7j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollpaneldemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4da230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollpaneldemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjUc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gky/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressspinnerdemo_vue__ = __webpack_require__("0VG/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263b2902_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressspinnerdemo_vue__ = __webpack_require__("pvO3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressspinnerdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263b2902_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressspinnerdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h1RH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer-layout'
});

/***/ }),

/***/ "hMVA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputplacedemo',
  data: function data() {
    return {
      text: 'VueFace',
      closable: true
    };
  }
});

/***/ }),

/***/ "hsQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-chkbox ui-tristatechkbox ui-widget",class:_vm.checkboxStyleClass,style:(_vm.checkboxStyle)},[_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',{ref:"input",attrs:{"type":"text","id":_vm.inputId,"name":_vm.name,"tabindex":_vm.tabindex,"readonly":"","disabled":_vm.disabled},on:{"keyup":function($event){_vm.onKeyup($event)},"keydown":function($event){_vm.onKeydown($event)},"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()}}})]),_vm._v(" "),_c('div',{staticClass:"ui-chkbox-box ui-widget ui-corner-all ui-state-default",class:{'ui-state-active':_vm.value!=null,'ui-state-disabled':_vm.disabled,'ui-state-focus':_vm.focus},on:{"click":function($event){_vm.onClick($event)}}},[_c('span',{staticClass:"ui-chkbox-icon fa ui-clickable",class:{'fa-check':_vm.value==true,'fa-close':_vm.value==false}})])]),_vm._v(" "),(_vm.label)?_c('label',{staticClass:"ui-chkbox-label",attrs:{"cass":{'ui-label-active':_vm.value!=null, 'ui-label-disabled':_vm.disabled, 'ui-label-focus':_vm.focus},"for":_vm.inputId},on:{"click":function($event){_vm.onClick($event,_vm.input)}}},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hx58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'ui-button ui-togglebutton ui-widget ui-state-default ui-corner-all': true, 'ui-button-text-only': (!_vm.onIcon&&!_vm.offIcon),
              'ui-button-text-icon-left': (_vm.onIcon&&_vm.offIcon&&_vm.hasOnLabel()&&_vm.hasOffLabel()), 'ui-button-icon-only': (_vm.onIcon&&_vm.offIcon&&!_vm.hasOnLabel()&&!_vm.hasOffLabel()),
              'ui-state-active': _vm.checked,'ui-state-focus':_vm.focus,'ui-state-disabled':_vm.disabled, buttonStyleClass: true},style:(_vm.buttonStyle),on:{"click":function($event){_vm.toggle($event)}}},[_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',{ref:"cb",attrs:{"name":_vm.name,"type":"checkbox","id":_vm.inputId,"tabindex":_vm.tabindex},domProps:{"checked":_vm.checked},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()}}})]),_vm._v(" "),(_vm.onIcon||_vm.offIcon)?_c('span',{class:_vm.getIconClass()}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ui-button-text ui-unselectable-text"},[_vm._v(_vm._s(_vm.checked ? _vm.hasOnLabel() ? this.onLabel : 'ui-btn' : _vm.hasOffLabel() ? this.offLabel : 'ui-btn'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iPUH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iREFUQSI+Cgk8ZWxsaXBzZSBmaWxsPSIjMUI4MkQ3IiBjeD0iNDMuNjU5IiBjeT0iMjIuMTUiIHJ4PSI0My42MTYiIHJ5PSIxNi4zIi8+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNMC4wNDMsMjkuMjVjMCwwLDYuNTQ4LDE0LjE5NSw0My42MTYsMTQuMTk1YzM3LjA2NywwLDQzLjYxNi0xNC4xOTUsNDMuNjE2LTE0LjE5NXY4LjIxOAoJCWMwLDAtNy45NjksMTQuMTk1LTQzLjYxNiwxNC4xOTVjLTM1LjY0NiwwLTQzLjYxNi0xMy45NDYtNDMuNjE2LTEzLjk0NlYyOS4yNXoiLz4KCTxwYXRoIGZpbGw9IiMxQjgyRDciIGQ9Ik0wLjA0Myw0Mi4xOTljMCwwLDYuNTQ4LDE0LjE5NSw0My42MTYsMTQuMTk1YzM3LjA2NywwLDQzLjYxNi0xNC4xOTUsNDMuNjE2LTE0LjE5NXY4LjIxOQoJCWMwLDAtNy45NjksMTQuMTkzLTQzLjYxNiwxNC4xOTNjLTM1LjY0NiwwLTQzLjYxNi0xMy45NDUtNDMuNjE2LTEzLjk0NVY0Mi4xOTl6Ii8+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNMC4wNDMsNTUuMTQ5YzAsMCw2LjU0OCwxNC4xOTMsNDMuNjE2LDE0LjE5M2MzNy4wNjcsMCw0My42MTYtMTQuMTkzLDQzLjYxNi0xNC4xOTN2OC4yMTkKCQljMCwwLTcuOTY5LDE0LjE5My00My42MTYsMTQuMTkzYy0zNS42NDYsMC00My42MTYtMTMuOTQ1LTQzLjYxNi0xMy45NDVWNTUuMTQ5eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "iSi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"galleria",staticClass:"ui-galleria ui-widget ui-widget-content ui-corner-all",class:_vm.galleriaStyleClass,style:(_vm.galleriaStyle)},[_c('ul',{staticClass:"ui-galleria-panel-wrapper",style:({width:_vm.panelWidth + 'px', height: _vm.panelHeight + 'px'})},_vm._l((_vm.images),function(image,i){return _c('li',{staticClass:"ui-galleria-panel",class:{'ui-helper-hidden':i!=_vm.activeIndex},style:({width:_vm.panelWidth + 'px', height: _vm.panelHeight + 'px'}),on:{"click":function($event){_vm.clickImage($event,image,i)}}},[_c('img',{staticClass:"ui-panel-images",attrs:{"src":image.source,"alt":image.alt,"title":image.title}})])})),_vm._v(" "),(_vm.showFilmstrip)?_c('div',{staticClass:"ui-galleria-filmstrip-wrapper"},[_c('ul',{staticClass:"ui-galleria-filmstrip",style:({transition:'left 1s',left: _vm.stripLeft + 'px'})},_vm._l((_vm.images),function(image,i){return _c('li',{ref:"frame",refInFor:true,staticClass:"ui-galleria-frame",class:{'ui-galleria-frame-active':i==_vm.activeIndex},style:({width:_vm.frameWidth + 'px', height: _vm.frameHeight + 'px', transition: 'opacity 0.75s ease'}),on:{"click":function($event){_vm.frameClick(_vm.frame)}}},[_c('div',{staticClass:"ui-galleria-frame-content"},[_c('img',{staticClass:"ui-galleria-frame-image",style:({width:_vm.frameWidth + 'px', height: _vm.frameHeight + 'px'}),attrs:{"src":image.source,"alt":image.alt,"title":image.title}})])])}))]):_vm._e(),_vm._v(" "),(_vm.activeIndex !== 0)?_c('div',{staticClass:"ui-galleria-nav-prev fa fa-fw fa-chevron-circle-left",style:({bottom: _vm.frameHeight/2 +'px'}),on:{"click":function($event){_vm.clickNavLeft()}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui-galleria-nav-next fa fa-fw fa-chevron-circle-right",style:({bottom: _vm.frameHeight/2 +'px'}),on:{"click":function($event){_vm.clickNavRight()}}}),_vm._v(" "),(_vm.showCaption&&_vm.images)?_c('div',{staticClass:"ui-galleria-caption",staticStyle:{"display":"block"}},[_c('h4',[_vm._v(_vm._s(_vm.images[_vm.activeIndex] ? _vm.images[_vm.activeIndex].title : ''))]),_c('p',[_vm._v(_vm._s(_vm.images[_vm.activeIndex] ? _vm.images[_vm.activeIndex].alt : ''))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iaRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminaldemo_vue__ = __webpack_require__("4cfm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3372a6ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminaldemo_vue__ = __webpack_require__("DL0P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminaldemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3372a6ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminaldemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ij7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__ = __webpack_require__("XHuI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d513dca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__ = __webpack_require__("f/vl");
function injectStyle (ssrContext) {
  __webpack_require__("YNGN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d513dca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-widget ui-corner-all"},[_c('canvas',{ref:"qrcode"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ilI2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iSU5QVVQiPgoJPHBhdGggZmlsbD0iIzg4OTU5NyIgZD0iTTg3LjIzMiw1Ny42MTFIMC4wODZWMjUuOGg4Ny4xNDZWNTcuNjExeiBNMy45MDMsNTMuNzkzaDc5LjUxMlYyOS42MTdIMy45MDNWNTMuNzkzeiIvPgoJPGc+CgkJPHBhdGggZmlsbD0iIzg4OTU5NyIgZD0iTTguMjEyLDM5LjE4NmMxLjMyMy0wLjUyNCwzLjA5Mi0wLjc4Nyw1LjMwMy0wLjc4N2MxLjMzOCwwLDIuMzY2LDAuMjgxLDMuMDg2LDAuODQxCgkJCWMwLjcyMSwwLjU2MiwxLjA4MSwxLjUyNCwxLjA4MSwyLjg5djguMDc2SDE1LjI2bC0wLjYzMy0xLjI2OWMtMC4wNiwwLjEwNC0wLjI0NCwwLjI2MS0wLjU1OCwwLjQ3CgkJCWMtMC4zMTIsMC4yMTEtMC43NDYsMC40Mi0xLjI5NywwLjYyM2MtMC41NTUsMC4yMDMtMS4wODUsMC4zMDctMS41OTMsMC4zMDdjLTEuMDc3LDAtMS45MDYtMC4zMTEtMi40ODgtMC45MwoJCQljLTAuNTgyLTAuNjE3LTAuODczLTEuMzM0LTAuODczLTIuMTQ4di0xLjA5YzAtMC45MzEsMC4yNzUtMS42OTUsMC44My0yLjI5M2MwLjU1My0wLjU5NCwxLjQwMi0wLjg5LDIuNTUzLTAuODgzCgkJCWMxLjE0OSwwLjAwOCwyLjAwNywwLjAxMiwyLjU3NSwwLjAxMmMwLjU2NywwLDAuODUxLTAuMDA4LDAuODUxLTAuMDIxYzAtMC4yMzMsMC0wLjQxMSwwLTAuNTM0YzAtMC4xMjUsMC0wLjE5MywwLTAuMjA3CgkJCWMwLTAuNTgzLTAuMTI0LTAuOTY2LTAuMzcxLTEuMTQ2Yy0wLjI0OC0wLjE4My0wLjc0MS0wLjI3Mi0xLjQ4Mi0wLjI3MmMtMC43NDMsMC0yLjI2NCwwLjA4LTQuNTYyLDAuMjM5VjM5LjE4NnogTTEwLjg3NCw0Ni44MjEKCQkJYzAsMC40MzgsMC4wOTQsMC43MjUsMC4yODMsMC44NjJjMC4xODksMC4xNCwwLjQ2NiwwLjIwNiwwLjgzLDAuMjA2czAuNzY3LTAuMDc2LDEuMjExLTAuMjI5CgkJCWMwLjQ0My0wLjE1MiwwLjc4OS0wLjMwMSwxLjAzNi0wLjQ0NWwwLjM5NC0wLjI0MXYtMi4xMTZsLTIuODE0LDAuMjE5Yy0wLjYyNiwwLjA1OS0wLjkzOCwwLjQ1LTAuOTM4LDEuMThMMTAuODc0LDQ2LjgyMQoJCQlMMTAuODc0LDQ2LjgyMXoiLz4KCQk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMjIuNTI2LDMzLjA3NXY2LjEzMmMxLjA5MS0wLjUxLDIuMjYxLTAuNzY0LDMuNTEyLTAuNzY0YzEuMDYyLDAsMS44NjIsMC4yNTQsMi40MDEsMC43NjQKCQkJYzAuNTY2LDAuNTIzLDAuOTM4LDEuMjIyLDEuMTEyLDIuMDk0YzAuMTc2LDAuODU5LDAuMjYzLDEuOTE1LDAuMjYzLDMuMTY1YzAsMS44NzctMC4yOTIsMy4zMjQtMC44NzMsNC4zNDMKCQkJcy0xLjU0OSwxLjUyNi0yLjkwMiwxLjUyNmMtMC42MjQsMC0xLjI1OC0wLjEzMS0xLjg5Ni0wLjM5MmMtMC42NDItMC4yNjMtMS4xNzEtMC41NjctMS41OTUtMC45MTlsLTAuNTQ0LDEuMThoLTIuNTExVjMzLjA3NQoJCQlIMjIuNTI2eiBNMjUuMjUzLDQ3LjcxN2MwLjUxLDAsMC44ODgtMC4yNTIsMS4xMzYtMC43NTRjMC4yNDUtMC41MDIsMC4zNjktMS4zMDMsMC4zNjktMi4zOThjMC0xLjEtMC4wNjItMS45MS0wLjE4Ni0yLjQzNgoJCQljLTAuMTIzLTAuNTIxLTAuMjg3LTAuODY3LTAuNDkxLTEuMDM1Yy0wLjIwMy0wLjE2Ni0wLjQ3OS0wLjI1MS0wLjgyOS0wLjI1MWMtMS4wNjIsMC0xLjk2MywwLjE0NS0yLjcwNywwLjQzOHY1LjczOQoJCQlDMjMuMjksNDcuNDgzLDI0LjE5MSw0Ny43MTcsMjUuMjUzLDQ3LjcxN3oiLz4KCQk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMzEuNDUsNDQuMzk4YzAtMS4xNjMsMC4wOS0yLjE0MiwwLjI3My0yLjkzM2MwLjE4MS0wLjc5NCwwLjQ1LTEuMzk4LDAuODA3LTEuODEyCgkJCWMwLjM1Ni0wLjQxNSwwLjc1Mi0wLjcxLDEuMTg5LTAuODg1YzAuNDM3LTAuMTczLDAuOTUyLTAuMjYxLDEuNTQ5LTAuMjYxYzIuMTM4LDAsMy45MTMsMC4yMjYsNS4zMjIsMC42Nzd2MS44OTgKCQkJYy0xLjM4MS0wLjA4OS0yLjQ4My0wLjEzMi0zLjMwNS0wLjEzMmMtMC44MjIsMC0xLjMxNiwwLjAxNC0xLjQ4NCwwLjA0M2MtMC4xNjcsMC4wMy0wLjM1NCwwLjEwMy0wLjU1NywwLjIxOAoJCQljLTAuMjAzLDAuMTE4LTAuMzQ5LDAuMjk5LTAuNDM2LDAuNTQ4Yy0wLjIwNCwwLjU5Ni0wLjMwNywxLjQ0My0wLjMwNywyLjU0MWMwLDEuMSwwLjA2OCwxLjg4OSwwLjIwNywyLjM2NwoJCQljMC4xNCwwLjQ4LDAuMzQyLDAuNzk3LDAuNjEsMC45NDljMC4yNywwLjE1MiwwLjY5NSwwLjIyOSwxLjI3NywwLjIyOWMxLjE3OCwwLDIuMzYzLTAuMDUxLDMuNTU3LTAuMTVsMC41ODgtMC4wNDV2MS45MjIKCQkJYy0wLjY2OSwwLjM0OC0xLjMyMywwLjU1My0xLjk2NCwwLjYwOWMtMC45NDYsMC4wODgtMS43NjYsMC4xMzEtMi40NjUsMC4xMzFoLTAuMTNjLTAuNTU1LDAtMC44NTksMC0wLjkxNywwCgkJCWMtMS4xNSwwLTIuMDUxLTAuMzg3LTIuNzA3LTEuMTU0QzMxLjgyMSw0OC4yOTcsMzEuNDUsNDYuNzEzLDMxLjQ1LDQ0LjM5OHoiLz4KCTwvZz4KCTxyZWN0IHg9IjQ0LjA1OSIgeT0iMzMuMDc1IiBmaWxsPSIjODg5NTk3IiB3aWR0aD0iMS45MDciIGhlaWdodD0iMTcuMjM3Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "ipuf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("aj/V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437e23d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("Y8DQ");
function injectStyle (ssrContext) {
  __webpack_require__("ipuf")
  __webpack_require__("U4Te")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437e23d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j0E5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j4oQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotopdemo_vue__ = __webpack_require__("WHX/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc355e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotopdemo_vue__ = __webpack_require__("ZusN");
function injectStyle (ssrContext) {
  __webpack_require__("UK7d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotopdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc355e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotopdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j6l0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jjfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-checkbox',
  inheritAttrs: false,
  model: {
    prop: 'model',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {},
    label: {
      type: String
    },
    name: {
      type: String
    },
    inputId: {
      type: String
    },
    tabindex: {
      type: [Number, String]
    },
    checkboxStyle: {},
    checkboxStyleClass: {
      type: String
    },
    model: {}
  },
  data: function data() {
    return {
      focused: false,
      checked: false,
      newModel: this.model
    };
  },

  watch: {
    model: function model(value) {
      this.newModel = value;
    },
    newModel: function newModel(value) {
      var _this = this;

      this.$emit('input', value);
      this.$nextTick(function () {
        _this.checked = _this.$refs.cb.checked;
      });
    }
  },
  methods: {
    onClick: function onClick(event, focus) {
      if (this.disabled) {
        return;
      }
      this.$refs.cb.click();
      this.checked = this.$refs.cb.checked;
      if (focus) {
        this.$refs.cb.focus();
      }
    },
    onFocus: function onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    }
  },
  mounted: function mounted() {
    this.checked = this.$refs.cb.checked;
  }
});

/***/ }),

/***/ "jvhi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',{staticClass:"first"},[_vm._v("1. Document")]),_vm._v(" "),_c('p',[_vm._v("The entire document is blocked")]),_vm._v(" "),_c('vf-blockUI',{attrs:{"blocked":_vm.blockedDocument}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Block"},on:{"click":function($event){_vm.blockDocument()}}}),_vm._v(" "),_c('h3',[_vm._v("2. Target")]),_vm._v(" "),_c('p',[_vm._v("Particular target")]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Block"},on:{"click":function($event){_vm.blockPanel()}}}),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Unblock"},on:{"click":function($event){_vm.unblockPanel()}}}),_vm._v(" "),_c('vf-blockUI',{attrs:{"target":_vm.target,"blocked":_vm.blockedPanel}},[_c('i',{staticClass:"fa fa-lock fa-5x",staticStyle:{"position":"absolute","top":"25%","left":"50%"}})]),_vm._v(" "),_c('vf-panel',{style:({'margin-top':'20px'}),attrs:{"id":"pnl","header":"Godfather I"}},[_vm._v("\n        The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding.\n        His beloved son Michael has just come home from the war, but does not intend to become part of his father's business.\n        Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family,\n        kind and benevolent to those who give respect, but given to ruthless violence whenever anything stands against the good of the family.\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("BlockUI")]),_vm._v(" "),_c('span',[_vm._v("BlockUI can either block other components or the whole page.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k0RA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var lineData = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  datasets: [{
    label: 'VueJS downloads',
    fill: false,
    borderColor: '#1988E5',
    data: [65, 88, 80, 81, 56, 95, 60, 65, 88, 80, 81, 56, 95, 60]
  }, {
    label: 'Angular downloads',
    fill: false,
    borderColor: '#799342',
    data: [77, 66, 50, 69, 86, 97, 90, 77, 66, 50, 69, 86, 97, 90]
  }]
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chartsdemo',
  data: function data() {
    return {
      lineData: lineData
    };
  }
});

/***/ }),

/***/ "k1wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("Basic")]),_vm._v(" "),_c('p',[_vm._v("Container component holds the various components where left aligned content is placed inside a div having .ui-toolbar-group-left class and similarly .ui-toolbar-group-right for right alignment.")]),_vm._v(" "),_c('vf-toolbar',[_c('div',{staticClass:"ui-toolbar-group-left"},[_c('vf-button',{attrs:{"type":"button","label":"New","icon":"fa-plus"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-success",attrs:{"type":"button","label":"Open","icon":"fa-folder-open"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-bars"})],1),_vm._v(" "),_c('div',{staticClass:"ui-toolbar-group-right"},[_c('vf-button',{attrs:{"pButton":"","type":"button","icon":"fa-search"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-bars"}),_vm._v(" "),_c('vf-button',{attrs:{"pButton":"","type":"button","icon":"fa-refresh"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-danger",attrs:{"pButton":"","type":"button","icon":"fa-trash"}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Toolbar")]),_vm._v(" "),_c('span',[_vm._v("Toolbar is a grouping component for buttons and other content.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kDDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barchartdemo_vue__ = __webpack_require__("AR/5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50288d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barchartdemo_vue__ = __webpack_require__("BjHW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barchartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50288d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barchartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kFRB":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iUEFORUwiPgoJPHBhdGggZmlsbD0iIzFCODJENyIgZD0iTTc3LjU5MSw3MC44ODNjMCwyLjA4Mi0xLjY4OCwzLjc3MS0zLjc3LDMuNzcxSDMuODAyYy0yLjA4MywwLTMuNzctMS42ODktMy43Ny0zLjc3MVYyMi4yMjEKCQljMC0yLjA4MSwxLjY4Ny0zLjc3LDMuNzctMy43N2g3MC4wMjFjMi4wODIsMCwzLjc3LDEuNjg5LDMuNzcsMy43N0w3Ny41OTEsNzAuODgzTDc3LjU5MSw3MC44ODN6Ii8+Cgk8cGF0aCBmaWxsPSIjMUI4MkQ3IiBkPSJNODMuNTE3LDguNzU2aC03MC4wMmMtMi4wODMsMC0zLjc3MSwxLjY4OC0zLjc3MSwzLjc3djEuNjE2SDc4LjEzYzIuMDgyLDAsMy43NzEsMS42ODksMy43NzEsMy43N3Y0Ny4wNDcKCQloMS42MTdjMi4wOCwwLDMuNzctMS42ODgsMy43Ny0zLjc3VjEyLjUyNkM4Ny4yODYsMTAuNDQ0LDg1LjU5Nyw4Ljc1Niw4My41MTcsOC43NTZ6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "kFam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Image")]),_vm._v(" "),_c('vf-avatar',{attrs:{"src":"https://placekitten.com/500/350","color":"blue","backgroundColor":"orange","size":30,"iconSize":20,"imageClass":"imageClass"}},[_vm._v("Tom")]),_vm._v(" "),_c('h2',[_vm._v("Icon")]),_vm._v(" "),_c('vf-avatar',{attrs:{"icon":"fa-github-square","color":"blue","backgroundColor":"orange","size":30,"iconSize":20}},[_vm._v("Github")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Avatar")]),_vm._v(" "),_c('span',[_vm._v("Avatars can be used to represent people or objects..")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kPoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_vue__ = __webpack_require__("mj7g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656d78c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_vue__ = __webpack_require__("ijjx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656d78c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kY+Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var bubbleData = {
  datasets: [{
    label: 'VueJS',
    backgroundColor: '#FF7989',
    data: [{
      x: 10,
      y: 25,
      r: 25
    }, {
      x: 20,
      y: 10,
      r: 10
    }, {
      x: 40,
      y: 30,
      r: 30
    }]
  }, {
    label: 'Angular',
    backgroundColor: '#DC8CFF',
    data: [{
      x: 20,
      y: 10,
      r: 15
    }, {
      x: 40,
      y: 20,
      r: 10
    }, {
      x: 50,
      y: 30,
      r: 25
    }]
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bubblechartdemo',
  data: function data() {
    return {
      bubbleData: bubbleData
    };
  }
});

/***/ }),

/***/ "ksO3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ratingdemo',
  data: function data() {
    return {
      val1: null,
      val2: null,
      val3: 6,
      val4: 8,
      val5: null,
      val6: null,
      msg: null
    };
  },

  methods: {
    rating: function rating(event) {
      this.msg = "You rated " + event.value;
    },
    canceling: function canceling() {
      this.msg = "Rating is Cancelled";
    }
  }
});

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export components */
/* unused harmony export directives */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inputtext_inputtext_vue__ = __webpack_require__("LFj4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputtextarea_inputtextarea_vue__ = __webpack_require__("lhYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_button_button_vue__ = __webpack_require__("a/uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progressspinner_progressspinner_vue__ = __webpack_require__("0TQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progressbar_progressbar_vue__ = __webpack_require__("wtsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_checkbox_checkbox_vue__ = __webpack_require__("yjF1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tristatecheckbox_tristatecheckbox_vue__ = __webpack_require__("c7s5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_charts_vue__ = __webpack_require__("wzqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_rating_rating_vue__ = __webpack_require__("2swz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_togglebutton_togglebutton_vue__ = __webpack_require__("eTvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_radiobutton_radiobutton_vue__ = __webpack_require__("tkC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_captcha_captcha_vue__ = __webpack_require__("Goma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_panel_panel_vue__ = __webpack_require__("miFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_fieldset_fieldset_vue__ = __webpack_require__("tu6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_toolbar_toolbar_vue__ = __webpack_require__("yE9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_galleria_galleria_vue__ = __webpack_require__("+hjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_message_message_vue__ = __webpack_require__("Q96i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_messages_messages_vue__ = __webpack_require__("tNWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_editor_editor_vue__ = __webpack_require__("NfLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_accordion_accordion_vue__ = __webpack_require__("WwAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_accordion_accordiontab_vue__ = __webpack_require__("g8lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_terminal_terminal_vue__ = __webpack_require__("d0EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_growl_growl_vue__ = __webpack_require__("8aOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_gmap_gmap_vue__ = __webpack_require__("Urqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_inputswitch_inputswitch_vue__ = __webpack_require__("G9X4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_spinner_spinner_vue__ = __webpack_require__("fVev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_password_password_vue__ = __webpack_require__("Qacz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_inplace_inplace_vue__ = __webpack_require__("+MX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_blockui_blockui_vue__ = __webpack_require__("OiG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_sidebar_sidebar_vue__ = __webpack_require__("ivsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_backtotop_backtotop_vue__ = __webpack_require__("cthI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_codehighlighter_codehighlighter_vue__ = __webpack_require__("SakC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_selectbutton_selectbutton_vue__ = __webpack_require__("VTww");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_colorpicker_colorpicker_vue__ = __webpack_require__("3e6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_badge_badge_vue__ = __webpack_require__("B1eA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_card_card_vue__ = __webpack_require__("n68v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_qrcode_qrcode_vue__ = __webpack_require__("kPoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_scrollpanel_scrollpanel_vue__ = __webpack_require__("SsdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_avatar_avatar_vue__ = __webpack_require__("ij7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_minusplus_minusplus_vue__ = __webpack_require__("dy4Y");









































var components = {
  InputText: __WEBPACK_IMPORTED_MODULE_0__components_inputtext_inputtext_vue__["a" /* default */],
  InputTextarea: __WEBPACK_IMPORTED_MODULE_1__components_inputtextarea_inputtextarea_vue__["a" /* default */],
  Button: __WEBPACK_IMPORTED_MODULE_2__components_button_button_vue__["a" /* default */],
  ProgressSpinner: __WEBPACK_IMPORTED_MODULE_3__components_progressspinner_progressspinner_vue__["a" /* default */],
  ProgressBar: __WEBPACK_IMPORTED_MODULE_4__components_progressbar_progressbar_vue__["a" /* default */],
  Checkbox: __WEBPACK_IMPORTED_MODULE_5__components_checkbox_checkbox_vue__["a" /* default */],
  TristateCheckbox: __WEBPACK_IMPORTED_MODULE_6__components_tristatecheckbox_tristatecheckbox_vue__["a" /* default */],
  Chart: __WEBPACK_IMPORTED_MODULE_7__components_charts_charts_vue__["a" /* default */],
  Rating: __WEBPACK_IMPORTED_MODULE_8__components_rating_rating_vue__["a" /* default */],
  ToggleButton: __WEBPACK_IMPORTED_MODULE_9__components_togglebutton_togglebutton_vue__["a" /* default */],
  RadioButton: __WEBPACK_IMPORTED_MODULE_10__components_radiobutton_radiobutton_vue__["a" /* default */],
  Captcha: __WEBPACK_IMPORTED_MODULE_11__components_captcha_captcha_vue__["a" /* default */],
  Panel: __WEBPACK_IMPORTED_MODULE_12__components_panel_panel_vue__["a" /* default */],
  Fieldset: __WEBPACK_IMPORTED_MODULE_13__components_fieldset_fieldset_vue__["a" /* default */],
  Toolbar: __WEBPACK_IMPORTED_MODULE_14__components_toolbar_toolbar_vue__["a" /* default */],
  Galleria: __WEBPACK_IMPORTED_MODULE_15__components_galleria_galleria_vue__["a" /* default */],
  Message: __WEBPACK_IMPORTED_MODULE_16__components_message_message_vue__["a" /* default */],
  Messages: __WEBPACK_IMPORTED_MODULE_17__components_messages_messages_vue__["a" /* default */],
  Editor: __WEBPACK_IMPORTED_MODULE_18__components_editor_editor_vue__["a" /* default */],
  Accordion: __WEBPACK_IMPORTED_MODULE_19__components_accordion_accordion_vue__["a" /* default */],
  AccordionTab: __WEBPACK_IMPORTED_MODULE_20__components_accordion_accordiontab_vue__["a" /* default */],
  Terminal: __WEBPACK_IMPORTED_MODULE_21__components_terminal_terminal_vue__["a" /* default */],
  Growl: __WEBPACK_IMPORTED_MODULE_22__components_growl_growl_vue__["a" /* default */],
  Gmap: __WEBPACK_IMPORTED_MODULE_23__components_gmap_gmap_vue__["a" /* default */],
  InputSwitch: __WEBPACK_IMPORTED_MODULE_24__components_inputswitch_inputswitch_vue__["a" /* default */],
  Password: __WEBPACK_IMPORTED_MODULE_26__components_password_password_vue__["a" /* default */],
  Spinner: __WEBPACK_IMPORTED_MODULE_25__components_spinner_spinner_vue__["a" /* default */],
  Inplace: __WEBPACK_IMPORTED_MODULE_27__components_inplace_inplace_vue__["a" /* default */],
  BlockUI: __WEBPACK_IMPORTED_MODULE_28__components_blockui_blockui_vue__["a" /* default */],
  SideBar: __WEBPACK_IMPORTED_MODULE_29__components_sidebar_sidebar_vue__["a" /* default */],
  BackToTop: __WEBPACK_IMPORTED_MODULE_30__components_backtotop_backtotop_vue__["a" /* default */],
  SelectButton: __WEBPACK_IMPORTED_MODULE_32__components_selectbutton_selectbutton_vue__["a" /* default */],
  ColorPicker: __WEBPACK_IMPORTED_MODULE_33__components_colorpicker_colorpicker_vue__["a" /* default */],
  Badge: __WEBPACK_IMPORTED_MODULE_34__components_badge_badge_vue__["a" /* default */],
  Card: __WEBPACK_IMPORTED_MODULE_35__components_card_card_vue__["a" /* default */],
  QRCode: __WEBPACK_IMPORTED_MODULE_36__components_qrcode_qrcode_vue__["a" /* default */],
  ScrollPanel: __WEBPACK_IMPORTED_MODULE_37__components_scrollpanel_scrollpanel_vue__["a" /* default */],
  Avatar: __WEBPACK_IMPORTED_MODULE_38__components_avatar_avatar_vue__["a" /* default */],
  MinusPlus: __WEBPACK_IMPORTED_MODULE_39__components_minusplus_minusplus_vue__["a" /* default */]
};

var directives = {
  CodeHighlighter: __WEBPACK_IMPORTED_MODULE_31__components_codehighlighter_codehighlighter_vue__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var key in components) {
      var component = components[key];
      Vue.component(component.name, component);
    }
    for (var _key in directives) {
      var directive = directives[_key];
      Vue.directive(directive.name, directive);
    }
  }
});

/***/ }),

/***/ "lhYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextarea_vue__ = __webpack_require__("m57U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4688ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextarea_vue__ = __webpack_require__("F5au");
function injectStyle (ssrContext) {
  __webpack_require__("j6l0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4688ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lrQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputtextareademo',
  data: function data() {
    return {
      text: 'VueFace',
      autoResize: true
    };
  }
});

/***/ }),

/***/ "m4lT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progressbardemo',
  data: function data() {
    return {
      value: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var interval = setInterval(function () {
      _this.value = _this.value + Math.floor(Math.random() * 10) + 1;
      if (_this.value >= 100) {
        _this.value = 100;
        _this.msgs = [{ severity: 'info', summary: 'Success', detail: 'Process Completed' }];
        clearInterval(interval);
      }
    }, 2000);
  }
});

/***/ }),

/***/ "m57U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-inputTextarea',
  props: {
    value: String,
    autoResize: Boolean,
    rows: [Number, String],
    cols: [Number, String]
  },
  data: function data() {
    return {
      newValue: this.value,
      filled: false,
      rowsDefault: 0,
      colsDefault: 0
    };
  },

  watch: {
    value: function value(_value) {
      this.newValue = _value;
    },
    newValue: function newValue(value) {
      this.updateFilled(value);
      this.$emit('input', value);
    }
  },
  methods: {
    updateFilled: function updateFilled(value) {
      this.filled = value && value.length;
    },
    resize: function resize(event) {
      var linesCount = 0;
      var lines = this.$refs.textarea.value.split('\n');

      for (var i = lines.length - 1; i >= 0; --i) {
        linesCount += Math.floor(lines[i].length / this.colsDefault + 1);
      }

      this.rows = linesCount >= this.rowsDefault ? linesCount + 1 : this.rowsDefault;
      this.$emit('onResize', event || {});
    },
    handleAutoresize: function handleAutoresize(event) {
      if (this.autoResize) {
        this.resize(event);
      }
    },
    handleFilledState: function handleFilledState(event) {
      this.updateFilled();
    }
  },
  created: function created() {
    this.rowsDefault = this.rows;
    this.colsDefault = this.cols;
    this.updateFilled(this.value);
  }
});

/***/ }),

/***/ "mQC1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "miFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panel_vue__ = __webpack_require__("W3u5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f836ed8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__ = __webpack_require__("7hwg");
function injectStyle (ssrContext) {
  __webpack_require__("Msuo")
  __webpack_require__("gjUc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f836ed8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mj7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrious__ = __webpack_require__("+n64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrious___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrious__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-qrcode',
  data: function data() {
    return {
      qrcode: null
    };
  },

  props: {
    value: {
      type: String,
      required: ''
    },
    background: {
      type: String,
      default: 'white'
    },
    backgroundAlpha: {
      type: Number,
      default: 1.0
    },
    foreground: {
      type: String,
      default: 'black'
    },
    foregroundAlpha: {
      type: Number,
      default: 1.0
    },
    level: {
      type: String,
      default: 'L'
    },
    mime: {
      type: String,
      default: 'image/png'
    },
    padding: {
      type: Number,
      default: null
    },
    size: {
      type: Number,
      default: 100
    }
  },
  watch: {
    background: function background() {
      this.qrcode.background = this.background;
    },
    backgroundAlpha: function backgroundAlpha() {
      this.qrcode.backgroundAlpha = this.backgroundAlpha;
    },
    foreground: function foreground() {
      this.qrcode.foreground = this.foreground;
    },
    foregroundAlpha: function foregroundAlpha() {
      this.qrcode.foregroundAlpha = this.foregroundAlpha;
    },
    level: function level() {
      this.qrcode.level = this.level;
    },
    mime: function mime() {
      this.qrcode.mime = this.mime;
    },
    padding: function padding() {
      this.qrcode.padding = this.padding;
    },
    size: function size() {
      this.qrcode.size = this.size;
    },
    value: function value() {
      this.qrcode.value = this.value;
    }
  },
  methods: {
    init: function init() {
      var qrObject = {
        element: this.$refs.qrcode,
        background: this.background,
        backgroundAlpha: this.backgroundAlpha,
        foreground: this.foreground,
        foregroundAlpha: this.foregroundAlpha,
        level: this.level,
        mime: this.mime,
        padding: this.padding,
        size: this.size,
        value: this.value
      };
      this.qrcode = new __WEBPACK_IMPORTED_MODULE_0_qrious___default.a(qrObject);
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),

/***/ "n/XO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.minusplusStyleClass, {'ui-minusplus ui-widget ui-widget-content ui-corner-all': true,'ui-minusplus-vertical': _vm.vertical, 'ui-state-disabled': _vm.disabled}]},[_c('vf-button',{class:_vm.getButtonClass(true),attrs:{"label":_vm.decrementLabel},on:{"click":function($event){_vm.decrement()}}}),_vm._v(" "),_c('div',{staticClass:"ui-minusplus-value"},[_vm._t("default",[_vm._v(_vm._s(_vm.inputValue))])],2),_vm._v(" "),_c('vf-button',{class:_vm.getButtonClass(false),attrs:{"label":_vm.incrementLabel},on:{"click":function($event){_vm.increment()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n68v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("qgc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac9f1504_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("nBUS");
function injectStyle (ssrContext) {
  __webpack_require__("VUKx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac9f1504_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n7LC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinnerdemo',
  data: function data() {
    return {
      val1: 10,
      val2: 5,
      val3: 10,
      val4: 100
    };
  }
});

/***/ }),

/***/ "nBUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-widget ui-widget-content ui-corner-all ui-card dimensions"},[(_vm.$slots.header || _vm.header)?_c('div',{staticClass:"ui-card-header"},[_vm._t("header",[_vm._v(_vm._s(_vm.header))])],2):_vm._e(),_vm._v(" "),_c('div',{style:(_vm.contentStyle)},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer || _vm.footer)?_c('div',{staticClass:"ui-card-footer"},[_vm._t("footer",[_vm._v(_vm._s(_vm.footer))])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nEZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-badge',
  props: {
    value: {},
    max: {
      type: Number,
      default: null
    },
    dot: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    badgeClass: {
      type: [String, Object, Array]
    }
  },
  computed: {
    data: function data() {
      if (this.dot) return;
      if (typeof this.value === 'number' && typeof this.max === 'number') {
        return this.max < this.value ? this.max + '+' : this.value;
      } else {
        return this.value;
      }
    },
    display: function display() {
      return this.data || this.dot;
    }
  }
});

/***/ }),

/***/ "nRi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("The basic WYSIWYG editor is built for the modern web.")]),_vm._v(" "),_c('vf-editor',{attrs:{"editorStyle":"height:320px"},model:{value:(_vm.text1),callback:function ($$v) {_vm.text1=$$v},expression:"text1"}}),_vm._v(" "),_c('p',[_vm._v("Value: "+_vm._s(_vm.text1))]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Clear","icon":"fa-close"},on:{"click":function($event){_vm.text1=null}}}),_vm._v(" "),_c('h3',[_vm._v("2. Custom Toolbar")]),_vm._v(" "),_c('p',[_vm._v("Editor customized with required toolbar option")]),_vm._v(" "),_c('vf-editor',{attrs:{"editorStyle":"height:320px"},model:{value:(_vm.text2),callback:function ($$v) {_vm.text2=$$v},expression:"text2"}},[_c('div',{attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('span',{staticClass:"ql-formats"},[_c('button',{staticClass:"ql-bold",attrs:{"aria-label":"Bold"}}),_vm._v(" "),_c('button',{staticClass:"ql-italic",attrs:{"aria-label":"Italic"}}),_vm._v(" "),_c('button',{staticClass:"ql-underline",attrs:{"aria-label":"Underline"}})])])]),_vm._v(" "),_c('p',[_vm._v("Value: "+_vm._s(_vm.text2))]),_vm._v(" "),_c('vf-button',{attrs:{"type":"button","label":"Clear","icon":"fa-close"},on:{"click":function($event){_vm.text2=null}}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Editor")]),_vm._v(" "),_c('span',[_vm._v("Editor is rich text editor component based on Quill.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "niiN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nkpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextareademo_vue__ = __webpack_require__("lrQp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5781d2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextareademo_vue__ = __webpack_require__("P/uI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inputtextareademo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5781d2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputtextareademo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o+B7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('p',[_vm._v("Define the type as radarData(type=\"radarData\").")]),_vm._v(" "),_c('vf-charts',{attrs:{"type":"radar","data":_vm.radarData,"width":"100","height":"20"}},[_vm._v(">")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("RadarChart")]),_vm._v(" "),_c('span',[_vm._v("A radar chart is a graphical method of displaying multivariate data in the form of a two-dimensional chart of three or more quantitative variables represented on axes starting from the same point.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3S/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglebuttondemo_vue__ = __webpack_require__("JVo+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3ee3e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglebuttondemo_vue__ = __webpack_require__("1QhY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglebuttondemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3ee3e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglebuttondemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oP77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Addons")]),_vm._v(" "),_c('div',{staticClass:"ui-g ui-fluid"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_vm._m(1),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Username"}})],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('span',{staticClass:"ui-inputgroup-addon"},[_vm._v("$")]),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Price"}}),_vm._v(" "),_c('span',{staticClass:"ui-inputgroup-addon"},[_vm._v(".00")])],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('span',{staticClass:"ui-inputgroup-addon"},[_vm._v("www")]),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Website"}})],1)])]),_vm._v(" "),_c('h3',[_vm._v("Multiple Addons")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12"},[_c('div',{staticClass:"ui-inputgroup"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Price"}}),_vm._v(" "),_c('span',{staticClass:"ui-inputgroup-addon"},[_vm._v("$")]),_vm._v(" "),_c('span',{staticClass:"ui-inputgroup-addon"},[_vm._v(".00")])],1)])]),_vm._v(" "),_c('h3',[_vm._v("Button Addons")]),_vm._v(" "),_c('div',{staticClass:"ui-g ui-fluid"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('vf-button',{attrs:{"type":"button","label":"Search"}}),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Keyword"}})],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('vf-inputText',{attrs:{"type":"text","placeholder":"Keyword"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-secondary",attrs:{"type":"button","icon":"fa-superpowers"}})],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('button',{staticClass:"ui-button-success",attrs:{"type":"button","icon":"fa-check"}}),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Vote"}}),_vm._v(" "),_c('vf-button',{staticClass:"ui-button-danger",attrs:{"type":"button","icon":"fa-close"}})],1)])]),_vm._v(" "),_c('h3',[_vm._v("Checkbox and RadioButton")]),_vm._v(" "),_c('div',{staticClass:"ui-g ui-fluid"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('span',{staticClass:"ui-inputgroup-addon"},[_c('vf-checkbox')],1),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Username"}})],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('vf-inputText',{attrs:{"type":"text","placeholder":"Price"}}),_vm._v(" "),_c('span',{staticClass:"ui-inputgroup-addon"},[_c('vf-radioButton')],1)],1)]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_c('div',{staticClass:"ui-inputgroup"},[_c('span',{staticClass:"ui-inputgroup-addon"},[_c('vf-checkbox')],1),_vm._v(" "),_c('vf-inputText',{attrs:{"type":"text","placeholder":"Website"}}),_vm._v(" "),_c('span',{staticClass:"ui-inputgroup-addon"},[_c('vf-radioButton')],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("InputGroup")]),_vm._v(" "),_c('span',[_vm._v("Text, icon, buttons and other content can be grouped next to an input by wrapping the addons and input inside .ui-inputgroup element. Multiple addons can be used within the same group as well.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-inputgroup-addon"},[_c('i',{staticClass:"fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-inputgroup-addon"},[_c('i',{staticClass:"fa fa-credit-card"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-inputgroup-addon"},[_c('i',{staticClass:"fa fa-cc-visa"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oPQZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("Displays the google map with given options.")]),_vm._v(" "),_c('vf-growl',{attrs:{"value":_vm.msgs}}),_vm._v(" "),_c('vf-gmap',{ref:"gmap",style:({'width':'100%','min-height':'320px'}),attrs:{"options":_vm.options,"overlays":_vm.overlays},on:{"click":_vm.handleMapClick,"overlayclick":_vm.handleOverlayClick,"overlaydragend":_vm.handleDragEnd}}),_vm._v(" "),_c('vf-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"button","label":"Clear","icon":"fa-close"},on:{"click":function($event){_vm.clear()}}}),_vm._v(" "),_c('vf-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"button","label":"Zoom In","icon":"fa-search-plus"},on:{"click":function($event){_vm.zoomIn(_vm.$refs.gmap.getMap())}}}),_vm._v(" "),_c('vf-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"button","label":"Zoom Out","icon":"fa-search-minus"},on:{"click":function($event){_vm.zoomOut(_vm.$refs.gmap.getMap())}}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("GMap")]),_vm._v(" "),_c('span',[_vm._v("GMap component provides integration with Google Maps API. This sample demontrates various uses cases like binding, overlays and events. Click the map to add a new item.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oUF0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4Ny4zMThweCIgaGVpZ2h0PSI4My40MTFweCIgdmlld0JveD0iMCAwIDg3LjMxOCA4My40MTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDg3LjMxOCA4My40MTEiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iTUVTU0FHRSI+Cgk8cGF0aCBmaWxsPSIjODg5NTk3IiBkPSJNMzYuNTA2LDU2Ljc0OGMwLDMuNjA3LDIuOTI0LDYuNTMzLDYuNTMyLDYuNTMzaDIzLjc2NEw3Ni45NDksNzUuNDlsMS4wMjUtMTIuMjA5CgkJYzMuNjA3LDAsNi41MzItMi45MjYsNi41MzItNi41MzNsMi43OTktMjMuMDJjMC0zLjYwNy0yLjkyNC02LjUzMi02LjUzMi02LjUzMkgzOS4zMDRjLTMuNjA3LDAtNi41MzIsMi45MjUtNi41MzIsNi41MzIKCQlMMzYuNTA2LDU2Ljc0OHoiLz4KCTxwYXRoIGZpbGw9IiM4ODk1OTciIGQ9Ik0zMy40OTIsNTcuMDEzbC0wLjY2LTQuMTFoLTUuMDExTDE3LjczOCw2NS4wMzRsLTEuMDE3LTEyLjEzMUgxNC41Yy0zLjMyNywwLTYuMDM3LTIuNzA4LTYuMDM3LTYuMDM3CgkJbC0zLjYyLTI5LjkxNWMwLjA3MS0zLjI2OCwyLjc1Mi01LjkwMiw2LjAzNC01LjkwMmg1My42NDhjMy4yNzEsMCw1Ljk0LDIuNjExLDYuMDM0LDUuODU4bC0xLjE3OSw3LjI3MWg0Ljg5M2wxLjA4OC02LjcwNwoJCWwwLjAzLTAuMzg3YzAtNS45OTEtNC44NzQtMTAuODY1LTEwLjg2Ni0xMC44NjVIMTAuODc4Yy01Ljk5MiwwLTEwLjg2Niw0Ljg3NC0xMC44NjYsMTAuODY1bDMuNjI1LDI5LjkzOAoJCWMwLjA3MSw1LjE1NCwzLjc1MSw5LjQ1Myw4LjYyMywxMC40NzhsMS42NTEsMTkuNjkybDE2LjE3Ni0xOS40NmgzLjQ1OUMzMy41MjMsNTcuNDk0LDMzLjQ5Nyw1Ny4yNTUsMzMuNDkyLDU3LjAxM3oiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "ovUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',[_vm._v("Install")]),_vm._v(" "),_c('p',[_vm._v("Install using npm package manager")]),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"bash"},[_vm._v("$ npm install --save vueface")])]),_vm._v(" "),_c('h3',[_vm._v("Quick Start (Using vue-cli)")]),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"bash"},[_vm._v("$ npm install -g vue-cli\n$ vue init webpack vue-app\n$ cd vue-app\n$ npm install --save vueface")])]),_vm._v(" "),_c('h4',[_vm._v("main.js")]),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"javascript"},[_vm._v("\nimport Vue from 'vue'\nimport App from './App'\nimport VueFace from 'vueface'\n\nVue.use(VueFace);\n\nVue.config.productionTip = false;\n\n/* eslint-disable no-new */\nnew Vue({\n  el: '#app',\n  template: '<App/>',\n  components: { App };\n})\n")])]),_vm._v(" "),_c('h4',[_vm._v("App.vue")]),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"html"},[_vm._v("<template>\n  <div id=\"app\">\n    <router-view></router-view>\n    <p-button>Testing</p-button>\n  </div>\n</template>\n<style id=\"current-theme\" lang=\"css\" src=\"../node_modules/vueface/src/assets/themes/omega/theme.css\"></style>\n<style lang=\"css\" src=\"../node_modules/vueface/src/assets/vue-face.css\"></style>\n<script>\nexport default {\n  name: 'app'\n}\n</script>\n\n<style>\n#app {\n  font-family: 'Avenir', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  margin-top: 60px;\n}\n</style>\n")])]),_vm._v(" "),_c('h4',[_vm._v("Run")]),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"bash"},[_vm._v("$ npm start")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-top":"80px"}},[_c('h2',[_vm._v("VueFace")]),_vm._v(" "),_c('h5',[_vm._v("A VueJS Component library")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p2b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paneldemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "p7ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messagedemo_vue__ = __webpack_require__("P6kH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70560cac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messagedemo_vue__ = __webpack_require__("SCRj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messagedemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70560cac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messagedemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pRjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-scrollPanel',
  props: {
    scrollpanelStyle: {
      type: Object,
      default: null
    },
    scrollpanelStyleClass: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      scrollRatio: null,
      initialized: false,
      lastPageY: null
    };
  },

  watch: {},
  methods: {
    init: function init() {
      this.moveBar();
      this.moveBar = this.moveBar.bind(this);
      this.onBarMouseDown = this.onBarMouseDown.bind(this);
      this.onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
      this.onDocumentMouseUp = this.onDocumentMouseUp.bind(this);

      window.addEventListener('resize', this.moveBar);
      this.$refs.content.addEventListener('scroll', this.moveBar);
      this.$refs.content.addEventListener('mouseenter', this.moveBar);
      this.$refs.bar.addEventListener('mousedown', this.onBarMouseDown);
      this.initialized = true;
    },
    moveBar: function moveBar() {
      var _this = this;

      var container = this.$refs.container;
      var content = this.$refs.content;
      var bar = this.$refs.bar;
      var totalHeight = content.scrollHeight;
      var ownHeight = content.clientHeight;
      var right = (container.clientWidth - bar.clientWidth) * -1;

      this.scrollRatio = ownHeight / totalHeight;

      this.requestAnimationFrame(function () {
        if (_this.scrollRatio >= 1) {
          __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].addClass(bar, 'ui-scrollpanel-hidden');
        } else {
          __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].removeClass(bar, 'ui-scrollpanel-hidden');
          bar.style.cssText = 'height:' + Math.max(_this.scrollRatio * 100, 10) + '%; top:' + content.scrollTop / totalHeight * 100 + '%;right:' + right + 'px;';
        }
      });
    },
    onBarMouseDown: function onBarMouseDown(e) {
      this.lastPageY = e.pageY;
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].addClass(this.$refs.bar, 'ui-scrollpanel-grabbed');
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].addClass(document.body, 'ui-scrollpanel-grabbed');

      document.addEventListener('mousemove', this.onDocumentMouseMove);
      document.addEventListener('mouseup', this.onDocumentMouseUp);
      e.preventDefault();
    },
    onDocumentMouseMove: function onDocumentMouseMove(e) {
      var _this2 = this;

      var delta = e.pageY - this.lastPageY;
      this.lastPageY = e.pageY;

      this.requestAnimationFrame(function () {
        _this2.$refs.content.scrollTop += delta / _this2.scrollRatio;
      });
    },
    onDocumentMouseUp: function onDocumentMouseUp(e) {
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].removeClass(this.$refs.bar, 'ui-scrollpanel-grabbed');
      __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].removeClass(document.body, 'ui-scrollpanel-grabbed');

      document.removeEventListener('mousemove', this.onDocumentMouseMove);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    },
    requestAnimationFrame: function requestAnimationFrame(f) {
      var frame = window.requestAnimationFrame || setTimeout(f, 0);
      frame(f);
    }
  },
  mounted: function mounted() {
    this.init();
  },
  destroyed: function destroyed() {
    if (this.initialized) {
      window.removeEventListener('resize', this.moveBar);
      this.$refs.content.removeEventListener('scroll', this.moveBar);
      this.$refs.content.removeEventListener('mouseenter', this.moveBar);
      this.$refs.bar.removeEventListener('mousedown', this.onBarMouseDown);
    }
  }
});

/***/ }),

/***/ "pvO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("Progress of loading is displayed using basic spinner element")]),_vm._v(" "),_c('vf-progressSpinner'),_vm._v(" "),_c('h3',[_vm._v("2. Custom")]),_vm._v(" "),_c('p',[_vm._v("The customized spinner with different colors with different percentages")]),_vm._v(" "),_c('vf-progressSpinner',{staticStyle:{"{width":"'50px', height: '50px'}"},attrs:{"strokeWidth":"8","fill":"#EEEEEE","animationDuration":".5s"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("ProgressSpinner")]),_vm._v(" "),_c('span',[_vm._v("ProgressSpinnerDemo is a process status indicator.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q04z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressbardemo_vue__ = __webpack_require__("m4lT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc87f7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressbardemo_vue__ = __webpack_require__("cczm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressbardemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cc87f7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressbardemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q86k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_codehighlighterdemo_vue__ = __webpack_require__("OK5J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0abac9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_codehighlighterdemo_vue__ = __webpack_require__("ZWGx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_codehighlighterdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0abac9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_codehighlighterdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qCHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('h3',[_vm._v("1. Basic")]),_vm._v(" "),_c('p',[_vm._v("Captcha is used with a siteKey and a callback to verify the response..")]),_vm._v(" "),_c('vf-captcha',{attrs:{"siteKey":"6LfsjW4UAAAAAAGYwx3nrVvG5lbXJRlfb9Ssi7PK"}}),_vm._v(" "),_c('h3',[_vm._v("2. Verification")]),_vm._v(" "),_c('p',[_vm._v("To ensure if a response token is valid then verification against recaptcha api needs to be done at backend using onResponse event.")]),_vm._v(" "),(_vm.verified)?_c('p',[_vm._v("The verification is successful")]):_vm._e(),_vm._v(" "),_c('vf-captcha',{attrs:{"siteKey":"6LfsjW4UAAAAAAGYwx3nrVvG5lbXJRlfb9Ssi7PK"},on:{"response":function($event){_vm.showResponse($event)}}}),_vm._v(" "),_c('h3',[_vm._v("3. Expiration")]),_vm._v(" "),_c('p',[_vm._v("The recaptcha response expires and the user needs to solve a new CAPTCHA acknowledge by onExpire event.")]),_vm._v(" "),_c('vf-captcha',{attrs:{"siteKey":"6LfsjW4UAAAAAAGYwx3nrVvG5lbXJRlfb9Ssi7PK"},on:{"expire":function($event){_vm.onExpire($event)}}}),_vm._v(" "),(_vm.expired)?_c('p',[_vm._v("The captcha is expired")]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Captcha")]),_vm._v(" "),_c('span',[_vm._v("Captcha is a form validation component based on Recaptcha.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qZ9c":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "qgc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-card',
  props: {
    header: {
      type: String,
      default: null
    },
    footer: {
      type: String,
      default: null
    },
    contentStyle: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ "qrrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-colorPicker',
  props: {
    value: {},
    inline: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'hex'
    },
    appendTo: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      newValue: this.value,
      newValueToUpdate: null,
      filled: false,
      inputBgColor: null,
      shown: false,
      panelVisible: false,
      defaultColor: 'ff0000',
      selfClick: false,
      colorDragging: false,
      hueDragging: false
    };
  },

  watch: {
    value: function value(_value) {
      if (_value !== this.newValueToUpdate) {
        this.writeValue(_value);
      }
    }
  },
  methods: {
    onHueMousedown: function onHueMousedown(event) {
      if (this.disabled) {
        return;
      }

      this.bindDocumentMousemoveListener();
      this.bindDocumentMouseupListener();

      this.hueDragging = true;
      this.pickHue(event);
    },
    pickHue: function pickHue(event) {
      var top = this.$refs.hue.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.newValue = this.validateHSB({
        h: Math.floor(360 * (150 - Math.max(0, Math.min(150, event.pageY - top))) / 150),
        s: this.newValue.s,
        b: this.newValue.b
      });

      this.updateColorSelector();
      this.updateUI();
      this.updateModel();
    },
    onColorMousedown: function onColorMousedown(event) {
      if (this.disabled) {
        return;
      }

      this.bindDocumentMousemoveListener();
      this.bindDocumentMouseupListener();

      this.colorDragging = true;
      this.pickColor(event);
    },
    pickColor: function pickColor(event) {
      var rect = this.$refs.colorSelector.getBoundingClientRect();
      var top = rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      var left = rect.left + document.body.scrollLeft;
      var saturation = Math.floor(100 * Math.max(0, Math.min(150, event.pageX - left)) / 150);
      var brightness = Math.floor(100 * (150 - Math.max(0, Math.min(150, event.pageY - top))) / 150);
      this.newValue = this.validateHSB({
        h: this.newValue.h,
        s: saturation,
        b: brightness
      });

      this.updateUI();
      this.updateModel();
    },
    getValueToUpdate: function getValueToUpdate() {
      var val = null;
      switch (this.format) {
        case 'hex':
          val = '#' + this.HSBtoHEX(this.newValue);
          break;
        case 'rgb':
          val = this.HSBtoRGB(this.newValue);
          break;
        case 'hsb':
          val = this.newValue;
          break;
      }

      return val;
    },
    updateModel: function updateModel() {
      this.newValueToUpdate = this.getValueToUpdate();
      this.$emit('input', this.newValueToUpdate);
    },
    writeValue: function writeValue(value) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (value) {
        switch (this.format) {
          case 'hex':
            this.newValue = this.HEXtoHSB(value);
            break;
          case 'rgb':
            this.newValue = this.RGBtoHSB(value);
            break;
          case 'hsb':
            this.newValue = value;
            break;
        }
      } else {
        this.newValue = this.HEXtoHSB(this.defaultColor);
      }

      if (update) {
        this.updateColorSelector();
        this.updateUI();
      }
    },
    updateColorSelector: function updateColorSelector() {
      this.$refs.colorSelector.style.backgroundColor = '#' + this.HSBtoHEX(this.newValue);
    },
    updateUI: function updateUI() {
      this.$refs.colorHandle.style.left = Math.floor(150 * this.newValue.s / 100) + 'px';
      this.$refs.colorHandle.style.top = Math.floor(150 * (100 - this.newValue.b) / 100) + 'px';
      this.$refs.hueHandle.style.top = Math.floor(150 - 150 * this.newValue.h / 360) + 'px';
      this.inputBgColor = '#' + this.HSBtoHEX(this.newValue);
    },
    show: function show() {
      var _this = this;

      this.$refs.panel.style.zIndex = String(++__WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].zindex);
      this.$nextTick(function () {
        _this.panelVisible = true;
        _this.shown = true;
      });
    },
    hide: function hide() {
      this.panelVisible = false;
      this.unbindDocumentClickListener();
    },
    onShow: function onShow() {
      this.alignPanel();
      this.bindDocumentClickListener();
    },
    alignPanel: function alignPanel() {
      if (this.appendTo) {
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].absolutePosition(this.$refs.panel, this.$refs.input);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].relativePosition(this.$refs.panel, this.$refs.input);
      }
    },
    onInputClick: function onInputClick() {
      this.selfClick = true;
      this.togglePanel();
    },
    togglePanel: function togglePanel() {
      if (!this.panelVisible) {
        this.show();
      } else {
        this.hide();
      }
    },
    onInputKeydown: function onInputKeydown(event) {
      switch (event.which) {
        // space
        case 32:
          this.togglePanel();
          event.preventDefault();
          break;
        // escape and tab
        case 27:
        case 9:
          this.hide();
          break;
      }
    },
    onPanelClick: function onPanelClick() {
      this.selfClick = true;
    },
    bindDocumentClickListener: function bindDocumentClickListener() {
      var _this2 = this;

      document.addEventListener('click', function () {
        if (!_this2.selfClick) {
          _this2.panelVisible = false;
          _this2.unbindDocumentClickListener();
        }

        _this2.selfClick = false;
      });
    },
    unbindDocumentClickListener: function unbindDocumentClickListener() {
      document.removeEventListener('click', null);
    },
    bindDocumentMousemoveListener: function bindDocumentMousemoveListener() {
      var _this3 = this;

      document.addEventListener('mousemove', function (event) {
        if (_this3.colorDragging) {
          _this3.pickColor(event);
        }

        if (_this3.hueDragging) {
          _this3.pickHue(event);
        }
      });
    },
    unbindDocumentMousemoveListener: function unbindDocumentMousemoveListener() {
      document.removeEventListener('mousemove', null);
    },
    bindDocumentMouseupListener: function bindDocumentMouseupListener() {
      var _this4 = this;

      document.addEventListener('mouseup', function () {
        _this4.colorDragging = false;
        _this4.hueDragging = false;
        _this4.unbindDocumentMousemoveListener();
        _this4.unbindDocumentMouseupListener();
      });
    },
    unbindDocumentMouseupListener: function unbindDocumentMouseupListener() {
      document.removeEventListener('mouseup', null);
    },
    validateHSB: function validateHSB(hsb) {
      return {
        h: Math.min(360, Math.max(0, hsb.h)),
        s: Math.min(100, Math.max(0, hsb.s)),
        b: Math.min(100, Math.max(0, hsb.b))
      };
    },
    validateRGB: function validateRGB(rgb) {
      return {
        r: Math.min(255, Math.max(0, rgb.r)),
        g: Math.min(255, Math.max(0, rgb.g)),
        b: Math.min(255, Math.max(0, rgb.b))
      };
    },
    validateHEX: function validateHEX(hex) {
      var len = 6 - hex.length;
      if (len > 0) {
        var o = [];
        for (var i = 0; i < len; i++) {
          o.push('0');
        }
        o.push(hex);
        hex = o.join('');
      }
      return hex;
    },
    HEXtoRGB: function HEXtoRGB(hex) {
      var hexValue = parseInt(hex.indexOf('#') > -1 ? hex.substring(1) : hex, 16);
      return { r: hexValue >> 16, g: (hexValue & 0x00FF00) >> 8, b: hexValue & 0x0000FF };
    },
    HEXtoHSB: function HEXtoHSB(hex) {
      return this.RGBtoHSB(this.HEXtoRGB(hex));
    },
    RGBtoHSB: function RGBtoHSB(rgb) {
      var hsb = {
        h: 0,
        s: 0,
        b: 0
      };
      var min = Math.min(rgb.r, rgb.g, rgb.b);
      var max = Math.max(rgb.r, rgb.g, rgb.b);
      var delta = max - min;
      hsb.b = max;
      if (max !== 0) {}
      hsb.s = max !== 0 ? 255 * delta / max : 0;
      if (hsb.s !== 0) {
        if (rgb.r === max) {
          hsb.h = (rgb.g - rgb.b) / delta;
        } else if (rgb.g === max) {
          hsb.h = 2 + (rgb.b - rgb.r) / delta;
        } else {
          hsb.h = 4 + (rgb.r - rgb.g) / delta;
        }
      } else {
        hsb.h = -1;
      }
      hsb.h *= 60;
      if (hsb.h < 0) {
        hsb.h += 360;
      }
      hsb.s *= 100 / 255;
      hsb.b *= 100 / 255;
      return hsb;
    },
    HSBtoRGB: function HSBtoRGB(hsb) {
      var rgb = {
        r: null, g: null, b: null
      };
      var h = Math.round(hsb.h);
      var s = Math.round(hsb.s * 255 / 100);
      var v = Math.round(hsb.b * 255 / 100);
      if (s === 0) {
        rgb = {
          r: v,
          g: v,
          b: v
        };
      } else {
        var t1 = v;
        var t2 = (255 - s) * v / 255;
        var t3 = (t1 - t2) * (h % 60) / 60;
        if (h === 360) {
          h = 0;
        }
        if (h < 60) {
          rgb.r = t1;
          rgb.b = t2;
          rgb.g = t2 + t3;
        } else if (h < 120) {
          rgb.g = t1;
          rgb.b = t2;
          rgb.r = t1 - t3;
        } else if (h < 180) {
          rgb.g = t1;
          rgb.r = t2;
          rgb.b = t2 + t3;
        } else if (h < 240) {
          rgb.b = t1;
          rgb.r = t2;
          rgb.g = t1 - t3;
        } else if (h < 300) {
          rgb.b = t1;
          rgb.g = t2;
          rgb.r = t2 + t3;
        } else if (h < 360) {
          rgb.r = t1;
          rgb.g = t2;
          rgb.b = t1 - t3;
        } else {
          rgb.r = 0;
          rgb.g = 0;
          rgb.b = 0;
        }
      }
      return { r: Math.round(rgb.r), g: Math.round(rgb.g), b: Math.round(rgb.b) };
    },
    RGBtoHEX: function RGBtoHEX(rgb) {
      var hex = [rgb.r.toString(16), rgb.g.toString(16), rgb.b.toString(16)];

      for (var key in hex) {
        if (hex[key].length === 1) {
          hex[key] = '0' + hex[key];
        }
      }

      return hex.join('');
    },
    HSBtoHEX: function HSBtoHEX(hsb) {
      return this.RGBtoHEX(this.HSBtoRGB(hsb));
    }
  },
  mounted: function mounted() {
    if (this.appendTo) {
      if (this.appendTo === 'body') {
        document.body.appendChild(this.$refs.panel);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__dom_domhandler__["a" /* default */].appendChild(this.$refs.panel, this.appendTo);
      }
    }
    this.writeValue(this.newValue);
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindDocumentClickListener();

    if (this.appendTo) {
      this.$el.appendChild(this.$refs.panel);
    }
  },
  updated: function updated() {
    if (this.shown) {
      this.onShow();
      this.shown = false;
    }
  }
});

/***/ }),

/***/ "qyQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('vf-spinner',{attrs:{"size":30},model:{value:(_vm.val1),callback:function ($$v) {_vm.val1=$$v},expression:"val1"}}),_vm._v(" "),_c('h3',[_vm._v("Min/Max")]),_vm._v(" "),_c('vf-spinner',{attrs:{"size":30,"min":0,"max":100},model:{value:(_vm.val2),callback:function ($$v) {_vm.val2=$$v},expression:"val2"}}),_vm._v(" "),_c('h3',[_vm._v("Step")]),_vm._v(" "),_c('vf-spinner',{attrs:{"size":30,"step":0.25},model:{value:(_vm.val3),callback:function ($$v) {_vm.val3=$$v},expression:"val3"}}),_vm._v(" "),_c('h3',[_vm._v("Disabled")]),_vm._v(" "),_c('vf-spinner',{attrs:{"size":30,"disabled":true},model:{value:(_vm.val4),callback:function ($$v) {_vm.val4=$$v},expression:"val4"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Spinner")]),_vm._v(" "),_c('span',[_vm._v("Spinner is an input component to provide a numerical input.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rIO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radiobuttondemo',
  data: function data() {
    return {
      val1: null,
      val2: 'VueJS',
      val3: 'Angular',
      val4: 'React'
    };
  },

  methods: {
    clickMe: function clickMe() {
      alert('click');
    }
  }
});

/***/ }),

/***/ "rYCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputtextdemo',
  data: function data() {
    return {
      visibleSidebar1: false,
      visibleSidebar2: false,
      visibleSidebar3: false,
      visibleSidebar4: false,
      visibleSidebar5: false
    };
  }
});

/***/ }),

/***/ "rfYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockuidemo_vue__ = __webpack_require__("y4Bb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6f5748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockuidemo_vue__ = __webpack_require__("jvhi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockuidemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6f5748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockuidemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rlge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMessages())?_c('div',{staticClass:"ui-messages ui-widget ui-corner-all",class:{'ui-messages-info':(_vm.value[0].severity === 'info'),
                  'ui-messages-warn':(_vm.value[0].severity === 'warn'),
                  'ui-messages-error':(_vm.value[0].severity === 'error'),
                  'ui-messages-success':(_vm.value[0].severity === 'success')},staticStyle:{"display":"block"}},[(_vm.closable)?_c('a',{staticClass:"ui-messages-close",attrs:{"href":"#"},on:{"click":function($event){_vm.clear($event)}}},[_c('i',{staticClass:"fa fa-close"})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ui-messages-icon fa fa-fw fa-2x",class:_vm.getIcon()}),_vm._v(" "),_c('ul',_vm._l((_vm.value),function(msg){return _c('li',[(msg.summary)?_c('span',{staticClass:"ui-messages-summary",domProps:{"innerHTML":_vm._s(msg.summary)}}):_vm._e(),_vm._v(" "),(msg.detail)?_c('span',{staticClass:"ui-messages-detail",domProps:{"innerHTML":_vm._s(msg.detail)}}):_vm._e()])}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "roGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radarchartdemo_vue__ = __webpack_require__("4w4V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732b5dfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radarchartdemo_vue__ = __webpack_require__("o+B7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radarchartdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732b5dfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radarchartdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "roYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'colorpickerdemo',
  data: function data() {
    return {
      color1: null,
      color2: '#1976D2'
    };
  }
});

/***/ }),

/***/ "sGQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var focus = false;
var checked = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-toggleButton',
  data: function data() {
    return {
      focus: focus, checked: checked
    };
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    onLabel: {
      type: String,
      default: 'Yes'
    },
    offLabel: {
      type: String,
      default: 'No'
    },
    onIcon: {
      type: String,
      default: null
    },
    offIcon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: 0
    },
    buttonStyle: {
      type: String,
      default: null
    },
    buttonStyleClass: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: 'button'
    }
  },
  methods: {
    getIconClass: function getIconClass() {
      var baseClass = 'ui-button-icon-left fa fa-fw';
      return baseClass + ' ' + (this.checked ? this.onIcon : this.offIcon);
    },
    toggle: function toggle(event) {
      if (!this.disabled) {
        this.checked = !this.checked;
        this.$emit('change', this.checked);
        this.$refs.cb.focus();
      }
    },
    onFocus: function onFocus() {
      this.focus = true;
    },
    onBlur: function onBlur() {
      this.focus = false;
    },
    hasOnLabel: function hasOnLabel() {
      return this.onLabel && this.onLabel.length > 0;
    },
    hasOffLabel: function hasOffLabel() {
      return this.onLabel && this.onLabel.length > 0;
    }
  },
  mounted: function mounted() {
    this.checked = this.value;
  }
});

/***/ }),

/***/ "t9Xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'griddemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "tNWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messages_vue__ = __webpack_require__("zoMH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d6262ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messages_vue__ = __webpack_require__("rlge");
function injectStyle (ssrContext) {
  __webpack_require__("/8aQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d6262ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tPdU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYc9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tesd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'galleriademo',
  data: function data() {
    return {
      images: []
    };
  },

  methods: {
    createImages: function createImages() {
      this.images.push({ source: 'img/cars/Golf.png', alt: 'Description for Image 1', title: 'Title 1' });
      this.images.push({ source: 'img/cars/Jetta.png', alt: 'Description for Image 2', title: 'Title 2' });
      this.images.push({ source: 'img/cars/Passat.png', alt: 'Description for Image 3', title: 'Title 3' });
      this.images.push({ source: 'img/cars/Polo.png', alt: 'Description for Image 4', title: 'Title 4' });
      this.images.push({ source: 'img/cars/Scirocco.png', alt: 'Description for Image 5', title: 'Title 5' });
      this.images.push({ source: 'img/cars/Touareg.png', alt: 'Description for Image 6', title: 'Title 6' });
      this.images.push({ source: 'img/cars/Yeni.png', alt: 'Description for Image 7', title: 'Title 7' });
    }
  },
  mounted: function mounted() {
    this.createImages();
  }
});

/***/ }),

/***/ "tkC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobutton_vue__ = __webpack_require__("D971");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c45143_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobutton_vue__ = __webpack_require__("TsEe");
function injectStyle (ssrContext) {
  __webpack_require__("y7Xs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiobutton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c45143_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radiobutton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tu6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fieldset_vue__ = __webpack_require__("vr/w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5f7644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fieldset_vue__ = __webpack_require__("CH+I");
function injectStyle (ssrContext) {
  __webpack_require__("Z3Co")
  __webpack_require__("ZXpy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5f7644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fieldset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5f7644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fieldset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u96i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/galleria2.a396e3a.jpg";

/***/ }),

/***/ "uLqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui-colorpicker ui-widget', {
    'ui-colorpicker-overlay': !_vm.inline,
    'ui-colorpicker-dragging': _vm.colorDragging || _vm.hueDragging
  }]},[(!_vm.inline)?_c('input',{ref:"input",staticClass:"ui-colorpicker-preview ui-inputtext ui-state-default ui-corner-all",class:{'ui-state-disabled': _vm.disabled},style:({'background-color': _vm.inputBgColor}),attrs:{"type":"text","readonly":"","id":_vm.inputId,"tabindex":_vm.tabindex,"disabled":_vm.disabled},on:{"click":_vm.onInputClick,"keydown":function($event){_vm.onInputKeydown($event)}}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inline || _vm.panelVisible),expression:"inline || panelVisible"}],ref:"panel",class:['ui-colorpicker-panel ui-corner-all', {
          'ui-shadow': !_vm.inline,
          'ui-state-disabled': _vm.disabled
        }],style:({'position': _vm.inline ? '' : 'absolute'}),on:{"click":_vm.onPanelClick}},[_c('div',{staticClass:"ui-colorpicker-content"},[_c('div',{ref:"colorSelector",staticClass:"ui-colorpicker-color-selector",on:{"mousedown":function($event){_vm.onColorMousedown($event)}}},[_c('div',{staticClass:"ui-colorpicker-color"},[_c('div',{ref:"colorHandle",staticClass:"ui-colorpicker-color-handle"})])]),_vm._v(" "),_c('div',{ref:"hue",staticClass:"ui-colorpicker-hue",on:{"mousedown":function($event){_vm.onHueMousedown($event)}}},[_c('div',{ref:"hueHandle",staticClass:"ui-colorpicker-hue-handle"})])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uOqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"inputswitch",class:[_vm.inputswitchStyleClass, {'ui-inputswitch ui-widget ui-widget-content ui-corner-all': true,
          'ui-state-disabled': _vm.disabled,'ui-inputswitch-checked':_vm.checked, 'ui-state-focus':_vm.focused}],style:(_vm.inputswitchStyle),on:{"click":function($event){_vm.toggle($event)}}},[_c('div',{staticClass:"ui-inputswitch-off"},[_c('span',{staticClass:"ui-inputswitch-offlabel"},[_vm._v(_vm._s(_vm.offLabel))])]),_vm._v(" "),_c('div',{staticClass:"ui-inputswitch-on"},[_c('span',{staticClass:"ui-inputswitch-onlabel"},[_vm._v(_vm._s(_vm.onLabel))])]),_vm._v(" "),_c('div',{class:{'ui-inputswitch-handle ui-state-default':true, 'ui-state-focus':_vm.focused}}),_vm._v(" "),_c('div',{staticClass:"ui-helper-hidden-accessible"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],ref:"in",attrs:{"type":"checkbox","aria-label":_vm.ariaLabel,"aria-labelledby":_vm.ariaLabelledBy,"aria-live":"polite","id":_vm.inputId,"readonly":"readonly","tabindex":_vm.tabindex},domProps:{"checked":Array.isArray(_vm.newValue)?_vm._i(_vm.newValue,null)>-1:(_vm.newValue)},on:{"focus":function($event){_vm.onFocus($event)},"blur":function($event){_vm.onBlur($event)},"change":function($event){var $$a=_vm.newValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newValue=$$c}}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "udM/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Grid CSS")]),_vm._v(" "),_c('span',[_vm._v("Grid CSS is a lightweight responsive and fluid layout utility optimized for mobile devices, tablets and desktops. Grid CSS is used internally in VueFace components and can be used as standalone as well.")])])]),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('div',{staticClass:"content-section implementation GridDemo"},[_c('h3',{staticClass:"first"},[_vm._v("Basic")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-3"},[_vm._v("3")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-4"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-4"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-4"},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-6"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"ui-g-6"},[_vm._v("6")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12"},[_vm._v("12")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-4"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-8"},[_vm._v("8")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-9"},[_vm._v("9")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-5"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"ui-g-4"},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-4"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-2"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"ui-g-3"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-1"},[_vm._v("1")])]),_vm._v(" "),_c('h3',[_vm._v("Responsive")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-3"},[_vm._v("ui-g-12 ui-md-6 ui-lg-3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-3"},[_vm._v("ui-g-12 ui-md-6 ui-lg-3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-3"},[_vm._v("ui-g-12 ui-md-6 ui-lg-3")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-3"},[_vm._v("ui-g-12 ui-md-6 ui-lg-3")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-4"},[_vm._v("ui-g-12 ui-md-6 ui-lg-4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-6 ui-lg-4"},[_vm._v("ui-g-12 ui-md-6 ui-lg-4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-lg-4"},[_vm._v("ui-g-12 ui-lg-4")])]),_vm._v(" "),_c('h3',[_vm._v("Nested")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-8 ui-g-nopad"},[_c('div',{staticClass:"ui-g-6"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"ui-g-6"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12"},[_vm._v("12")])]),_vm._v(" "),_c('div',{staticClass:"ui-g-4"},[_vm._v("4")])]),_vm._v(" "),_c('h3',[_vm._v("Offset")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_vm._v("ui-g-12 ui-md-4")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4 ui-md-offset-4"},[_vm._v("ui-g-12 ui-md-4 ui-md-offset-4")])]),_vm._v(" "),_c('h3',[_vm._v("Sample Layout")]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-2"},[_vm._v("Menu")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-10 ui-g-nopad"},[_c('div',{staticClass:"ui-g-12"},[_vm._v("\n              Bar\n          ")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-g-nopad"},[_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-4"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed imperdiet, orci nec dictum convallis, ligula mauris vestibulum turpis, nec varius tortor quam at diam. Nullam a viverra nibh. In tincidunt tempor lectus quis vulputate. Pellentesque nec dui aliquam, lobortis est in, lobortis ante")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_vm._v("Maecenas vel nisi aliquet, vulputate tortor id, laoreet massa. Maecenas mattis tristique bibendum. Suspendisse vel mi dictum, vestibulum lacus quis, pulvinar quam. Proin vulputate, nibh at finibus varius, leo eros lacinia elit, nec blandit odio tellus a justo. Donec nec ex auctor, tristique nulla nec, rutrum sapien.")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-4"},[_vm._v("Proin efficitur in leo eget ornare. Nam vestibulum neque sed velit sagittis sodales. Sed scelerisque hendrerit magna a hendrerit. Cras tempor sem at justo pharetra convallis. Curabitur vel sodales purus. Vestibulum interdum facilisis nulla imperdiet suscipit. Quisque lectus felis, condimentum eget hendrerit sit amet.")])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-6 ui-md-3"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("VQhR")}})]),_vm._v(" "),_c('div',{staticClass:"ui-g-6 ui-md-3"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("u96i")}})]),_vm._v(" "),_c('div',{staticClass:"ui-g-6 ui-md-3"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("4cFB")}})]),_vm._v(" "),_c('div',{staticClass:"ui-g-6 ui-md-3"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("POpO")}})])]),_vm._v(" "),_c('div',{staticClass:"ui-g"},[_c('div',{staticClass:"ui-g-12 ui-md-6"},[_vm._v("Phasellus faucibus purus volutpat mauris lacinia sodales. Ut sit amet sapien facilisis, commodo dui non, fringilla tellus. Quisque tempus facilisis nisi sodales finibus. Pellentesque neque orci, ullamcorper vitae ligula quis, dignissim euismod augue.")]),_vm._v(" "),_c('div',{staticClass:"ui-g-12 ui-md-6"},[_vm._v("Fusce ullamcorper congue massa, eget ullamcorper nunc lobortis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ultrices dui eget dolor feugiat dapibus. Aliquam pretium leo et egestas luctus. Nunc facilisis gravida tellus.")])])])]),_vm._v(" "),_c('div',{staticClass:"ui-g-12"},[_vm._v("\n            Footer\n        ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v602":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gmap"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vIIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__ = __webpack_require__("Jzan");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-terminal',
  data: function data() {
    return {
      commands: [],
      command: null,
      container: null,
      commandProcessed: false
    };
  },
  props: {
    welcomeMessage: {
      type: String,
      default: null
    },
    prompt: {
      type: String,
      default: null
    },
    terminalStyle: {
      type: Object,
      default: null
    },
    terminalStyleClass: {
      type: String,
      default: null
    },
    response: {
      type: String,
      default: null
    }
  },
  methods: {
    handleCommand: function handleCommand(event) {
      if (event.keyCode === 13) {
        this.commands.push({ text: this.command });
        this.$emit('handler', { originalEvent: event, command: this.command });
        this.command = '';
      }
    },
    focus: function focus() {
      this.$refs.in.focus();
    }
  },
  mounted: function mounted() {
    this.container = __WEBPACK_IMPORTED_MODULE_0__dom_domhandler_js__["a" /* default */].find(this.$refs.terminal, '.ui-terminal');
  },
  updated: function updated() {
    if (this.commandProcessed) {
      this.container.scrollTop = this.container.scrollHeight;
      this.commandProcessed = false;
    }
  },
  watch: {
    response: function response(value) {
      if (value) {
        this.commands[this.commands.length - 1].response = value;
        this.commandProcessed = true;
      }
    }
  }
});

/***/ }),

/***/ "vJy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tristatecheckboxdemo_vue__ = __webpack_require__("T4AK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191989ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tristatecheckboxdemo_vue__ = __webpack_require__("L14D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tristatecheckboxdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191989ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tristatecheckboxdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vSE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'badgedemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "vUa0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("UQcL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988acb96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("6WBb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988acb96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vZp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badgedemo_vue__ = __webpack_require__("vSE1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc39074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badgedemo_vue__ = __webpack_require__("avq0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badgedemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc39074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badgedemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vdW/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vr/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var idx = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-fieldset',
  data: function data() {
    return {
      id: 'ui-fieldset-' + idx++,
      animating: false,
      collapsedStatus: false
    };
  },
  props: {
    toggleable: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    legend: {
      type: String,
      default: null
    },
    fieldsetStyle: {
      type: String,
      default: null
    },
    fieldsetStyleClass: {
      type: String,
      default: null
    }
  },
  methods: {
    toggle: function toggle(event) {
      if (this.animating) {
        return false;
      }

      this.animating = true;
      this.$emit('onBeforeToggle', { originalEvent: event, collapsed: this.collapsedStatus });

      if (this.collapsedStatus) {
        this.expand(event);
      } else {
        this.collapse(event);
      }

      this.$emit('onAfterToggle', { originalEvent: event, collapsed: this.collapsedStatus });
      event.preventDefault();
    },
    expand: function expand(event) {
      this.collapsedStatus = false;
    },
    collapse: function collapse(event) {
      this.collapsedStatus = true;
    },
    onToggleDone: function onToggleDone(event) {
      this.animating = false;
      this.$emit('onAfterToggle', { originalEvent: event, collapsed: this.collapsedStatus });
    }
  },
  mounted: function mounted() {
    this.collapsedStatus = this.collapsed;
  },
  computed: {}
});

/***/ }),

/***/ "vviW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbardemo',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "wRVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxdemo_vue__ = __webpack_require__("8vfT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c1454e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxdemo_vue__ = __webpack_require__("HIeo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxdemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c1454e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxdemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressbar_vue__ = __webpack_require__("WBXI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45a27b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressbar_vue__ = __webpack_require__("JUgJ");
function injectStyle (ssrContext) {
  __webpack_require__("/EmB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45a27b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wzqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue__ = __webpack_require__("bCLl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2c386e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charts_vue__ = __webpack_require__("xSgt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2c386e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xSgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chart"},[_c('canvas',{attrs:{"width":_vm.width,"height":_vm.height},on:{"click":function($event){_vm.onCanvasClick($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y4Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blockuidemo',
  data: function data() {
    return {
      blockedPanel: false,
      blockedDocument: false,
      target: 'pnl'
    };
  },

  methods: {
    blockDocument: function blockDocument() {
      var _this = this;

      this.blockedDocument = true;
      setTimeout(function () {
        _this.blockedDocument = false;
      }, 3000);
    },
    blockPanel: function blockPanel() {
      this.blockedPanel = true;
    },
    unblockPanel: function unblockPanel() {
      this.blockedPanel = false;
    }
  }
});

/***/ }),

/***/ "y7Xs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yE9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolbar_vue__ = __webpack_require__("XJZo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea872c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolbar_vue__ = __webpack_require__("zT5k");
function injectStyle (ssrContext) {
  __webpack_require__("XMfa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea872c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yZ23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputtextdemo',
  data: function data() {
    return {
      text: '20',
      disabled: true
    };
  },

  methods: {
    toggleDisabled: function toggleDisabled() {
      this.disabled = !this.disabled;
    }
  }
});

/***/ }),

/***/ "yg1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-accordion-header ui-state-default ui-corner-all",class:{'ui-state-active': _vm.selected,'ui-state-disabled':_vm.disabled}},[_c('a',{attrs:{"href":"#","id":_vm.id,"aria-controls":_vm.id + '-content',"role":"tab","aria-expanded":_vm.selected},on:{"click":function($event){_vm.toggle($event)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key," ")){ return null; }_vm.toggle($event)}}},[_c('span',{staticClass:"ui-accordion-toggle-icon fa fa-fw",class:{'fa-caret-down': _vm.selected, 'fa-caret-right': !_vm.selected}}),_vm._v(" "),(!_vm.hasHeaderFacet())?_c('span',{staticClass:"ui-accordion-header-text"},[_vm._v("\n                  "+_vm._s(_vm.header)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.hasHeaderFacet())?_vm._t("header"):_vm._e()],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"},on:{"enter":function($event){_vm.onToggleDone($event)},"leave":function($event){_vm.onToggleDone($event)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],staticClass:"ui-accordion-content-wrapper",class:{'ui-accordion-content-wrapper-overflown': !_vm.selected||_vm.animating},attrs:{"id":_vm.id + '-content',"role":"region","aria-hidden":!_vm.selected,"aria-labelledby":_vm.id}},[(_vm.getLazy() ? _vm.selected : true)?_c('div',{staticClass:"ui-accordion-content ui-widget-content"},[_vm._t("default")],2):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yjF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__ = __webpack_require__("jjfl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a9652a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("QmOc");
function injectStyle (ssrContext) {
  __webpack_require__("dmfF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a9652a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z63Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var doughnutData = {
  labels: ['VueJS', 'Angular', 'ReactJS'],
  datasets: [{
    data: [35, 35, 30],
    backgroundColor: ["#886384", "#12A2EB", "#FFCE56"],
    hoverBackgroundColor: ["#126384", "#CDA2EB", "#FFCE56"]
  }]
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'doughnutchartdemo',
  data: function data() {
    return {
      doughnutData: doughnutData
    };
  }
});

/***/ }),

/***/ "zAIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zT5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-toolbar ui-widget ui-widget-header ui-corner-all ui-helper-clearfix",class:_vm.toolbarStyleClass,style:(_vm.toolbarStyle)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zkdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordiondemo_vue__ = __webpack_require__("XlOP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d77fca00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordiondemo_vue__ = __webpack_require__("BezM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accordiondemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d77fca00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accordiondemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zoMH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vf-messages',
  data: function data() {
    return {};
  },
  props: {
    value: {
      type: Array,
      default: []
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasMessages: function hasMessages() {
      return this.value && this.value.length > 0;
    },
    getSeverityClass: function getSeverityClass() {
      return this.value[0].severity;
    },
    clear: function clear(event) {
      this.value = [];
      this.$emit('valueChange', this.value);

      event.preventDefault();
    },
    getIcon: function getIcon() {
      var icon = null;

      if (this.severity) {
        switch (this.severity) {
          case 'success':
            icon = 'fa fa-check';
            break;

          case 'info':
            icon = 'fa fa-info-circle';
            break;

          case 'error':
            icon = 'fa fa-close';
            break;

          case 'warn':
            icon = 'fa fa-warning';
            break;

          default:
            icon = 'fa fa-info-circle';
            break;
        }
      }

      return icon;
    },

    destroyed: function destroyed() {}
  }
});

/***/ }),

/***/ "zve5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"first"},[_vm._v("Different slots")]),_vm._v(" "),_c('vf-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n          Card header\n        ")]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":"https://placekitten.com/500/350"}})]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n          Card footer\n        ")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-section introduction",attrs:{"id":"component"}},[_c('div',[_c('span',{staticClass:"feature-title"},[_vm._v("Card")]),_vm._v(" "),_c('span',[_vm._v("Show information in a card container.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["Vcda"]);


// WEBPACK FOOTER //
// js/app.d6a6db7913d492b92d2f.js